import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef, ViewEncapsulation, AfterContentInit, OnDestroy, NgZone, Input, ComponentFactoryResolver, Renderer2, IterableDiffers } from '@angular/core';
import { Observable, empty, forkJoin, Subscription, combineLatest } from 'rxjs';
import { map, debounceTime, finalize, switchMap, tap, startWith, filter, mergeMap } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormsModule, NgForm, AbstractControl } from '@angular/forms';
import { MatRipple } from '@angular/material/core';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { ScheduleService } from '../../schedule/schedule.service';
import { RaterFormService } from '../../raterform/raterform.service'
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FileUploaderService } from '../../utils/photo-upload.service';
import { LoggingService } from '../../utils/logging.service';
import { GlobalEmailService } from '../../utils/globalemail.service';
import { AuthService } from '../../auth.service';
import { MatAutocomplete, MatCheckboxChange, MatChipInputEvent, MatRadioButton } from '@angular/material';
import { LocationService } from 'src/app/location/location.service';
import { FormControlService } from '../../multifamily/formfcontrol.service';
import { MultiFamilyService } from '../../multifamily/multifamily.service';
import * as piexif  from 'piexifjs';
import { WarningPopupComponent } from 'src/app/utils/warning-popup/warning-popup.component';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { isNumber } from 'util';
import { MatSnackBar } from '@angular/material';
import { CHECKLIST_ITEMS } from 'backend/utility/checklist.constant';
import { EmployeeService } from 'src/app/employee/employee.service';
import { CustomerService } from 'src/app/customers/customers.service';
import { environment } from 'src/environments/environment.prod';
import { HttpEventType } from '@angular/common/http';
import { ConifgService } from 'src/app/utils/config.service';
import { PhotoViewerDialogComponent } from '../photo-viewer-dialog.component';


@Component({
  selector: 'app-raterform-selector',
  templateUrl: './raterform-selector.component.html',
  styleUrls: ['./raterformselector.component.css'],
  encapsulation : ViewEncapsulation.None
})
export class RaterformSelectorComponent implements OnInit, OnDestroy {


  constructor(private dialogRef: MatDialogRef<RaterformSelectorComponent>, private fb: FormBuilder,  public scheduleService: ScheduleService, public raterFormService: RaterFormService, private messager: MessagerComponent, @Inject(MAT_DIALOG_DATA) public data: any, public log: LoggingService, public ges: GlobalEmailService) { }


  ngOnInit(): void {
    this.usernamee = this.data.usernamee;
  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }


  user;
  usernamee;
  initials;
  jobs = this.data.Jobs;
  fid = this.data.form_id;

  selectedJob = 0; //formID of selected job
  selectedjobid = 0; //job id of selectedjob
  private subscriptions = new Subscription();


  cvopen;
  cvclose;
  cvna;



  async loadData(formid, job) {
    this.selectedJob = formid;
    this.selectedjobid = job.job_id;

    //get id of locpics with job_id
    const getpics = await this.raterFormService.getIDlocpicsByJobID(job.job_id).toPromise();

    var locpicsObj = {
      form_id : this.selectedJob,
      locpics_id : getpics.id,
      clear : false
    }

    this.raterFormService.updateLocmainFormAndPics(this.data.location_id, locpicsObj).subscribe(
      res => {
        if(res.Error){
          this.messager.openSnackBar('Error loading data', '', 'warningAlert');
        }else {

          this.messager.openSnackBar('Successfully loaded data! Close this window and re-open the form.', '', 'successAlert')
          this.dialogRef.close(locpicsObj);
                  }
      }, err => {
        this.messager.openSnackBar('Error loading data', '', 'warningAlert');
      }
    )

  }


  blankForm(formid): void {

    this.log.info(this.usernamee + ' attempted to clear form with id: ' + formid );

    //make the data blank for this form, which essentially means pointing ids to null values
    var locpicsObj = {
      form_id : null,
      locpics_id : null,
      clear : true
    }

    this.raterFormService.updateLocmainFormAndPics(this.data.location_id, locpicsObj).subscribe(
      res => {
        if(res.Error){
          this.messager.openSnackBar('Error loading data', '', 'warningAlert');
        }else {

          this.messager.openSnackBar('Successfully cleared form. Close this window and re-open the form.', '', 'successAlert')
          this.dialogRef.close(locpicsObj);
                  }
      }, err => {
        this.messager.openSnackBar('Error loading data', '', 'warningAlert');
      }
    )
    
    
    /*
    this.subscriptions.add(this.raterFormService.rfloadBlankData(formid).subscribe(
      res=>{
        //this.messager.openSnackBar('Error making form blank (form issue):', '', 'warningAlert');
        this.subscriptions.add(this.raterFormService.blankPics(this.data.job_id).subscribe(
          res => {
            this.log.info(this.usernamee + ' successfully cleared form: ' + formid );
            this.messager.openSnackBar('Current form is now blank.', '', 'successAlert');
          }, err => {
            this.log.error(this.usernamee + ' experienced an error clearing form: ' + formid + 'Error: ' + err  );

            this.messager.openSnackBar('Error making form blank (photo issue): ' + err, '', 'warningAlert');
          }))
      }, err => {
        this.messager.openSnackBar('Error making form blank: ' + err, '', 'warningAlert');
      }));
    */

  }

}




@Component({
  selector: 'app-warningmodal-selector',
  templateUrl: '../warningmodal.component.html',
  styleUrls: ['./raterform.component.css']
})

export class WarningModalComponent implements OnInit {


  constructor(private fb: FormBuilder, public scheduleService: ScheduleService, public raterFormService: RaterFormService, private messager: MessagerComponent, @Inject(MAT_DIALOG_DATA) public data: any, public log: LoggingService, public ges: GlobalEmailService) { }

  ngOnInit(): void {

  }

  //warning = this.data;
  lines = this.data.split('\n');


}


export interface dropdownObj {
  value: string;
  viewValue: string;
}

export interface checklistItem {
  field: string,
  description: string,
  value: string,
  stage: number
}

export interface hvacGradeItem {
  name: string
  volts: number | null,
  amps: number | null,
  watts: number | null,
  calcAirflowGrade: string | null,
  syslocs: [],
  linesetPhoto: string | null,
  linesetLength: number | null,
  chargedev: number | null,
  liquidLineDiameter: number | null,
  prechargedDistance: number | null,
  refrigerantNeeded : number | null,
  airflowtestmode : string | null,
  tonnage : number   | null,
  manualcalc: boolean | false,
  manualdesign: number | null,
  cfmPerTon: number | null,
  voltsPhoto: string | null,
  ampsPhoto: string | null,
  airflowReport: string | null

}

export function createDefaultHvacGradeItem(name?: string): hvacGradeItem {
  return {
    name: name || '',
    volts: null,
    amps: null,
    watts: null,
    calcAirflowGrade: null,
    syslocs: [],
    linesetPhoto: null,
    linesetLength: null,
    chargedev: null,
    liquidLineDiameter: null,
    prechargedDistance: null,
    refrigerantNeeded: null,
    airflowtestmode : null,
    tonnage : null,
    manualcalc: false,
    manualdesign: null,
    cfmPerTon: 400,
    voltsPhoto: null,
    ampsPhoto: null,
    airflowReport: null
  };
}



  interface CurrentUpload {
    active: boolean;
    field: string | null;
    percent: number;
  }

@Component({
  selector: 'app-raterform',
  templateUrl: './raterform.component.html',
  styleUrls: ['./raterform.component.css']
})


export class RaterformComponent implements OnInit, AfterContentInit, OnDestroy {



  currentUpload: CurrentUpload = {
    active: false,
    field: null,
    percent: 0
  };
  activeUploadingField: string | null = null;


  multifamilyData: any;
  multifamilyLoaded: boolean;
  testSpecs: any;
  envSpecs: any;
  hvacSpecs: any;
  stickerPlacementInfo: any;
  showtestSpecs: boolean = false;
  showenvSpecs: boolean = false;
  showHvacSpecs: boolean = false;
  showStickerPlacementInfo: boolean = false;
  // Subdivision-level sticker note, shown under the customer-job sticker placement info.
  stickerLocation: string = '';
  showStickerLocation: boolean = false;
  // Subdivision-level envelope specs, shown under the customer-job envelope specs.
  subdivisionEnvSpecs: string = '';
  showSubdivisionEnvSpecs: boolean = false;
  selectedIndexMF: any;
  mfinspectionType: number = 0;
  isESMFNC: boolean;
  photoObj: any[];

  initialValue: any;
  isHers: boolean = false;
  systemNo: number = 1;

  tonnageTable = [
    { "tonnage": 1, "lowerbound": 340, "upperbound": 460 },
    { "tonnage": 1.5, "lowerbound": 510, "upperbound": 690 },
    { "tonnage": 2, "lowerbound": 680, "upperbound": 920 },
    { "tonnage": 2.5, "lowerbound": 850, "upperbound": 1150 },
    { "tonnage": 3, "lowerbound": 1020, "upperbound": 1380 },
    { "tonnage": 3.5, "lowerbound": 1190, "upperbound": 1610 },
    { "tonnage": 4, "lowerbound": 1360, "upperbound": 1840 },
    { "tonnage": 4.5, "lowerbound": 1530, "upperbound": 2070 },
    { "tonnage": 5, "lowerbound": 1700, "upperbound": 2300 },
    { "tonnage": 5.5, "lowerbound": 1870, "upperbound": 2530 },
    { "tonnage": 6, "lowerbound": 2040, "upperbound": 2760 }
  ];

  manualUpperBound: number | null = null;
  manualLowerBound: number | null = null;
  wattscfm: number | null = null;
  curr_sys_grading_stagedone: string = '' ;
  leakageTarget: number | null = null;
  subdivisionCZ: string;
  locpics_id: number;
  currDeletePhotoUrl: string
  currDeletePhotoUrlMF: string
  // NOTE: ids reflect the ESMFNC Checklist Update renumbers in backend/migrations.sql
  // (item1_4 moved 4->23; ids 149-173 shifted +1 to insert the new 7.6 at id 149).
  // 164/165/166 = 10.1/10.2/10.3 removed per the checklist update.
  mfHiddenFields : number[] = [
   5, 6, 7, 8, 9, 10, 11, 21, 22, 23, 42, 43, 44, 45, 56, 57, 58, 59, 61, 121, 122, 123, 124, 125, 126, 127, 128, 133, 138, 139, 140, 141, 144,
   153, 160, 161, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187
  ]
  consultant: string = "";
  consultantPhone: string = "";
  labeledSystems: string[] = [];
  heightdisabledtext: boolean = false;
  isEnergyStar: boolean = false;
  targetset: string;
  adminNotesText: string;
  uploadProgress: { [key: string]: number } = {};
  uploadErrors: { [key: string]: string } = {};
  rangeText: string;
  selfiepics: string[] = [];
  phoneNumberText: string;
  



viewDataModal() {
throw new Error('Method not implemented.');
}
  presetArray: any[];
  viewHomePresets: boolean;
  reviewMode: boolean;
  ventWarning;
  formFields;
  mfSelected: boolean = false;

  @ViewChild('dhw2') dhw2: ElementRef;
  mfFields: any;

  notesText: any;
  numOfWarnings: number = 0;
  @Input() isWarning1: boolean = false;
  @Input() isWarning2: boolean = false;
  @Input() isWarning3: boolean = false;
  @Input() isWarning4: boolean = false;
  @Input() isWarning: boolean = false;

  @ViewChild('elevationRipple', { read: MatRipple }) elevationRipple: MatRipple;
  @ViewChild('baselineRipple', { read: MatRipple }) baselineRipple: MatRipple;
  @ViewChild('tempinRipple', { read: MatRipple }) tempinRipple: MatRipple;
  @ViewChild('tempoutRipple', { read: MatRipple }) tempoutRipple: MatRipple;
  @ViewChild('cvna', { read: false, static: false})cvnaRef: MatRadioButton;

  constructor(private el: ElementRef, private renderer: Renderer2, private dialog: MatDialog,  private fcs: FormControlService, private dialogRef: MatDialogRef<RaterformComponent>, private ngZone: NgZone, public auth: AuthService, private configs: ConifgService, private locservice: LocationService, private fb: FormBuilder, private cdr: ChangeDetectorRef, public log: LoggingService, public customerservice: CustomerService, public ges: GlobalEmailService, public scheduleService: ScheduleService, public raterFormService: RaterFormService, private messager: MessagerComponent, @Inject(MAT_DIALOG_DATA) public data: any, public fileUploaderService: FileUploaderService, public multifamilyservice: MultiFamilyService, public snackbar: MatSnackBar, public employeeService: EmployeeService) {}





    ngAfterContentInit() : void {
    //do Nothing.


    this.volume = (   this.hvac_1_area * this.hvac1_ceil_ht) + (this.hvac_2_area * this.hvac2_ceil_ht) + (this.hvac_3_area * this.hvac3_ceil_ht) + (this.hvac_4_area * this.hvac4_ceil_ht)  + (  (    parseFloat(this.raterform.get('hvac1_option1_sf').value) + parseFloat(this.raterform.get('hvac1_option2_sf').value) ) * ( parseFloat(this.raterform.get('hvac1_optceilheight').value))  )  + (  (    parseFloat(this.raterform.get('hvac2_option1_sf').value) + parseFloat(this.raterform.get('hvac2_option2_sf').value)  ) * (   parseFloat(this.raterform.get('hvac2_optceilheight').value) ) ) + (  parseFloat(this.raterform.get('hvac3_option_sf').value) * parseFloat(this.raterform.get('hvac3_optceilheight').value) ) + ( parseFloat(this.raterform.get('hvac4_option1_sf').value) * parseFloat(this.raterform.get('hvac4_optceilheight').value) ) + parseFloat(this.addvol.toString());

  }



  //stringData = JSON.stringify(this.data);

  canvas = document.createElement("canvas");
  image = document.createElement("img");
  private subscriptions = new Subscription();
  highImage = false;
  form_id = this.data.formData.form_id;
  selectedItem = 0;
  selectedIndex = 0;
  checklistClasses = [];
  checklist = []; //checklist
  facamera = faCamera;
  fainfo = faInfo;
  class = '';
  initClass = '';
  selectedChecklistItem;
  selectedMFChecklistItem;
  inspectionType = 0;
  checklistNotes = '';
  job_id = this.data.job_id;
  location_id = this.data.location_id;
  // When the form is opened from the locations page (office review/viewing) we suppress the
  // automatic "send back to builder" reset that fires on Close. The locations page already has
  // an explicit "Reset Builder TEC" button for this, and opening/closing a form that already has
  // a 'Must Correct' item was re-resetting the builder portal with no actual change.
  fromLocations = this.data.fromLocations || false;
  elev_left = '';
  elev_right = '';
  elev_front = '';
  elev_back = '';
  subdivision_name = '';
  street_address = '';
  lot = '';
  locationTxt = '';
  customerjob = '';
  weatherlocation = '';
  jobscope = '';
  compliance = '';
  raternotesummary = '';
  predrywallnotesSummary = ''; //pdw notes
  finalnotesSummary = ''; //final notes
  volume = 0;
  raterNotePresets = [];
  isFinal = false;//final job type
  isPDWI = false; //pdw job type
  faExclamationCircle = faExclamationCircle;
  formSubcription;

  isHorizontal = false;
  toggleLabel = 'Horizontal';
  currRefchecked;


  hvac_1_area = 0;
  hvac_2_area = 0;
  hvac_3_area = 0;
  hvac_4_area = 0;
  hvac1_ceil_ht = 0;
  hvac2_ceil_ht = 0;
  hvac3_ceil_ht = 0;
  hvac4_ceil_ht = 0;
  hvac1_option1_sf = 0;
  hvac2_option1_sf = 0;
  hvac3_option_sf = 0;
  hvac4_option1_sf = 0;
  hvac1_option2_sf = 0;
  hvac2_option2_sf = 0;
  hvac1_optceilheight = 0;
  hvac2_optceilheight = 0;
  hvac3_optceilheight = 0;
  hvac4_optceilheight = 0;
  sfbe = 0;


  bedrooms = 0;
  bathrooms = 0;
  plan_name = '';
  plan_notes = '';
  addvol = 0;
  ashrae = 0;
  elr = 0;

  ventlationInRange;

  ach50 = '';
  sys1notes = '';
  sys2notes = '';
  sys3notes = '';
  sys4notes = '';
  bdnotes = '';
  totalMustCorrect : number = 0;
  //this object gets sent to photo upload function.
  photos = {};

  mfChecklistItems : any[] = [];
  mfChecklistID = 0;
  currentphotoobjects : string[] = [];
  currentMFphotoobjects : string[] = [];

  // Multi-photo arrays for non-checklist fields
  loflowafxPhotos: string[] = [];
  currDeletePhotoUrlLoflow: string = '';
  ventCtrlPhotos: string[] = [];
  currDeletePhotoUrlVentCtrl: string = '';
  esCeilingFansPhotos: string[] = [];
  currDeletePhotoUrlEsCeilingFans: string = '';
  esCeilingFansLegacyPic: string = '';
  allOtrCeilingsPhotos: string[] = [];
  currDeletePhotoUrlAllOtrCeilings: string = '';
  allOtrCeilingsLegacyPic: string = '';


  
  //{ field: 'measvent', description: '7.1 Rater-measured ventilation rate is within either ± 15 CFM or ±15% of design value (2.3)', value: '', stage: 2, photo: '', note: '' },
  //{ field: 'modelNumbers', description: '5.1 HVAC manufacturer & model number on installed equipment matches either of the following', value: '', stage: 0, photo: '', note: '' },

  checklistItems = CHECKLIST_ITEMS;

  checklistItemsFields = this.checklistItems.map((item)=> item.field)

  //Hvac Grade properties

  //properties for location inputs
  locationName: string;
  airFlow: number;


  sys1grade: hvacGradeItem = createDefaultHvacGradeItem('Whole House');
  sys2grade: hvacGradeItem = createDefaultHvacGradeItem();
  sys3grade: hvacGradeItem = createDefaultHvacGradeItem();
  sys4grade: hvacGradeItem = createDefaultHvacGradeItem();
  currentGrade: hvacGradeItem = this.sys1grade;


  ductlocations: dropdownObj[] = [
    { value: '', viewValue: '' },
    { value: 'Conditioned Attic', viewValue: 'Conditioned Attic' },
    { value: 'Conditioned Crawl', viewValue: 'Conditioned Crawl' },
    { value: 'Conditioned Space', viewValue: 'Conditioned Space' },
    { value: 'Garage', viewValue: 'Garage' },
    { value: 'Unconditioned Attic', viewValue: 'Unconditioned Attic' },
    { value: 'Unconditioned Basement', viewValue: 'Unconditioned Basement' },
    { value: 'Vented Crawl', viewValue: 'Vented Crawl' },
  ];


  ahlocations: dropdownObj[] = [
    { value: 'Ambient', viewValue: 'Ambient' },
    { value: 'Conditioned Attic', viewValue: 'Conditioned Attic' },
    { value: 'Conditioned Crawl', viewValue: 'Conditioned Crawl' },
    { value: 'Conditioned Space', viewValue: 'Conditioned Space' },
    { value: 'Garage', viewValue: 'Garage' },
    { value: 'Unconditioned Attic', viewValue: 'Unconditioned Attic' },
    { value: 'Unconditioned Basement', viewValue: 'Unconditioned Basement' },
    { value: 'Vented Crawl', viewValue: 'Vented Crawl' },
  ];


  ahlocations2: dropdownObj[] = [
    { value: 'Ambient', viewValue: 'Ambient' },
    { value: 'Conditioned Attic', viewValue: 'Conditioned Attic' },
    { value: 'Conditioned Crawl', viewValue: 'Conditioned Crawl' },
    { value: 'Conditioned Space', viewValue: 'Conditioned Space' },
    { value: 'Garage', viewValue: 'Garage' },
    { value: 'Unconditioned Attic', viewValue: 'Unconditioned Attic' },
    { value: 'Unconditioned Basement', viewValue: 'Unconditioned Basement' },
    { value: 'Vented Crawl', viewValue: 'Vented Crawl' },
  ];

  ductpercentages: dropdownObj[] = [
    { value: '', viewValue: '' },
    { value: '10', viewValue: '10%' },
    { value: '20', viewValue: '20%' },
    { value: '30', viewValue: '30%' },
    { value: '40', viewValue: '40%' },
    { value: '50', viewValue: '50%' },
    { value: '60', viewValue: '60%' },
    { value: '70', viewValue: '70%' },
    { value: '80', viewValue: '80%' },
    { value: '90', viewValue: '90%' },
    { value: '100', viewValue: '100%' }
  ];



  trades = [
    'Framer',
    'Painter',
    'Insulator',
    'Siding Contractor',
    'HVAC Contractor',
    'Door/Trim',
    'Builder',
    'Plumber',
    'Electrician'
  ];

  selectedTrades = "";

  raterform = new FormGroup({
    checklistNotes: new FormControl(this.checklistNotes),
    ahri_1: new FormControl(typeof this.data.formData.ahri_1 === 'undefined' ? '' : this.data.formData.ahri_1 || ''),
    ahri_2: new FormControl(typeof this.data.formData.ahri_2 === 'undefined' ? '' : this.data.formData.ahri_2 || ''),
    ahri_3: new FormControl(typeof this.data.formData.ahri_3 === 'undefined' ? '' : this.data.formData.ahri_3 || ''),
    ahri_4: new FormControl(typeof this.data.formData.ahri_4 === 'undefined' ? '' : this.data.formData.ahri_4 || ''),
    unventcomb: new FormControl(typeof this.data.formData.unventcomb === 'undefined' ? '' : this.data.formData.unventcomb || ''),
    ecmicmfan: new FormControl(typeof this.data.formData.ecmicmfan === 'undefined' ? '' : this.data.formData.ecmicmfan || ''),
    cathedral: new FormControl(typeof this.data.formData.cathedral === 'undefined' ? '' : this.data.formData.cathedral || ''),
    conv_oven: new FormControl(typeof this.data.formData.conv_oven === 'undefined' ? '' : this.data.formData.conv_oven || ''),
    ind_range: new FormControl(typeof this.data.formData.ind_range === 'undefined' ? '' : this.data.formData.ind_range || ''),
    measvent: new FormControl(typeof this.data.formData.measvent === 'undefined' ? '' : this.data.formData.measvent || ''),
    notutilize: new FormControl(typeof this.data.formData.notutilize === 'undefined' ? '' : this.data.formData.notutilize || ''),
    fenlevels: new FormControl(typeof this.data.formData.fenlevels === 'undefined' ? '' : this.data.formData.fenlevels || ''),
    insmeets: new FormControl(typeof this.data.formData.insmeets === 'undefined' ? '' : this.data.formData.insmeets || ''),
    insachieve: new FormControl(typeof this.data.formData.insachieve === 'undefined' ? '' : this.data.formData.insachieve || ''),
    modelNumbers: new FormControl(typeof this.data.formData.modelNumbers === 'undefined' ? '' : this.data.formData.modelNumbers || ''),
    leakageotdr: new FormControl(typeof this.data.formData.leakageotdr === 'undefined' ? '' : this.data.formData.leakageotdr || ''),
    returnside: new FormControl(typeof this.data.formData.returnside === 'undefined' ? '' : this.data.formData.returnside || ''),
    rsesp1: new FormControl(typeof this.data.formData.rsesp1 === 'undefined' ? 0 : this.data.formData.rsesp1 || 0),
    rsesp2: new FormControl(typeof this.data.formData.rsesp2 === 'undefined' ? 0 : this.data.formData.rsesp2 || 0),
    rsesp3: new FormControl(typeof this.data.formData.rsesp3 === 'undefined' ? 0 : this.data.formData.rsesp3 || 0),
    rsesp4: new FormControl(typeof this.data.formData.rsesp4 === 'undefined' ? 0 : this.data.formData.rsesp4 || 0),
    ssesp1: new FormControl(typeof this.data.formData.ssesp1 === 'undefined' ? 0 : this.data.formData.ssesp1 || 0),
    ssesp2: new FormControl(typeof this.data.formData.ssesp2 === 'undefined' ? 0 : this.data.formData.ssesp2 || 0),
    ssesp3: new FormControl(typeof this.data.formData.ssesp3 === 'undefined' ? 0 : this.data.formData.ssesp3 || 0),
    ssesp4: new FormControl(typeof this.data.formData.ssesp4 === 'undefined' ? 0 : this.data.formData.ssesp4 || 0),
    orientation: new FormControl(typeof this.data.formData.orientation === 'undefined' ? '' : this.data.formData.orientation || ''),
    performancepath: new FormControl(typeof this.data.formData.performancepath === 'undefined' ? '' : this.data.formData.performancepath || ''),
    rater_notes: new FormControl(typeof this.data.formData.rater_notes === 'undefined' ? '' : this.data.formData.rater_notes || ''),
    taxparcel: new FormControl(typeof this.data.formData.taxparcel === 'undefined' ? '' : this.data.formData.taxparcel || ''),
    warranynotes: new FormControl(typeof this.data.formData.warranynotes === 'undefined' ? '' : this.data.formData.warranynotes || ''),
    predrywallnotes4builder: new FormControl(typeof this.data.formData.predrywallnotes4builder === 'undefined' ? '' : this.data.formData.predrywallnotes4builder || ''),
    radiantbarrier: new FormControl(typeof this.data.formData.radiantbarrier === 'undefined' ? '' : this.data.formData.radiantbarrier || ''),
    foamwalls: new FormControl(typeof this.data.formData.foamwalls === 'undefined' ? '' : this.data.formData.foamwalls || ''),
    foamceilings: new FormControl(typeof this.data.formData.foamceilings === 'undefined' ? '' : this.data.formData.foamceilings || ''),
    window_u: new FormControl(typeof this.data.formData.window_u === 'undefined' ? 0 : this.data.formData.window_u || 0),
    window_shgc: new FormControl(typeof this.data.formData.window_shgc === 'undefined' ? 0 : this.data.formData.window_shgc || 0),
    glass_door_u: new FormControl(typeof this.data.formData.glass_door_u === 'undefined' ? 0 : this.data.formData.glass_door_u || 0),
    glass_door_shgc: new FormControl(typeof this.data.formData.glass_door_shgc === 'undefined' ? 0 : this.data.formData.glass_door_shgc || 0),
    solid_door_u: new FormControl(typeof this.data.formData.solid_door_u === 'undefined' ? 0 : this.data.formData.solid_door_u || 0),
    agw: new FormControl(typeof this.data.formData.agw === 'undefined' ? '' : this.data.formData.agw || ''),
    band: new FormControl(typeof this.data.formData.band === 'undefined' ? '' : this.data.formData.band || ''),
    floor_above_garage: new FormControl(typeof this.data.formData.floor_above_garage === 'undefined' ? '' : this.data.formData.floor_above_garage || ''),
    cantilever_floor: new FormControl(typeof this.data.formData.cantilever_floor === 'undefined' ? '' : this.data.formData.cantilever_floor || ''),
    woodmc: new FormControl(typeof this.data.formData.woodmc === 'undefined' ? 0 : this.data.formData.woodmc || 0),
    finalnotes4builder: new FormControl(typeof this.data.formData.finalnotes4builder === 'undefined' ? '' : this.data.formData.finalnotes4builder || ''),
    allverifiedreported: new FormControl(typeof this.data.formData.allverifiedreported === 'undefined' ? '' : this.data.formData.allverifiedreported || ''),
    _cfl: new FormControl(typeof this.data.formData._cfl === 'undefined' ? 0 : this.data.formData._cfl || 0),
    _pin_based: new FormControl(typeof this.data.formData._pin_based === 'undefined' ? 0 : this.data.formData._pin_based || 0),
    ext_cfl: new FormControl(typeof this.data.formData.ext_cfl === 'undefined' ? 0 : this.data.formData.ext_cfl || 0),
    gar_cfl: new FormControl(typeof this.data.formData.gar_cfl === 'undefined' ? 0 : this.data.formData.gar_cfl || 0),
    ven_mn: new FormControl(typeof this.data.formData.ven_mn === 'undefined' ? '' : this.data.formData.ven_mn || ''),
    refrigerator_mn: new FormControl(typeof this.data.formData.refrigerator_mn === 'undefined' ? '' : this.data.formData.refrigerator_mn || ''),
    dishwasher_mn: new FormControl(typeof this.data.formData.dishwasher_mn === 'undefined' ? '' : this.data.formData.dishwasher_mn || ''),
    washerdryermodnum: new FormControl(typeof this.data.formData.washerdryermodnum === 'undefined' ? '' : this.data.formData.washerdryermodnum || ''),
    oventype: new FormControl(typeof this.data.formData.oventype === 'undefined' ? '' : this.data.formData.oventype || ''),
    close_dryer_fuel: new FormControl(typeof this.data.formData.close_dryer_fuel === 'undefined' ? '' : this.data.formData.close_dryer_fuel || ''),
    rangefueltype: new FormControl(typeof this.data.formData.rangefueltype === 'undefined' ? '' : this.data.formData.rangefueltype || ''),
    es_ceiling_fans: new FormControl(typeof this.data.formData.es_ceiling_fans === 'undefined' ? 0 : this.data.formData.es_ceiling_fans || 0),
    programstat1: new FormControl(typeof this.data.formData.programstat1 === 'undefined' ? '' : this.data.formData.programstat1 || ''),
    hvac1_zones: new FormControl(typeof this.data.formData.hvac1_zones === 'undefined' ? 0 : this.data.formData.hvac1_zones || 0),
    heat1fuel: new FormControl(typeof this.data.formData.heat1fuel === 'undefined' ? '' : this.data.formData.heat1fuel || ''),
    hvac_1_mfr: new FormControl(typeof this.data.formData.hvac_1_mfr === 'undefined' ? '' : this.data.formData.hvac_1_mfr || ''),
    e_coil_1_mn: new FormControl(typeof this.data.formData.e_coil_1_mn === 'undefined' ? '' : this.data.formData.e_coil_1_mn || ''),
    c_coil_1_mn: new FormControl(typeof this.data.formData.c_coil_1_mn === 'undefined' ? '' : this.data.formData.c_coil_1_mn || ''),
    ahu_furn_1_mn: new FormControl(typeof this.data.formData.ahu_furn_1_mn === 'undefined' ? '' : this.data.formData.ahu_furn_1_mn || ''),
    syst1_supret: new FormControl(typeof this.data.formData.syst1_supret === 'undefined' ? '' : this.data.formData.syst1_supret || ''),
    programstat2: new FormControl(typeof this.data.formData.programstat2 === 'undefined' ? '' : this.data.formData.programstat2 || ''),
    hvac2_zones: new FormControl(typeof this.data.formData.hvac2_zones === 'undefined' ? 0 : this.data.formData.hvac2_zones || 0),
    heat2fuel: new FormControl(typeof this.data.formData.heat2fuel === 'undefined' ? '' : this.data.formData.heat2fuel || ''),
    hvac_2_mfr: new FormControl(typeof this.data.formData.hvac_2_mfr === 'undefined' ? '' : this.data.formData.hvac_2_mfr || ''),
    e_coil_2_mn: new FormControl(typeof this.data.formData.e_coil_2_mn === 'undefined' ? '' : this.data.formData.e_coil_2_mn || ''),
    c_coil_2_mn: new FormControl(typeof this.data.formData.c_coil_2_mn === 'undefined' ? '' : this.data.formData.c_coil_2_mn || ''),
    ahu_furn_2_mn: new FormControl(typeof this.data.formData.ahu_furn_2_mn === 'undefined' ? '' : this.data.formData.ahu_furn_2_mn || ''),
    syst2_supret: new FormControl(typeof this.data.formData.syst2_supret === 'undefined' ? '' : this.data.formData.syst2_supret || ''),
    programstat3: new FormControl(typeof this.data.formData.programstat3 === 'undefined' ? '' : this.data.formData.programstat3 || ''),
    hvac3_zones: new FormControl(typeof this.data.formData.hvac3_zones === 'undefined' ? 0 : this.data.formData.hvac3_zones || 0),
    heat3fuel: new FormControl(typeof this.data.formData.heat3fuel === 'undefined' ? '' : this.data.formData.heat3fuel || ''),
    hvac_3_mfr: new FormControl(typeof this.data.formData.hvac_3_mfr === 'undefined' ? '' : this.data.formData.hvac_3_mfr || ''),
    e_coil_3_mn: new FormControl(typeof this.data.formData.e_coil_3_mn === 'undefined' ? '' : this.data.formData.e_coil_3_mn || ''),
    c_coil_3_mn: new FormControl(typeof this.data.formData.c_coil_3_mn === 'undefined' ? '' : this.data.formData.c_coil_3_mn || ''),
    ahu_furn_3_mn: new FormControl(typeof this.data.formData.ahu_furn_3_mn === 'undefined' ? '' : this.data.formData.ahu_furn_3_mn || ''),
    syst3_supret: new FormControl(typeof this.data.formData.syst3_supret === 'undefined' ? '' : this.data.formData.syst3_supret || ''),
    programstat4: new FormControl(typeof this.data.formData.programstat4 === 'undefined' ? '' : this.data.formData.programstat4 || ''),
    hvac4_zones: new FormControl(typeof this.data.formData.hvac4_zones === 'undefined' ? 0 : this.data.formData.hvac4_zones || 0),
    heat4fuel: new FormControl(typeof this.data.formData.heat4fuel === 'undefined' ? '' : this.data.formData.heat4fuel || ''),
    hvac_4_mfr: new FormControl(typeof this.data.formData.hvac_4_mfr === 'undefined' ? '' : this.data.formData.hvac_4_mfr || ''),
    e_coil_4_mn: new FormControl(typeof this.data.formData.e_coil_4_mn === 'undefined' ? '' : this.data.formData.e_coil_4_mn || ''),
    c_coil_4_mn: new FormControl(typeof this.data.formData.c_coil_4_mn === 'undefined' ? '' : this.data.formData.c_coil_4_mn || ''),
    ahu_furn_4_mn: new FormControl(typeof this.data.formData.ahu_furn_4_mn === 'undefined' ? '' : this.data.formData.ahu_furn_4_mn || ''),
    syst4_supret: new FormControl(typeof this.data.formData.syst4_supret === 'undefined' ? '' : this.data.formData.syst4_supret || ''),
    dhw1fuel: new FormControl(typeof this.data.formData.dhw1fuel === 'undefined' ? '' : this.data.formData.dhw1fuel || ''),
    dhw_1_location: new FormControl(typeof this.data.formData.dhw_1_location === 'undefined' ? '' : this.data.formData.dhw_1_location || ''),
    dhw_1_mfr: new FormControl(typeof this.data.formData.dhw_1_mfr === 'undefined' ? '' : this.data.formData.dhw_1_mfr || ''),
    dhw_1_mn: new FormControl(typeof this.data.formData.dhw_1_mn === 'undefined' ? '' : this.data.formData.dhw_1_mn || ''),
    dhw2fuel: new FormControl(typeof this.data.formData.dhw2fuel === 'undefined' ? '' : this.data.formData.dhw2fuel || ''),
    dhw_2_location: new FormControl(typeof this.data.formData.dhw_2_location === 'undefined' ? '' : this.data.formData.dhw_2_location || ''),
    dhw_2_mfr: new FormControl(typeof this.data.formData.dhw_2_mfr === 'undefined' ? '' : this.data.formData.dhw_2_mfr || ''),
    dhw_2_mn: new FormControl(typeof this.data.formData.dhw_2_mn === 'undefined' ? '' : this.data.formData.dhw_2_mn || ''),
    blower_door: new FormControl(typeof this.data.formData.blower_door === 'undefined' ? 0 : this.data.formData.blower_door || 0),
    ach50: new FormControl(typeof this.data.formData.ach50 === 'undefined' ? 0 : this.data.formData.ach50 || 0),
    mechanical_ventilation: new FormControl(typeof this.data.formData.mechanical_ventilation === 'undefined' ? '' : this.data.formData.mechanical_ventilation || ''),
    vent_rate_total: new FormControl(typeof this.data.formData.vent_rate_total === 'undefined' ? 0 : this.data.formData.vent_rate_total || 0),
    hvac1name: new FormControl(typeof this.data.formData.hvac1name === 'undefined' ? '' : this.data.formData.hvac1name || ''),
    duct_system_1_location: new FormControl(typeof this.data.formData.duct_system_1_location === 'undefined' ? '' : this.data.formData.duct_system_1_location || ''),
    ahu_1_location: new FormControl(typeof this.data.formData.ahu_1_location === 'undefined' ? '' : this.data.formData.ahu_1_location || ''),
    db1_total: new FormControl(typeof this.data.formData.db1_total === 'undefined' ? 0 : this.data.formData.db1_total || 0),
    db1_ext: new FormControl(typeof this.data.formData.db1_ext === 'undefined' ? 0 : this.data.formData.db1_ext || 0),
    hvac1totpcnt: new FormControl(typeof this.data.formData.hvac1totpcnt === 'undefined' ? 0 : this.data.formData.hvac1totpcnt || 0 ),
    hvac1extpcnt: new FormControl(typeof this.data.formData.hvac1extpcnt === 'undefined' ? 0 : this.data.formData.hvac1extpcnt || 0 ),
    hvac1_option1_sf: new FormControl(typeof this.data.formData.hvac1_option1_sf === 'undefined' ? 0 : this.data.formData.hvac1_option1_sf || 0),
    hvac1_option2_sf: new FormControl(typeof this.data.formData.hvac1_option2_sf === 'undefined' ? 0 : this.data.formData.hvac1_option2_sf || 0),
    hvac1_optceilheight: new FormControl(typeof this.data.formData.hvac1_optceilheight === 'undefined' ? 0 : this.data.formData.hvac1_optceilheight || 0),
    hvac2name: new FormControl(typeof this.data.formData.hvac2name === 'undefined' ? '' : this.data.formData.hvac2name || ''),
    duct_system_2_location: new FormControl(typeof this.data.formData.duct_system_2_location === 'undefined' ? '' : this.data.formData.duct_system_2_location || ''),
    ahu_2_location: new FormControl(typeof this.data.formData.ahu_2_location === 'undefined' ? '' : this.data.formData.ahu_2_location || ''),
    db2_total: new FormControl(typeof this.data.formData.db2_total === 'undefined' ? 0 : this.data.formData.db2_total || 0),
    db2_ext: new FormControl(typeof this.data.formData.db2_ext === 'undefined' ? 0 : this.data.formData.db2_ext || 0),
    hvac2totpcnt: new FormControl(typeof this.data.formData.hvac2totpcnt === 'undefined' ? 0 : this.data.formData.hvac2totpcnt || 0 ),
    hvac2extpcnt: new FormControl(typeof this.data.formData.hvac2extpcnt === 'undefined' ? 0 : this.data.formData.hvac2extpcnt || 0 ),
    hvac2_option1_sf: new FormControl(typeof this.data.formData.hvac2_option1_sf === 'undefined' ? 0 : this.data.formData.hvac2_option1_sf || 0),
    hvac2_option2_sf: new FormControl(typeof this.data.formData.hvac2_option2_sf === 'undefined' ? 0 : this.data.formData.hvac2_option2_sf || 0),
    hvac2_optceilheight: new FormControl(typeof this.data.formData.hvac2_optceilheight === 'undefined' ? 0 : this.data.formData.hvac2_optceilheight || 0),
    hvac3name: new FormControl(typeof this.data.formData.hvac3name === 'undefined' ? '' : this.data.formData.hvac3name || ''),
    duct_system_3_location: new FormControl(typeof this.data.formData.duct_system_3_location === 'undefined' ? '' : this.data.formData.duct_system_3_location || ''),
    ahu_3_location: new FormControl(typeof this.data.formData.ahu_3_location === 'undefined' ? '' : this.data.formData.ahu_3_location || ''),
    db3_total: new FormControl(typeof this.data.formData.db3_total === 'undefined' ? 0 : this.data.formData.db3_total || 0),
    db3_ext: new FormControl(typeof this.data.formData.db3_ext === 'undefined' ? 0 : this.data.formData.db3_ext || 0),
    hvac3totpcnt: new FormControl(typeof this.data.formData.hvac3totpcnt === 'undefined' ? 0 : this.data.formData.hvac3totpcnt || 0 ),
    hvac3extpcnt: new FormControl(typeof this.data.formData.hvac3extpcnt === 'undefined' ? 0 : this.data.formData.hvac3extpcnt || 0 ),
    hvac3_option_sf: new FormControl(typeof this.data.formData.hvac3_option_sf === 'undefined' ? 0 : this.data.formData.hvac3_option_sf || 0),
    hvac3_optceilheight: new FormControl(typeof this.data.formData.hvac3_optceilheight === 'undefined' ? 0 : this.data.formData.hvac3_optceilheight || 0),
    hvac4name: new FormControl(typeof this.data.formData.hvac4name === 'undefined' ? '' : this.data.formData.hvac4name || ''),
    duct_system_4_location: new FormControl(typeof this.data.formData.duct_system_4_location === 'undefined' ? '' : this.data.formData.duct_system_4_location || ''),
    ahu_4_location: new FormControl(typeof this.data.formData.ahu_4_location === 'undefined' ? '' : this.data.formData.ahu_4_location || ''),
    db4_total: new FormControl(typeof this.data.formData.db4_total === 'undefined' ? 0 : this.data.formData.db4_total || 0),
    db4_ext: new FormControl(typeof this.data.formData.db4_ext === 'undefined' ? 0 : this.data.formData.db4_ext || 0),
    hvac4totpcnt: new FormControl(typeof this.data.formData.hvac4totpcnt === 'undefined' ? 0 : this.data.formData.hvac4totpcnt || 0 ),
    hvac4extpcnt: new FormControl(typeof this.data.formData.hvac4extpcnt === 'undefined' ? 0 : this.data.formData.hvac4extpcnt || 0 ),
    hvac4_option_sf: new FormControl(typeof this.data.formData.hvac4_option_sf === 'undefined' ? 0 : this.data.formData.hvac4_option_sf || 0),
    hvac4_optceilheight: new FormControl(typeof this.data.formData.hvac4_optceilheight === 'undefined' ? 0 : this.data.formData.hvac4_optceilheight || 0),
    vaulted_ceilings: new FormControl(typeof this.data.formData.vaulted_ceilings === 'undefined' ? '' : this.data.formData.vaulted_ceilings || ''),
    flat_ceilings: new FormControl(typeof this.data.formData.flat_ceilings === 'undefined' ? '' : this.data.formData.flat_ceilings || ''),
    all_otr_ceilings: new FormControl(typeof this.data.formData.all_otr_ceilings === 'undefined' ? '' : this.data.formData.all_otr_ceilings || ''),
    _1st_floor: new FormControl(typeof this.data.formData._1st_floor === 'undefined' ? '' : this.data.formData._1st_floor || ''),
    knee_walls: new FormControl(typeof this.data.formData.knee_walls === 'undefined' ? '' : this.data.formData.knee_walls || ''),
    foundation_type: new FormControl(typeof this.data.formData.foundation_type === 'undefined' ? '' : this.data.formData.foundation_type || ''),
    fdn_r: new FormControl(typeof this.data.formData.fdn_r === 'undefined' ? '' : this.data.formData.fdn_r || ''),
    dropped_ceiling_soffit: new FormControl(typeof this.data.formData.dropped_ceiling_soffit === 'undefined' ? '' : this.data.formData.dropped_ceiling_soffit || ''),
    wall_b_shower_tub: new FormControl(typeof this.data.formData.wall_b_shower_tub === 'undefined' ? '' : this.data.formData.wall_b_shower_tub || ''),
    attic_knee_walls: new FormControl(typeof this.data.formData.attic_knee_walls === 'undefined' ? '' : this.data.formData.attic_knee_walls || ''),
    wall_a_porch_roof: new FormControl(typeof this.data.formData.wall_a_porch_roof === 'undefined' ? '' : this.data.formData.wall_a_porch_roof || ''),
    double_walls: new FormControl(typeof this.data.formData.double_walls === 'undefined' ? '' : this.data.formData.double_walls || ''),
    flr_o_unconbsmt_crawl: new FormControl(typeof this.data.formData.flr_o_unconbsmt_crawl === 'undefined' ? '' : this.data.formData.flr_o_unconbsmt_crawl || ''),
    cantilevered_floor: new FormControl(typeof this.data.formData.cantilevered_floor === 'undefined' ? '' : this.data.formData.cantilevered_floor || ''),
    r21_o_wall: new FormControl(typeof this.data.formData.r21_o_wall === 'undefined' ? '' : this.data.formData.r21_o_wall || ''),
    sip: new FormControl(typeof this.data.formData.sip === 'undefined' ? '' : this.data.formData.sip || ''),
    r21_attic_platform: new FormControl(typeof this.data.formData.r21_attic_platform === 'undefined' ? '' : this.data.formData.r21_attic_platform || ''),
    ins_sheathing: new FormControl(typeof this.data.formData.ins_sheathing === 'undefined' ? '' : this.data.formData.ins_sheathing || ''),
    r6_corner: new FormControl(typeof this.data.formData.r6_corner === 'undefined' ? '' : this.data.formData.r6_corner || ''),
    ins_headr: new FormControl(typeof this.data.formData.ins_headr === 'undefined' ? '' : this.data.formData.ins_headr || ''),
    min_wind_dr_framing: new FormControl(typeof this.data.formData.min_wind_dr_framing === 'undefined' ? '' : this.data.formData.min_wind_dr_framing || ''),
    ins_wall_intersect: new FormControl(typeof this.data.formData.ins_wall_intersect === 'undefined' ? '' : this.data.formData.ins_wall_intersect || ''),
    min_stud_spacing: new FormControl(typeof this.data.formData.min_stud_spacing === 'undefined' ? '' : this.data.formData.min_stud_spacing || ''),
    duct_flue_shaft: new FormControl(typeof this.data.formData.duct_flue_shaft === 'undefined' ? '' : this.data.formData.duct_flue_shaft || ''),
    recessed_light: new FormControl(typeof this.data.formData.recessed_light === 'undefined' ? '' : this.data.formData.recessed_light || ''),
    sealedsillplate: new FormControl(typeof this.data.formData.sealedsillplate === 'undefined' ? '' : this.data.formData.sealedsillplate || ''),
    topplatespresent: new FormControl(typeof this.data.formData.topplatespresent === 'undefined' ? '' : this.data.formData.topplatespresent || ''),
    sealedtopplate: new FormControl(typeof this.data.formData.sealedtopplate === 'undefined' ? '' : this.data.formData.sealedtopplate || ''),
    sealedwindows: new FormControl(typeof this.data.formData.sealedwindows === 'undefined' ? '' : this.data.formData.sealedwindows || ''),
    sealedmarriagejointsmodhomes: new FormControl(typeof this.data.formData.sealedmarriagejointsmodhomes === 'undefined' ? '' : this.data.formData.sealedmarriagejointsmodhomes || ''),
    sealed_common_wall: new FormControl(typeof this.data.formData.sealed_common_wall === 'undefined' ? '' : this.data.formData.sealed_common_wall || ''),
    door_to_uncon: new FormControl(typeof this.data.formData.door_to_uncon === 'undefined' ? '' : this.data.formData.door_to_uncon || ''),
    attic_dropdown: new FormControl(typeof this.data.formData.attic_dropdown === 'undefined' ? '' : this.data.formData.attic_dropdown || ''),
    ach50_cl: new FormControl(typeof this.data.formData.ach50_cl === 'undefined' ? '' : this.data.formData.ach50_cl || ''),
    cfm50_cl: new FormControl(typeof this.data.formData.cfm50_cl === 'undefined' ? '' : this.data.formData.cfm50_cl || ''),
    ext_static_pr: new FormControl(typeof this.data.formData.ext_static_pr === 'undefined' ? '' : this.data.formData.ext_static_pr || ''),
    kinked_ducts: new FormControl(typeof this.data.formData.kinked_ducts === 'undefined' ? '' : this.data.formData.kinked_ducts || ''),
    pressure_balanced: new FormControl(typeof this.data.formData.pressure_balanced === 'undefined' ? '' : this.data.formData.pressure_balanced || ''),
    min_r6_uncond: new FormControl(typeof this.data.formData.min_r6_uncond === 'undefined' ? '' : this.data.formData.min_r6_uncond || ''),
    boots_sealed: new FormControl(typeof this.data.formData.boots_sealed === 'undefined' ? '' : this.data.formData.boots_sealed || ''),
    slab_edge_insulation: new FormControl(typeof this.data.formData.slab_edge_insulation === 'undefined' ? '' : this.data.formData.slab_edge_insulation || ''),
    continuous_control: new FormControl(typeof this.data.formData.continuous_control === 'undefined' ? '' : this.data.formData.continuous_control || ''),
    quitet_intermittent_fans: new FormControl(typeof this.data.formData.quitet_intermittent_fans === 'undefined' ? '' : this.data.formData.quitet_intermittent_fans || ''),
    quiet_continuous_fans: new FormControl(typeof this.data.formData.quiet_continuous_fans === 'undefined' ? '' : this.data.formData.quiet_continuous_fans || ''),
    continuous_fan_esq: new FormControl(typeof this.data.formData.continuous_fan_esq === 'undefined' ? '' : this.data.formData.continuous_fan_esq || ''),
    inlet_outside: new FormControl(typeof this.data.formData.inlet_outside === 'undefined' ? '' : this.data.formData.inlet_outside || ''),
    inlet_2ft: new FormControl(typeof this.data.formData.inlet_2ft === 'undefined' ? '' : this.data.formData.inlet_2ft || ''),
    inlet_screen: new FormControl(typeof this.data.formData.inlet_screen === 'undefined' ? '' : this.data.formData.inlet_screen || ''),
    kitchen_cfm: new FormControl(typeof this.data.formData.kitchen_cfm === 'undefined' ? '' : this.data.formData.kitchen_cfm || ''),
    bathroom_cfm: new FormControl(typeof this.data.formData.bathroom_cfm === 'undefined' ? '' : this.data.formData.bathroom_cfm || ''),
    merv6_filters: new FormControl(typeof this.data.formData.merv6_filters === 'undefined' ? '' : this.data.formData.merv6_filters || ''),
    gasketed_filter: new FormControl(typeof this.data.formData.gasketed_filter === 'undefined' ? '' : this.data.formData.gasketed_filter || ''),
    air_is_filtered: new FormControl(typeof this.data.formData.air_is_filtered === 'undefined' ? '' : this.data.formData.air_is_filtered || ''),
    vent_combust_right: new FormControl(typeof this.data.formData.vent_combust_right === 'undefined' ? '' : this.data.formData.vent_combust_right || ''),
    vent_fireplace_right: new FormControl(typeof this.data.formData.vent_fireplace_right === 'undefined' ? '' : this.data.formData.vent_fireplace_right || ''),
    co_less_35ppm: new FormControl(typeof this.data.formData.co_less_35ppm === 'undefined' ? '' : this.data.formData.co_less_35ppm || ''),
    job_id: new FormControl(typeof this.data.formData.job_id === 'undefined' ? '' : this.data.formData.job_id || ''),
    location_id: new FormControl(typeof this.data.formData.location_id === 'undefined' ? '' : this.data.formData.location_id || ''),
    version: new FormControl(typeof this.data.formData.version === 'undefined' ? 0 : this.data.formData.version || 0),
    noreturn1: new FormControl(typeof this.data.formData.noreturn1 === 'undefined' ? 0 : this.data.formData.noreturn1 || 0),
    noreturn2: new FormControl(typeof this.data.formData.noreturn2 === 'undefined' ? 0 : this.data.formData.noreturn2 || 0),
    noreturn3: new FormControl(typeof this.data.formData.noreturn3 === 'undefined' ? 0 : this.data.formData.noreturn3 || 0),
    noreturn4: new FormControl(typeof this.data.formData.noreturn4 === 'undefined' ? 0 : this.data.formData.noreturn4 || 0),
    ledpercnt: new FormControl(typeof this.data.formData.ledpercnt === 'undefined' ? 0 : this.data.formData.ledpercnt || 0),
    codetector: new FormControl(typeof this.data.formData.codetector === 'undefined' ? '' : this.data.formData.codetector || ''),
    meterno: new FormControl(typeof this.data.formData.meterno === 'undefined' ? '' : this.data.formData.meterno || ''),
    wifitherm: new FormControl(typeof this.data.formData.wifitherm === 'undefined' ? '' : this.data.formData.wifitherm || ''),
    size: new FormControl(typeof this.data.formData.size === 'undefined' ? '' : this.data.formData.size || ''),
    spacing: new FormControl(typeof this.data.formData.spacing === 'undefined' ? '' : this.data.formData.spacing || ''),
    specshgcu: new FormControl(typeof this.data.formData.specshgcu === 'undefined' ? '' : this.data.formData.specshgcu || ''),
    noheaders: new FormControl(typeof this.data.formData.noheaders === 'undefined' ? '' : this.data.formData.noheaders || ''),
    singletop: new FormControl(typeof this.data.formData.singletop === 'undefined' ? '' : this.data.formData.singletop || ''),
    studspace: new FormControl(typeof this.data.formData.studspace === 'undefined' ? '' : this.data.formData.studspace || ''),
    studnomin: new FormControl(typeof this.data.formData.studnomin === 'undefined' ? '' : this.data.formData.studnomin || ''),
    inssheath: new FormControl(typeof this.data.formData.inssheath === 'undefined' ? '' : this.data.formData.inssheath || ''),
    inssheathr: new FormControl(typeof this.data.formData.inssheathr === 'undefined' ? '' : this.data.formData.inssheathr || ''),
    extallsheath: new FormControl(typeof this.data.formData.extallsheath === 'undefined' ? '' : this.data.formData.extallsheath || ''),
    specialnotes: new FormControl(typeof this.data.formData.specialnotes === 'undefined' ? '' : this.data.formData.specialnotes || ''),
    raisedheel: new FormControl(typeof this.data.formData.raisedheel === 'undefined' ? '' : this.data.formData.raisedheel || ''),
    crawlwall: new FormControl(typeof this.data.formData.crawlwall === 'undefined' ? 0 : this.data.formData.crawlwall || 0),
    fcavgdepth: new FormControl(typeof this.data.formData.fcavgdepth === 'undefined' ? 0 : this.data.formData.fcavgdepth || 0),
    fwavgdepth: new FormControl(typeof this.data.formData.fwavgdepth === 'undefined' ? 0 : this.data.formData.fwavgdepth || 0),
    avgfdraftr: new FormControl(typeof this.data.formData.avgfdraftr === 'undefined' ? 0 : this.data.formData.avgfdraftr || 0),
    txv: new FormControl(typeof this.data.formData.txv === 'undefined' ? '' : this.data.formData.txv || ''),
    txv2: new FormControl(typeof this.data.formData.txv2 === 'undefined' ? '' : this.data.formData.txv2 || ''),
    txv3: new FormControl(typeof this.data.formData.txv3 === 'undefined' ? '' : this.data.formData.txv3 || ''),
    txv4: new FormControl(typeof this.data.formData.txv4 === 'undefined' ? '' : this.data.formData.txv4 || ''),
    numpa: new FormControl(typeof this.data.formData.numpa === 'undefined' ? 0 : this.data.formData.numpa || 0),
    vent_brand: new FormControl(typeof this.data.formData.vent_brand === 'undefined' ? '' : this.data.formData.vent_brand || ''),
    outperled: new FormControl(typeof this.data.formData.outperled === 'undefined' ? 0 : this.data.formData.outperled || 0),
    garperled: new FormControl(typeof this.data.formData.garperled === 'undefined' ? 0 : this.data.formData.garperled || 0),
    crawlvnts: new FormControl(typeof this.data.formData.crawlvnts === 'undefined' ? '' : this.data.formData.crawlvnts || ''),
    atticdoor: new FormControl(typeof this.data.formData.atticdoor === 'undefined' ? '' : this.data.formData.atticdoor || ''),
    bsmntdoor: new FormControl(typeof this.data.formData.bsmntdoor === 'undefined' ? '' : this.data.formData.bsmntdoor || ''),
    crwlspdry: new FormControl(typeof this.data.formData.crwlspdry === 'undefined' ? '' : this.data.formData.crwlspdry || ''),
    crldrymet: new FormControl(typeof this.data.formData.crldrymet === 'undefined' ? '' : this.data.formData.crldrymet || ''),
    indperled: new FormControl(typeof this.data.formData.indperled === 'undefined' ? 0 : this.data.formData.indperled || 0),
    duct1bspr: new FormControl(typeof this.data.formData.duct1bspr === 'undefined' ? 0 : this.data.formData.duct1bspr || 0),
    duct2bspr: new FormControl(typeof this.data.formData.duct2bspr === 'undefined' ? 0 : this.data.formData.duct2bspr || 0),
    duct3bspr: new FormControl(typeof this.data.formData.duct3bspr === 'undefined' ? 0 : this.data.formData.duct3bspr || 0),
    duct4bspr: new FormControl(typeof this.data.formData.duct4bspr === 'undefined' ? 0 : this.data.formData.duct4bspr || 0),
    windobsrv: new FormControl(typeof this.data.formData.windobsrv === 'undefined' ? '' : this.data.formData.windobsrv || ''),
    precobsrv: new FormControl(typeof this.data.formData.precobsrv === 'undefined' ? '' : this.data.formData.precobsrv || ''),
    indoortemp: new FormControl(typeof this.data.formData.indoortemp === 'undefined' ? 0 : this.data.formData.indoortemp || 0),
    outdoortemp: new FormControl(typeof this.data.formData.outdoortemp === 'undefined' ? 0 : this.data.formData.outdoortemp || 0),
    envblnpres: new FormControl(typeof this.data.formData.envblnpres === 'undefined' ? 0 : this.data.formData.envblnpres || 0),
    spldctref1: new FormControl(typeof this.data.formData.spldctref1 === 'undefined' ? '' : this.data.formData.spldctref1 || "Supply Closest to Air Handler"),
    spldctref2: new FormControl(typeof this.data.formData.spldctref2 === 'undefined' ? '' : this.data.formData.spldctref2 || "Supply Closest to Air Handler"),
    spldctref3: new FormControl(typeof this.data.formData.spldctref3 === 'undefined' ? '' : this.data.formData.spldctref3 || "Supply Closest to Air Handler"),
    spldctref4: new FormControl(typeof this.data.formData.spldctref4 === 'undefined' ? '' : this.data.formData.spldctref4 || "Supply Closest to Air Handler"),
    dcttestloc1: new FormControl(typeof this.data.formData.dcttestloc1 === 'undefined' ? '' : this.data.formData.dcttestloc1 || "Largest Return Grille"),
    dcttestloc2: new FormControl(typeof this.data.formData.dcttestloc2 === 'undefined' ? '' : this.data.formData.dcttestloc2 || "Largest Return Grille"),
    dcttestloc3: new FormControl(typeof this.data.formData.dcttestloc3 === 'undefined' ? '' : this.data.formData.dcttestloc3 || "Largest Return Grille"),
    dcttestloc4: new FormControl(typeof this.data.formData.dcttestloc4 === 'undefined' ? '' : this.data.formData.dcttestloc4 || "Largest Return Grille"),
    infltestmet: new FormControl(typeof this.data.formData.infltestmet === 'undefined' ? '' : this.data.formData.infltestmet == 'Depressurize' ? 'Depressurized' : this.data.formData.infltestmet || ''),
    corcfm50: new FormControl(typeof this.data.formData.corcfm50 === 'undefined' ? '' : this.data.formData.corcfm50 || 0),
    multipa1: new FormControl(typeof this.data.formData.multipa1 === 'undefined' ? -10.0 : this.data.formData.multipa1 || -10.0),
    multipa2: new FormControl(typeof this.data.formData.multipa2 === 'undefined' ? -20.0 : this.data.formData.multipa2 || -20.0),
    multipa3: new FormControl(typeof this.data.formData.multipa3 === 'undefined' ? -30.0 : this.data.formData.multipa3 || -30.0),
    multipa4: new FormControl(typeof this.data.formData.multipa4 === 'undefined' ? -40.0 : this.data.formData.multipa4 || -40.0),
    multipa5: new FormControl(typeof this.data.formData.multipa5 === 'undefined' ? -50.0 : this.data.formData.multipa5 || -50.0),
    multipa6: new FormControl(typeof this.data.formData.multipa6 === 'undefined' ? -60.0 : this.data.formData.multipa6 || -60.0),
    multiflo1: new FormControl(typeof this.data.formData.multiflo1 === 'undefined' ? 0 : this.data.formData.multiflo1 || 0),
    multiflo2: new FormControl(typeof this.data.formData.multiflo2 === 'undefined' ? 0 : this.data.formData.multiflo2 || 0),
    multiflo3: new FormControl(typeof this.data.formData.multiflo3 === 'undefined' ? 0 : this.data.formData.multiflo3 || 0),
    multiflo4: new FormControl(typeof this.data.formData.multiflo4 === 'undefined' ? 0 : this.data.formData.multiflo4 || 0),
    multiflo5: new FormControl(typeof this.data.formData.multiflo5 === 'undefined' ? 0 : this.data.formData.multiflo5 || 0),
    multiflo6: new FormControl(typeof this.data.formData.multiflo6 === 'undefined' ? 0 : this.data.formData.multiflo6 || 0),
    flowat50: new FormControl(typeof this.data.formData.flowat50 === 'undefined' ? 0 : this.data.formData.flowat50 || 0),
    elevation: new FormControl(typeof this.data.formData.elevation === 'undefined' ? 0 : this.data.formData.elevation || 0),
    ceilins: new FormControl(typeof this.data.formData.ceilins === 'undefined' ? '' : this.data.formData.ceilins || ''),
    stagedone1: new FormControl(typeof this.data.formData.stagedone1 === 'undefined' ? '' : this.data.formData.stagedone1 || ''),
    stagedone2: new FormControl(typeof this.data.formData.stagedone2 === 'undefined' ? '' : this.data.formData.stagedone2 || ''),
    stagedone3: new FormControl(typeof this.data.formData.stagedone3 === 'undefined' ? '' : this.data.formData.stagedone3 || ''),
    stagedone4: new FormControl(typeof this.data.formData.stagedone4 === 'undefined' ? '' : this.data.formData.stagedone4 || ''),
    crwldoor: new FormControl(typeof this.data.formData.crwldoor === 'undefined' ? '' : this.data.formData.crwldoor || ''),
    crwlhatch: new FormControl(typeof this.data.formData.crwlhatch === 'undefined' ? '' : this.data.formData.crwlhatch || ''),
    sloped_ceilings: new FormControl(typeof this.data.formData.sloped_ceilings === 'undefined' ? '' : this.data.formData.sloped_ceilings || ''),
    washer_mn: new FormControl(typeof this.data.formData.washer_mn === 'undefined' ? '' : this.data.formData.washer_mn || ''),
    dryer_mn: new FormControl(typeof this.data.formData.dryer_mn === 'undefined' ? '' : this.data.formData.dryer_mn || ''),
    kneesheath: new FormControl(typeof this.data.formData.kneesheath === 'undefined' ? '' : this.data.formData.kneesheath || ''),
    veneertype: new FormControl(typeof this.data.formData.veneertype === 'undefined' ? '' : this.data.formData.veneertype || ''),
    dctlc1sys1: new FormControl(typeof this.data.formData.dctlc1sys1 === 'undefined' ? 0 : this.data.formData.dctlc1sys1 || 0),
    dctpc1sys1: new FormControl(typeof this.data.formData.dctpc1sys1 === 'undefined' ? 0 : this.data.formData.dctpc1sys1 || 0),
    dctlc2sys1: new FormControl(typeof this.data.formData.dctlc2sys1 === 'undefined' ? 0 : this.data.formData.dctlc2sys1 || 0),
    dctpc2sys1: new FormControl(typeof this.data.formData.dctpc2sys1 === 'undefined' ? 0 : this.data.formData.dctpc2sys1 || 0),
    dctlc3sys1: new FormControl(typeof this.data.formData.dctlc3sys1 === 'undefined' ? 0 : this.data.formData.dctlc3sys1 || 0),
    dctpc3sys1: new FormControl(typeof this.data.formData.dctpc3sys1 === 'undefined' ? 0 : this.data.formData.dctpc3sys1 || 0),
    dctlc1sys2: new FormControl(typeof this.data.formData.dctlc1sys2 === 'undefined' ? 0 : this.data.formData.dctlc1sys2 || 0),
    dctpc1sys2: new FormControl(typeof this.data.formData.dctpc1sys2 === 'undefined' ? 0 : this.data.formData.dctpc1sys2 || 0),
    dctlc2sys2: new FormControl(typeof this.data.formData.dctlc2sys2 === 'undefined' ? 0 : this.data.formData.dctlc2sys2 || 0),
    dctpc2sys2: new FormControl(typeof this.data.formData.dctpc2sys2 === 'undefined' ? 0 : this.data.formData.dctpc2sys2 || 0),
    dctlc3sys2: new FormControl(typeof this.data.formData.dctlc3sys2 === 'undefined' ? 0 : this.data.formData.dctlc3sys2 || 0),
    dctpc3sys2: new FormControl(typeof this.data.formData.dctpc3sys2 === 'undefined' ? 0 : this.data.formData.dctpc3sys2 || 0),
    dctlc1sys3: new FormControl(typeof this.data.formData.dctlc1sys3 === 'undefined' ? 0 : this.data.formData.dctlc1sys3 || 0),
    dctpc1sys3: new FormControl(typeof this.data.formData.dctpc1sys3 === 'undefined' ? 0 : this.data.formData.dctpc1sys3 || 0),
    dctlc2sys3: new FormControl(typeof this.data.formData.dctlc2sys3 === 'undefined' ? 0 : this.data.formData.dctlc2sys3 || 0),
    dctpc2sys3: new FormControl(typeof this.data.formData.dctpc2sys3 === 'undefined' ? 0 : this.data.formData.dctpc2sys3 || 0),
    dctlc3sys3: new FormControl(typeof this.data.formData.dctlc3sys3 === 'undefined' ? 0 : this.data.formData.dctlc3sys3 || 0),
    dctpc3sys3: new FormControl(typeof this.data.formData.dctpc3sys3 === 'undefined' ? 0 : this.data.formData.dctpc3sys3 || 0),
    dctlc1sys4: new FormControl(typeof this.data.formData.dctlc1sys4 === 'undefined' ? 0 : this.data.formData.dctlc1sys4 || 0),
    dctpc1sys4: new FormControl(typeof this.data.formData.dctpc1sys4 === 'undefined' ? 0 : this.data.formData.dctpc1sys4 || 0),
    dctlc2sys4: new FormControl(typeof this.data.formData.dctlc2sys4 === 'undefined' ? 0 : this.data.formData.dctlc2sys4 || 0),
    dctpc2sys4: new FormControl(typeof this.data.formData.dctpc2sys4 === 'undefined' ? 0 : this.data.formData.dctpc2sys4 || 0),
    dctlc3sys4: new FormControl(typeof this.data.formData.dctlc3sys4 === 'undefined' ? 0 : this.data.formData.dctlc3sys4 || 0),
    dctpc3sys4: new FormControl(typeof this.data.formData.dctpc3sys4 === 'undefined' ? 0 : this.data.formData.dctpc3sys4 || 0),
    dctpc4sys4: new FormControl(typeof this.data.formData.dctpc4sys4 === 'undefined' ? 0 : this.data.formData.dctpc4sys4 || 0),
    ahulc1sys1: new FormControl(typeof this.data.formData.ahulc1sys1 === 'undefined' ? 0 : this.data.formData.ahulc1sys1 || 0),
    ahupc1sys1: new FormControl(typeof this.data.formData.ahupc1sys1 === 'undefined' ? 0 : this.data.formData.ahupc1sys1 || 0),
    ahulc2sys1: new FormControl(typeof this.data.formData.ahulc2sys1 === 'undefined' ? 0 : this.data.formData.ahulc2sys1 || 0),
    ahupc2sys1: new FormControl(typeof this.data.formData.ahupc2sys1 === 'undefined' ? 0 : this.data.formData.ahupc2sys1 || 0),
    ahulc3sys1: new FormControl(typeof this.data.formData.ahulc3sys1 === 'undefined' ? 0 : this.data.formData.ahulc3sys1 || 0),
    ahupc3sys1: new FormControl(typeof this.data.formData.ahupc3sys1 === 'undefined' ? 0 : this.data.formData.ahupc3sys1 || 0),
    ahulc1sys2: new FormControl(typeof this.data.formData.ahulc1sys2 === 'undefined' ? 0 : this.data.formData.ahulc1sys2 || 0),
    ahupc1sys2: new FormControl(typeof this.data.formData.ahupc1sys2 === 'undefined' ? 0 : this.data.formData.ahupc1sys2 || 0),
    ahulc2sys2: new FormControl(typeof this.data.formData.ahulc2sys2 === 'undefined' ? 0 : this.data.formData.ahulc2sys2 || 0),
    ahupc2sys2: new FormControl(typeof this.data.formData.ahupc2sys2 === 'undefined' ? 0 : this.data.formData.ahupc2sys2 || 0),
    ahulc3sys2: new FormControl(typeof this.data.formData.ahulc3sys2 === 'undefined' ? 0 : this.data.formData.ahulc3sys2 || 0),
    ahupc3sys2: new FormControl(typeof this.data.formData.ahupc3sys2 === 'undefined' ? 0 : this.data.formData.ahupc3sys2 || 0),
    ahulc1sys3: new FormControl(typeof this.data.formData.ahulc1sys3 === 'undefined' ? 0 : this.data.formData.ahulc1sys3 || 0),
    ahupc1sys3: new FormControl(typeof this.data.formData.ahupc1sys3 === 'undefined' ? 0 : this.data.formData.ahupc1sys3 || 0),
    ahulc2sys3: new FormControl(typeof this.data.formData.ahulc2sys3 === 'undefined' ? 0 : this.data.formData.ahulc2sys3 || 0),
    ahupc2sys3: new FormControl(typeof this.data.formData.ahupc2sys3 === 'undefined' ? 0 : this.data.formData.ahupc2sys3 || 0),
    ahulc3sys3: new FormControl(typeof this.data.formData.ahulc3sys3 === 'undefined' ? 0 : this.data.formData.ahulc3sys3 || 0),
    ahupc3sys3: new FormControl(typeof this.data.formData.ahupc3sys3 === 'undefined' ? 0 : this.data.formData.ahupc3sys3 || 0),
    ahulc1sys4: new FormControl(typeof this.data.formData.ahulc1sys4 === 'undefined' ? 0 : this.data.formData.ahulc1sys4 || 0),
    ahupc1sys4: new FormControl(typeof this.data.formData.ahupc1sys4 === 'undefined' ? 0 : this.data.formData.ahupc1sys4 || 0),
    ahulc2sys4: new FormControl(typeof this.data.formData.ahulc2sys4 === 'undefined' ? 0 : this.data.formData.ahulc2sys4 || 0),
    ahupc2sys4: new FormControl(typeof this.data.formData.ahupc2sys4 === 'undefined' ? 0 : this.data.formData.ahupc2sys4 || 0),
    ahulc3sys4: new FormControl(typeof this.data.formData.ahulc3sys4 === 'undefined' ? 0 : this.data.formData.ahulc3sys4 || 0),
    ahupc3sys4: new FormControl(typeof this.data.formData.ahupc3sys4 === 'undefined' ? 0 : this.data.formData.ahupc3sys4 || 0),
    insidet1: new FormControl(typeof this.data.formData.insidet1 === 'undefined' ? 0 : this.data.formData.insidet1 || 0),
    garaget1: new FormControl(typeof this.data.formData.garaget1 === 'undefined' ? 0 : this.data.formData.garaget1 || 0),
    outsidet1: new FormControl(typeof this.data.formData.outsidet1 === 'undefined' ? 0 : this.data.formData.outsidet1 || 0),
    insidet2: new FormControl(typeof this.data.formData.insidet2 === 'undefined' ? 0 : this.data.formData.insidet2 || 0),
    outsidet2: new FormControl(typeof this.data.formData.outsidet2 === 'undefined' ? 0 : this.data.formData.outsidet2 || 0),
    garaget2: new FormControl(typeof this.data.formData.garaget2 === 'undefined' ? 0 : this.data.formData.garaget2 || 0),
    insidenq: new FormControl(typeof this.data.formData.insidenq === 'undefined' ? 0 : this.data.formData.insidenq || 0),
    outsidenq: new FormControl(typeof this.data.formData.outsidenq === 'undefined' ? 0 : this.data.formData.outsidenq || 0),
    garagenq: new FormControl(typeof this.data.formData.garagenq === 'undefined' ? 0 : this.data.formData.garagenq || 0),
    insidet1pct: new FormControl({ value: (typeof this.data.formData.insidet1pct === 'undefined' ? 0 : this.data.formData.insidet1pct || 0) }),
    insidet2pct: new FormControl({ value: (typeof this.data.formData.insidet2pct === 'undefined' ? 0 : this.data.formData.insidet2pct || 0) }),
    outsidet1pct: new FormControl({ value: (typeof this.data.formData.outsidet1pct === 'undefined' ? 0 : this.data.formData.outsidet1pct || 0) }),
    outsidet2pct: new FormControl({ value: (typeof this.data.formData.outsidet2pct === 'undefined' ? 0 : this.data.formData.outsidet2pct || 0) }),
    garaget1pct: new FormControl({ value: (typeof this.data.formData.garaget1pct === 'undefined' ? 0 : this.data.formData.garaget1pct || 0) }),
    garaget2pct: new FormControl({ value: (typeof this.data.formData.garaget2pct === 'undefined' ? 0 : this.data.formData.garaget2pct || 0) }),
    whpcteff: new FormControl({ value: (typeof this.data.formData.whpcteff === 'undefined' ? 0 : this.data.formData.whpcteff || 0) }),
    ductdebris: new FormControl(typeof this.data.formData.ductdebris === 'undefined' ? '' : this.data.formData.ductdebris || ''),
    carbmondet: new FormControl(typeof this.data.formData.carbmondet === 'undefined' ? '' : this.data.formData.carbmondet || ''),
    filtclean: new FormControl(typeof this.data.formData.filtclean === 'undefined' ? '' : this.data.formData.filtclean || ''),
    ductclean: new FormControl(typeof this.data.formData.ductclean === 'undefined' ? '' : this.data.formData.ductclean || ''),
    gardoorclo: new FormControl(typeof this.data.formData.gardoorclo === 'undefined' ? '' : this.data.formData.gardoorclo || ''),
    gutextensn: new FormControl(typeof this.data.formData.gutextensn === 'undefined' ? '' : this.data.formData.gutextensn || ''),
    finalcfm: new FormControl(typeof this.data.formData.finalcfm === 'undefined' ? '' : this.data.formData.finalcfm || ''),
    blowfanvol: new FormControl(typeof this.data.formData.blowfanvol === 'undefined' ? '' : this.data.formData.blowfanvol || ''),
    blowfanwatt: new FormControl(typeof this.data.formData.blowfanwatt === 'undefined' ? '' : this.data.formData.blowfanwatt || ''),
    refcharge: new FormControl(typeof this.data.formData.refcharge === 'undefined' ? '' : this.data.formData.refcharge || ''),
    motodamp: new FormControl(typeof this.data.formData.motodamp === 'undefined' ? '' : this.data.formData.motodamp || ''),
    abvdesval: new FormControl(typeof this.data.formData.abvdesval === 'undefined' ? '' : this.data.formData.abvdesval || ''),
    airinletloc: new FormControl(typeof this.data.formData.airinletloc === 'undefined' ? '' : this.data.formData.airinletloc || ''),
    skylights: new FormControl(typeof this.data.formData.skylights === 'undefined' ? '' : this.data.formData.skylights || ''),
    bandht: new FormControl(typeof this.data.formData.bandht === 'undefined' ? '' : this.data.formData.bandht || ''),
    ashrae: new FormControl(typeof this.data.formData.ashrae === 'undefined' ? '' : this.data.formData.ashrae || ''),
    ceilins_notes: new FormControl(typeof this.data.formData.ceilins_notes === 'undefined' ? '' : this.data.formData.ceilins_notes || ''),
    cantfspacing: new FormControl(typeof this.data.formData.cantfspacing === 'undefined' ? '' : this.data.formData.cantfspacing || ''),
    garspacing: new FormControl(typeof this.data.formData.garspacing === 'undefined' ? '' : this.data.formData.garspacing || ''),
    ffspacing: new FormControl(typeof this.data.formData.ffspacing === 'undefined' ? '' : this.data.formData.ffspacing || ''),
    trades: new FormControl(typeof this.data.formData.trades === 'undefined' || this.data.formData.trades == null ? [] : (this.data.formData.trades.split(',') || [])),
    elr: new FormControl(typeof this.data.formData.elr === 'undefined' ? '' : this.data.formData.elr || 0),
    fdn_notes: new FormControl(typeof this.data.formData.fdn_notes === 'undefined' ? '' : this.data.formData.fdn_notes || ''),
    flrovrincl: new FormControl(typeof this.data.formData.flrovrincl === 'undefined' ? '' : this.data.formData.flrovrincl || false),
    adddoorins: new FormControl(typeof this.data.formData.adddoorins === 'undefined' ? '' : this.data.formData.adddoorins || false),
    atticdoorins: new FormControl(typeof this.data.formData.atticdoorins === 'undefined' ? '' : this.data.formData.atticdoorins || false),
    bandspacing: new FormControl(typeof this.data.formData.bandspacing === 'undefined' ? '' : this.data.formData.bandspacing || false),
    dctlc4sys4: new FormControl(typeof this.data.formData.dctlc4sys4 === 'undefined' ? '' : this.data.formData.dctlc4sys4 || false),
    hvac4_option2_sf: new FormControl(typeof this.data.formData.hvac4_option2_sf === 'undefined' ? 0 : this.data.formData.hvac4_option2_sf || 0),
    hvac4_option1_sf: new FormControl(typeof this.data.formData.hvac4_option1_sf === 'undefined' ? 0 : this.data.formData.hvac4_option1_sf || 0),
    agwins : new FormControl(typeof this.data.formData.agwins == 'undefined' ? '' : this.data.formData.agwins || ''),
    fcavginsdep : new FormControl(typeof this.data.formData.fcavginsdep == 'undefined' ? '' : this.data.formData.fcavginsdep || ''),
    cantjoist : new FormControl(typeof this.data.formData.cantjoist == 'undefined' ? '' : this.data.formData.cantjoist || ''),
    garjoist : new FormControl(typeof this.data.formData.garjoist == 'undefined' ? '' : this.data.formData.garjoist || ''),
    fndwallspa : new FormControl(typeof this.data.formData.fndwallspa == 'undefined' ? '' : this.data.formData.fndwallspa || ''),
    parwallshe : new FormControl(typeof this.data.formData.parwallshe == 'undefined' ? '' : this.data.formData.parwallshe || ''),
    suppinareas : new FormControl(typeof this.data.formData.suppinareas == 'undefined' ? null : this.data.formData.suppinareas),
    suppliesinareas : new FormControl(this.data?.formData?.suppliesinareas? this.data.formData.suppliesinareas : ''), 
    cndcrwldry : new FormControl(typeof this.data.formData.cndcrwldry == 'undefined' ? '' : this.data.formData.cndcrwldry || ''),
    frstflrjoi : new FormControl(typeof this.data.formData.frstflrjoi == 'undefined' ? '' : this.data.formData.frstflrjoi || ''),
    dehumidmod : new FormControl(typeof this.data.formData.dehumidmod == 'undefined' ? '' : this.data.formData.dehumidmod || ''),
    tstatcount : new FormControl(typeof this.data.formData.tstatcount == 'undefined' ? '' : this.data.formData.tstatcount || ''),
    tstatcount2 : new FormControl(typeof this.data.formData.tstatcount2 == 'undefined' ? '' : this.data.formData.tstatcount2 || ''),
    tstatcount3 : new FormControl(typeof this.data.formData.tstatcount3 == 'undefined' ? '' : this.data.formData.tstatcount3 || ''),
    tstatcount4 : new FormControl(typeof this.data.formData.tstatcount4 == 'undefined' ? '' : this.data.formData.tstatcount4 || ''),
    tstattype1 : new FormControl(typeof this.data.formData.tstattype1 == 'undefined' ? '' : this.data.formData.tstattype1 || ''),
    tstattype2 : new FormControl(typeof this.data.formData.tstattype2 == 'undefined' ? '' : this.data.formData.tstattype2 || ''),
    tstattype3 : new FormControl(typeof this.data.formData.tstattype3 == 'undefined' ? '' : this.data.formData.tstattype3 || ''),
    tstattype4 : new FormControl(typeof this.data.formData.tstattype4 == 'undefined' ? '' : this.data.formData.tstattype4 || ''),
    loflowafx : new FormControl(typeof this.data.formData.loflowafx === 'undefined' ? null : this.data.formData.loflowafx),
    r3hwpipins : new FormControl(typeof this.data.formData.r3hwpipins == 'undefined' ? null : this.data.formData.r3hwpipins || null),
    agwspacing : new FormControl(typeof this.data.formData.agwspacing == 'undefined' ? '' : this.data.formData.agwspacing || ''),
    multifamilytemplate : new FormControl(typeof this.data.formData.multifamilytemplate == 'undefined' ? '' : this.data.formData.multifamilytemplate || ''),
    sys1notes : new FormControl(typeof this.data.formData.sys1notes == 'undefined' ? '' : this.data.formData.sys1notes || ''),
    sys2notes : new FormControl(typeof this.data.formData.sys2notes == 'undefined' ? '' : this.data.formData.sys2notes || ''),
    sys3notes : new FormControl(typeof this.data.formData.sys3notes == 'undefined' ? '' : this.data.formData.sys3notes || ''),
    sys4notes : new FormControl(typeof this.data.formData.sys4notes == 'undefined' ? '' : this.data.formData.sys4notes || ''),
    bdnotes : new FormControl(typeof this.data.formData.bdnotes == 'undefined' ? '' : this.data.formData.bdnotes || ''),
    manualentry : new FormControl(typeof this.data.formData.manualentry == 'undefined' ? '' : this.data.formData.manualentry || false),
    bandna : new FormControl(typeof this.data.formData.bandna == 'undefined' ? '' : this.data.formData.bandna || false),
    agwna : new FormControl(typeof this.data.formData.agwna == 'undefined' ? '' : this.data.formData.agwna || false),
    adiabatic_walls_chk: new FormControl(typeof this.data.formData.adiabatic_walls_chk === 'undefined' ? false : this.data.formData.adiabatic_walls_chk || false),
    adiabatic_walls_rv: new FormControl(typeof this.data.formData.adiabatic_walls_rv === 'undefined' ? '' : this.data.formData.adiabatic_walls_rv || ''),
    adiabatic_walls_sp: new FormControl(typeof this.data.formData.adiabatic_walls_sp === 'undefined' ? '' : this.data.formData.adiabatic_walls_sp || ''),
    adiabatic_bands_chk: new FormControl(typeof this.data.formData.adiabatic_bands_chk === 'undefined' ? false : this.data.formData.adiabatic_bands_chk || false),
    adiabatic_bands_rv: new FormControl(typeof this.data.formData.adiabatic_bands_rv === 'undefined' ? '' : this.data.formData.adiabatic_bands_rv || ''),
    adiabatic_bands_sp: new FormControl(typeof this.data.formData.adiabatic_bands_sp === 'undefined' ? '' : this.data.formData.adiabatic_bands_sp || ''),
    adiabatic_bands_jh: new FormControl(typeof this.data.formData.adiabatic_bands_jh === 'undefined' ? '' : this.data.formData.adiabatic_bands_jh || ''),
    adiabatic_ceil_chk: new FormControl(typeof this.data.formData.adiabatic_ceil_chk === 'undefined' ? false : this.data.formData.adiabatic_ceil_chk || false),
    adiabatic_ceil_rv: new FormControl(typeof this.data.formData.adiabatic_ceil_rv === 'undefined' ? '' : this.data.formData.adiabatic_ceil_rv || ''),
    adiabatic_ceil_sp: new FormControl(typeof this.data.formData.adiabatic_ceil_sp === 'undefined' ? '' : this.data.formData.adiabatic_ceil_sp || ''),
    adiabatic_ceil_fs: new FormControl(typeof this.data.formData.adiabatic_ceil_fs === 'undefined' ? '' : this.data.formData.adiabatic_ceil_fs || ''),
    adiabatic_flr_chk: new FormControl(typeof this.data.formData.adiabatic_flr_chk === 'undefined' ? false : this.data.formData.adiabatic_flr_chk || false),
    adiabatic_flr_rv: new FormControl(typeof this.data.formData.adiabatic_flr_rv === 'undefined' ? '' : this.data.formData.adiabatic_flr_rv || ''),
    adiabatic_flr_sp: new FormControl(typeof this.data.formData.adiabatic_flr_sp === 'undefined' ? '' : this.data.formData.adiabatic_flr_sp || ''),
    adiabatic_flr_jh: new FormControl(typeof this.data.formData.adiabatic_flr_jh === 'undefined' ? '' : this.data.formData.adiabatic_flr_jh || ''),
    kneewallfs : new FormControl(typeof this.data.formData.kneewallfs == 'undefined' ? '' : this.data.formData.kneewallfs || ''),
    kneewallsp : new FormControl(typeof this.data.formData.kneewallsp == 'undefined' ? '' : this.data.formData.kneewallsp || ''),
    garslabins : new FormControl(typeof this.data.formData.garslabins == 'undefined' ? '' : this.data.formData.garslabins || ''),
    prchpatins : new FormControl(typeof this.data.formData.garslabins == 'undefined' ? '' : this.data.formData.prchpatins || ''),
    tagControl : new FormControl(''),
    mfcfm : new FormControl(typeof this.data.formData.mfcfm == 'undefined' ? 0 : this.data.formData.mfcfm || 0),
    caz1 : new FormControl(typeof this.data.formData.caz1 == 'undefined' ? 0 : this.data.formData.caz1 || ''),
    caz2 : new FormControl(typeof this.data.formData.caz2 == 'undefined' ? 0 : this.data.formData.caz2 || ''),
    ahucloset : new FormControl(typeof this.data.formData.ahucloset == 'undefined' ? 0 : this.data.formData.ahucloset || 0),
    bdahucloset : new FormControl(typeof this.data.formData.bdahucloset == 'undefined' ? 0 : this.data.formData.bdahucloset || 0),
    hvac1_exempt : new FormControl(typeof this.data.formData.hvac1_exempt == 'undefined' ? false : this.data.formData.hvac1_exempt || false),
    hvac1_exempt_reason : new FormControl(typeof this.data.formData.hvac1_exempt_reason == 'undefined' ? '' : this.data.formData.hvac1_exempt_reason || ''),
    hvac2_exempt : new FormControl(typeof this.data.formData.hvac2_exempt == 'undefined' ? false : this.data.formData.hvac2_exempt || false),
    hvac2_exempt_reason : new FormControl(typeof this.data.formData.hvac2_exempt_reason == 'undefined' ? '' : this.data.formData.hvac2_exempt_reason || ''),
    hvac3_exempt : new FormControl(typeof this.data.formData.hvac3_exempt == 'undefined' ? false : this.data.formData.hvac3_exempt || false),
    hvac3_exempt_reason : new FormControl(typeof this.data.formData.hvac3_exempt_reason == 'undefined' ? '' : this.data.formData.hvac3_exempt_reason || ''),
    hvac4_exempt : new FormControl(typeof this.data.formData.hvac4_exempt == 'undefined' ? false : this.data.formData.hvac4_exempt || false),
    hvac4_exempt_reason : new FormControl(typeof this.data.formData.hvac4_exempt_reason == 'undefined' ? '' : this.data.formData.hvac4_exempt_reason || ''),
    locationName: new FormControl(''),
    airFlow: new FormControl(null),
    watts: new FormControl(null),
    amps: new FormControl(null),
    volts: new FormControl(null),
    calculatedAirFlowGrade: new FormControl(''),
    lineset : new FormControl(null),
    liquiddiameter : new FormControl(null),
    chargedev : new FormControl(null),
    prechargedistance : new FormControl(null),
    ozrefrigerant : new FormControl(null),
    airflowtestmode : new FormControl(null),
    tonnage : new FormControl(null),
    cfm_per_ton : new FormControl(400),
    manualcalc: new FormControl(false),
    manualdesign: new FormControl(null),
    aff : new FormControl(this.data.formData.aff || false),
    vent_tied_to : new FormControl(this.data.formData.vent_tied_to || ''),
    bedroom_verify : new FormControl(this.data.formData.bedroom_verify || ''),
    // Explicit undefined checks rather than the `|| ''` idiom: a stored 0 is a legitimate
    // bedroom count and `0 || ''` would silently blank it.
    bedroom_override : new FormControl(this.data.formData.bedroom_override == null ? '' : this.data.formData.bedroom_override),
    bedroom_original : new FormControl(this.data.formData.bedroom_original == null ? '' : this.data.formData.bedroom_original),
    bathroom_verify : new FormControl(this.data.formData.bathroom_verify || ''),
    bathroom_override : new FormControl(this.data.formData.bathroom_override == null ? '' : this.data.formData.bathroom_override),
    bathroom_original : new FormControl(this.data.formData.bathroom_original == null ? '' : this.data.formData.bathroom_original),
    condcrawlpt : new FormControl(typeof this.data.formData.condcrawlpt == 'undefined' ? 0 : this.data.formData.condcrawlpt || 0),
    ahupanel : new FormControl(typeof this.data.formData.ahupanel == 'undefined' ? '' : this.data.formData.ahupanel || ''),
    hwpipelen: new FormControl(typeof this.data.formData.hwpipelen == 'undefined' ? '' : this.data.formData.hwpipelen || ''),
    pztested : new FormControl(typeof this.data.formData.pztested == 'undefined' ? false : this.data.formData.pztested || false),
    pztesttype: new FormControl(typeof this.data.formData.pztesttype == 'undefined' ? false : this.data.formData.pztesttype || false)
  });
  //references to form controls we use in functions/ comparisons
  blowerDoorControl: AbstractControl 
  totalSF1:  number; 
  totalSF2:  number; 
  totalSF3:  number; 
  totalSF4:  number; 

  templateName = '';
  initials;
  usernamee;
  user;
  drivelink;
  lastChanged;
  selectedTemplate;
  multifamilyDoc: boolean = false;
  template$;
  templateObject;
  scheduleDate;
  subdivision;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredTags: Observable<any[]>;
  tags: any[] = [];
  inputTags: any[] = [];
  mftemplateid = 0;
  baseURL = '';
  thresholds: any = {};

  previousIndoor = 0;
  previousOutdoor = 0;
  previousElevation = 0; 
  previousBaseline = 0;

  previousIndoor_changed = false;
  previousOutdoor_changed = false;
  previousElevation_changed = false; 
  previousBaseline_changed = false;
  customerObj = {
    customer_name: '(No customer selected)', 
    customer_id: 0
  };

  
  showAff: boolean = false; 
  show_bd_factor_warning = false;

  ngOnInit(): void {

    this.configs.loadConfigs();

    this.phoneNumberText = this.data.formData.jobinfo.name + ':    ' +  this.data.formData.jobinfo.contact_phone;
    //initialize form controls
    this.blowerDoorControl = this.raterform.get('blower_door'); 


    this.customerservice.getOneCustomerLocId(this.data.location_id).subscribe(
      res => {
        this.customerObj = res.Customer;
      }, err => {
        this.customerObj = {
          customer_name: '(No customer selected)', 
          customer_id: 0
        }
      }
    )
    
    this.baseURL = this.raterFormService.getPrefixLink();
    let mfid = 0;

    this.previousIndoor = this.raterform.get('indoortemp').value;
    this.previousOutdoor = this.raterform.get('outdoortemp').value;
    this.previousElevation = this.raterform.get('elevation').value; 
    this.previousBaseline = this.raterform.get('envblnpres').value;
    

    this.checkAffBoxes(false);
    //get job scope
    this.loadSelfiePics(this.form_id);
    this.loadLoflowafxPhotos(this.form_id);
    this.loadVentCtrlPhotos(this.form_id);
    this.loadEsCeilingFansPhotos(this.form_id);
    this.loadChecklistPhotoCounts(this.form_id);
    this.loadAllOtrCeilingsPhotos(this.form_id);
    this.loadSysNames();

    //iterate 1 to 4 and see if there's a matching property in hvacgrade called system1, system2, etc
    //if so, assign the system1, system2, etc to the corresponding sys1grade, sys2grade, etc
    if(this.data.formData.hvacgrade){
      for(let i = 1; i <= 4; i++){
        let sys = 'system' + i;
        let gradedsystem = this.data.formData.hvacgrade[sys];
        if(gradedsystem){
          this['sys' + i + 'grade'] = gradedsystem;
        }
      }
      this.setSysNo(1);
    }

    //load manualBounds if applicable. 
    this.updateManualBounds();
  
    this.raterFormService.getTargetSet(this.location_id).subscribe(
      res => {
        this.targetset = res.TargetSet || false; 
      }, err => {
      }
    );

    this.raterFormService.getJobScope(this.job_id).subscribe(
      res => {
        console.log('Job Scope:', res);
        this.jobscope = res.JobScope.note;
        this.testSpecs = res.JobScope.testspecs || '';
        this.envSpecs = res.JobScope.envspecs || '';
        this.hvacSpecs = res.JobScope.hvacspecs || '';
        this.stickerPlacementInfo = res.JobScope.stickerplacement || '';

        if(this.testSpecs.length > 0){
          this.showtestSpecs = true;
        }

        if(this.envSpecs.length > 0){
          this.showenvSpecs = true;
        }

        if(this.hvacSpecs.length > 0){
          this.showHvacSpecs = true;
        }

        if(this.stickerPlacementInfo.length > 0){
          this.showStickerPlacementInfo = true;
        }

      }, err => {
      }
    )   

    this.raterFormService.getTagsForJob(this.data.job_id).subscribe(
      res =>{
        this.data.tags = res.data.tags;

        this.data.tags.forEach(tag => {
          this.locservice.getTag(tag).subscribe(
            res => {
              this.inputTags.push(res.data);

              //see if tag with id 23 is in the list
              let tag23 = this.inputTags.find(x => x.id === 23);
              if(tag23){
                this.jobscope = 'HERO MANDATORY! ' + this.jobscope;
              }

            }
          );

        });


      },err => {
        this.data.length = 0;
      })

    this.locservice.getTags().subscribe(
      res => {
        this.tags = res.data;
      });

    //load any tags that are already selected
      this.filteredTags = this.raterform.get('tagControl').valueChanges.pipe(
        debounceTime(400),
        filter((tag: string | null) => tag && tag.length > 0),
        map((tag: string | null) => tag ? this._filter(tag) : this.tags.slice())
      );

    this.raterFormService.getMultifamilyTemplate(this.job_id).subscribe(
      res => {
        if(res.Response.mftemplate > 0){
          this.mftemplateid = res.Response.mftemplate;
          this.multifamilyservice.getSingleTemplate(this.mftemplateid).subscribe(
          (data) => {
            if(data.Response){
              this.templateName = data.Response.name;
              this.templateObject = data.Response;
              this.multiFamilySelected(data.Response);
              //this.getMultifamilyData(this.form_id);
            }
          });
        }
      }, err => {

      });
      // If jobtype contains esmf/mfes, ensure the flag and data row exist
      // (catches jobs updated by scheduled DB tasks outside the app)
      const cjt = this.data.formData.jobinfo?.customer_jobtype || '';
      if(cjt.trim().toLowerCase().includes('esmf') || cjt.trim().toLowerCase().includes('mfes')){
        this.locservice.updateESMFNC(this.location_id).subscribe();
        this.raterFormService.addESMFNCdata(this.location_id).subscribe();
      }

      //see if this location needs esmfnc list loaded:
      this.raterFormService.isESMFNC(this.location_id).subscribe(
        res => {
          if(res.ESMFNC.esmfnc == null || res.ESMFNC.esmfnc == false){
            this.isESMFNC = false;
            //do nothing, maybe set variables here
          }else {
            this.isESMFNC = true;

            this.snackbar.open('Please ensure you fill out the ESMFNC checklist for this job.', 'OK', {
              duration: null,  // duration in milliseconds
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: ['custom-snackbar-rf']
            }
            )
            //open a dialog component here to warn the user that they are entering ESMFNC data
            this.raterFormService.getESMFNCdesc().subscribe(
              res => {
                res.Desc.forEach(element => {
                  this.mfChecklistItems.push({
                    id : element.id,
                    field: element.fieldname,
                    description: element.description,
                    stage: element.stage,
                    requiresPhoto: element.requires_photo === true,
                    isHeading: element.is_heading === true,
                    value: null,
                    photo: null,
                    photos: [],
                    note: null
                  });
                });

                // Remove hidden fields
                this.mfChecklistItems = this.mfChecklistItems.filter(item => !this.mfHiddenFields.includes(item.id));

                //see now if we have any ESMFNC data___
                this.raterFormService.getESMFNCdata(this.location_id).subscribe(
                  res => {
                    if(res.Error == false){
                      this.mfChecklistID = res.FormData.id;
                      this.mfChecklistItems.forEach(element => {
                        const fieldData = res.FormData[element.field];
                        element.value = fieldData?.value || '';
                        element.note = fieldData?.note || '';


                        // Backwards compatibility: support old 'photo' (string) and new 'photos' (array)
                        if (fieldData?.photos && Array.isArray(fieldData.photos) && fieldData.photos.length > 0) {
                          element.photos = fieldData.photos;
                          element.photo = fieldData.photos[fieldData.photos.length - 1];
                        } else if (fieldData?.photo && fieldData.photo.length > 0) {
                          element.photos = [fieldData.photo];
                          element.photo = fieldData.photo;
                        } else {
                          element.photos = [];
                          element.photo = '';
                        }
                      });
                    }else{
                      this.raterFormService.addESMFNCdata(this.location_id).subscribe(
                        res => {
                          this.mfChecklistID = res.id;
                          this.messager.openSnackBar('ESMFNC data added successfully.', '', 'successAlert');
                        })
                    };
                  }, err => {
                  });

              },err => {
              });
          }
        }, err => {

        });


      //getESMFNC things

    let esPDW = '**Note: if you arrive at an ES(v3) PDWI inspection and it has already been hung, mark it FAIL -NR. Make a note with the date and put “drywall hung, needs thermal, provide $250 EPO for thermal).The house is not eligible for HERO if a PDWI is not conducted(thermal not accepted).';
    let hersPDW = '*Note: if you arrive at a HERS PDWI inspection and it has already been hung, mark it FAIL -NR and record the applicable insulation locations Grade 3. Be sure to take all necessary pictures and document what you can. Put a note that the house was hung on arrival or something that clearly documents this situation. If you arrive at the house and it is not ready, mark the job FAIL and make a note that the house is not ready and contact scheduling to reschedule the job. The house is not eligible for HERO if a PDWI is not conducted(no substitutions).';

    this.reviewMode = false;
    this.lastChanged = 'No changes recorded in logs.'

    this.ventlationInRange = false;
    this.multifamilyDoc = this.data.formData.jobinfo.customer_jobtype?.toLowerCase().includes('mf');

    this.isFinal = this.data.formData.jobinfo.customer_jobtype?.includes('Final'); //final job type
    this.isHers = this.data.formData.jobinfo.customer_jobtype?.includes('HERS'); //hers job type
    this.isPDWI = this.data.formData.jobinfo.customer_jobtype?.includes('PDWI'); //pdw job type

    this.isFinal = this.data.formData.jobinfo.customer_jobtype?.includes('Final'); //final job type
    this.isPDWI = this.data.formData.jobinfo.customer_jobtype?.includes('PDWI'); //pdw job type

    this.isEnergyStar = this.data.formData.jobinfo.customer_jobtype?.toLowerCase().includes('v3'); //energy star job type

    this.template$ = this.raterform.get('multifamilytemplate').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.templateObject = value;
      }),
      switchMap(value =>
        value.length > 0 ? this.raterFormService.getMultifamilyTemplates(value as string) : empty()
      )
    );

    if(this.isPDWI && this.data.formData.jobinfo.customer_jobtype?.toLowerCase().includes('v3')){
      this.notesText = esPDW;
    }else if (this.isPDWI && this.data.formData.jobinfo.customer_jobtype?.toLowerCase().includes('hers')){
      this.notesText = hersPDW;
    }
    this.scheduleDate = new Date(this.data.schedule_date);
    this.checkWarning(true)

    //get drive link
    this.subscriptions.add(this.raterFormService.loadv3UploadsDriveFolderLink(this.location_id).subscribe(
      res => {
        this.drivelink = res.Link.folderid;
      }, err => {
      }
    ));

    this.subscriptions.add(this.auth.userProfile$.subscribe(
      (profile) => {
        this.user = profile;
        this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
        this.initials = this.user?.nickname.charAt(0).toUpperCase() + this.user?.nickname.charAt(this.user?.nickname.length - 1).toUpperCase();
      }));


    //initialize light values
    if(this.raterform.get('numpa').value == 0){
      if(this.raterform.get('manualentry').value != true){
        this.raterform.get('vent_rate_total').setValue(0,{onlySelf: true, emitEvent: false});
      }
    }else{
        document.getElementById('manualentry').classList.add('manualEntryRemove');
    }
    this.cfmCalculation(this.raterform.get('vent_brand').value)
    //getRaternote presets
    this.subscriptions.add(this.raterFormService.getRaternotePresets().subscribe(
      res => {
        this.raterNotePresets = res.Presets;
        this.presetArray = this.displayPresets('gen');
      }, err => {
        this.messager.openSnackBar('Could not retrieve presets for notes.', '', 'errorAlert');
      }
    ));


    let coll = document.getElementsByClassName("collapseButton");
    let i;
    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener('click', this.clickListenerFunc,false );
    }


      this.subscriptions.add(this.raterFormService.getPlanData(this.data.location_id).subscribe(
        (res) => {
          if(!res.Error){

          this.hvac_1_area = res.Plan.hvac_1_area || 0;
          this.hvac_2_area = res.Plan.hvac_2_area || 0;
          this.hvac_3_area = res.Plan.hvac_3_area || 0;
          this.hvac_4_area = res.Plan.hvac_4_area || 0;
          this.hvac1_ceil_ht = res.Plan.hvac1_ceil_ht || 0;
          this.hvac2_ceil_ht = res.Plan.hvac2_ceil_ht || 0;
          this.hvac3_ceil_ht = res.Plan.hvac3_ceil_ht || 0;
          this.hvac4_ceil_ht = res.Plan.hvac4_ceil_ht || 0;
          this.bedrooms =  res.Plan.bedrooms || 0;
          this.bathrooms = res.Plan.bathrooms || 0;
          this.plan_name = res.Plan.plan_name || "No plan assigned";
          this.plan_notes = res.Plan.plan_notes||"No notes";
          this.addvol = res.Plan.addvol || 0;
          this.sfbe = res.Plan.envelopearea || 0;

          if(this.hvac_1_area > 0){
            this.heightdisabledtext = true;

            // A plan is assigned: system-1 Optional Ceiling Ht must be zeroed. If a value
            // was entered before the plan was assigned it would otherwise stay (disabled but
            // non-zero) and keep feeding Volume/ACH50. Zero + persist once (the field is
            // disabled, so blur-autosave can never correct it).
            const rawOptHt = this.raterform.get('hvac1_optceilheight').value;
            const optHt = parseFloat(rawOptHt);
            if (!isNaN(optHt) && optHt !== 0) {
              this.initialValue = rawOptHt; // ensure updateSingleField's change-guard passes
              this.raterform.get('hvac1_optceilheight').setValue(0, { onlySelf: true, emitEvent: false });
              this.updateSingleField('hvac1_optceilheight'); // persists (respects noSave) + RF log
            }

            this.raterform.get('hvac1_optceilheight').disable();
          }

          this.volume = (   this.hvac_1_area * this.hvac1_ceil_ht) + (this.hvac_2_area * this.hvac2_ceil_ht) + (this.hvac_3_area * this.hvac3_ceil_ht) + (this.hvac_4_area * this.hvac4_ceil_ht)  + (  (    parseFloat(this.raterform.get('hvac1_option1_sf').value) + parseFloat(this.raterform.get('hvac1_option2_sf').value) ) * ( parseFloat(this.raterform.get('hvac1_optceilheight').value))  )  + (  (    parseFloat(this.raterform.get('hvac2_option1_sf').value) + parseFloat(this.raterform.get('hvac2_option2_sf').value)  ) * (   parseFloat(this.raterform.get('hvac2_optceilheight').value) ) ) + (  parseFloat(this.raterform.get('hvac3_option_sf').value) * parseFloat(this.raterform.get('hvac3_optceilheight').value) ) + ( parseFloat(this.raterform.get('hvac4_option1_sf').value) * parseFloat(this.raterform.get('hvac4_optceilheight').value) ) + parseFloat(this.addvol.toString());

          this.elr = parseFloat(this.raterform.get('corcfm50').value) / this.sfbe;

          let valuee = ( parseFloat(this.raterform.get('blower_door').value)  * 60)/ (parseFloat(this.addvol.toString()) + (parseFloat(this.hvac_1_area.toString()) * parseFloat(this.hvac1_ceil_ht.toString())) + (parseFloat(this.hvac_2_area.toString()) * parseFloat(this.hvac2_ceil_ht.toString())) + (parseFloat(this.hvac_3_area.toString()) * parseFloat(this.hvac3_ceil_ht.toString())) + (parseFloat(this.hvac_4_area.toString()) * parseFloat(this.hvac4_ceil_ht.toString())) + ((parseFloat(this.raterform.get('hvac1_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac1_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac1_optceilheight').value.toString())) + ((parseFloat(this.raterform.get('hvac2_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac2_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac2_optceilheight').value.toString())) + (parseFloat(this.raterform.get('hvac3_option_sf').value.toString()) * parseFloat(this.raterform.get('hvac3_optceilheight').value.toString())));

          this.raterform.get('ach50').setValue( Number.isNaN(valuee) || !Number.isFinite(valuee) ? "0": valuee.toFixed(3), {onlySelf: true, emitEvent: false});

          let ashraee = this.computeAshrae().toString();

          this.raterform.get('mfcfm').setValue(this.sfbe * 0.3);

          this.raterform.get('mfcfm').setValue(this.sfbe * 0.3);

          this.ashrae = parseFloat(ashraee);
          this.raterform.get('ashrae').setValue( this.ashrae, {onlySelf: true, emitEvent: false});

          this.calculateTotalSF1();
          this.calculateTotalSF2();
          this.calculateTotalSF3();
          this.calculateTotalSF4();


          this.dbtotalCalc(this.raterform.get('db1_total').value, this.raterform.get('hvac1_option1_sf').value, this.raterform.get('hvac1_option2_sf').value, this.hvac_1_area, 1, false);
          this.dbtotalCalc(this.raterform.get('db2_total').value, this.raterform.get('hvac2_option1_sf').value, this.raterform.get('hvac2_option2_sf').value, this.hvac_2_area, 2,false);
          this.dbtotalCalc(this.raterform.get('db3_total').value, this.raterform.get('hvac3_option_sf').value, 0, this.hvac_3_area, 3, false);
          this.dbtotalCalc(this.raterform.get('db4_total').value, this.raterform.get('hvac4_option_sf').value, 0, this.hvac_4_area, 4, false);
          this.dbextCalc(this.raterform.get('db1_ext').value, this.raterform.get('hvac1_option1_sf').value,this.raterform.get('hvac1_option2_sf').value, this.hvac_1_area, 1, false);
          this.dbextCalc(this.raterform.get('db2_ext').value, this.raterform.get('hvac2_option1_sf').value,this.raterform.get('hvac2_option2_sf').value, this.hvac_2_area, 2, false);
          this.dbextCalc(this.raterform.get('db3_ext').value, this.raterform.get('hvac3_option_sf').value,0, this.hvac_3_area, 3, false);
          this.dbextCalc(this.raterform.get('db4_ext').value, this.raterform.get('hvac4_option_sf').value,0, this.hvac_4_area, 4, false);
          this.optionalSFCalc(this.raterform.get('db1_ext').value, this.raterform.get('db1_total').value, this.raterform.get('hvac1_option1_sf').value, this.raterform.get('hvac1_option2_sf').value, this.hvac_1_area, 0);
          this.optionalSFCalc(this.raterform.get('db2_ext').value, this.raterform.get('db2_total').value, this.raterform.get('hvac2_option1_sf').value, this.raterform.get('hvac2_option2_sf').value, this.hvac_2_area, 0);
          this.optionalSFCalc(this.raterform.get('db3_ext').value, this.raterform.get('db3_total').value, this.raterform.get('hvac3_option_sf').value, 0, this.hvac_3_area, 0);
          this.optionalSFCalc(this.raterform.get('db4_ext').value, this.raterform.get('db4_total').value, this.raterform.get('hvac4_option_sf').value, 0, this.hvac_4_area, 0);

          var totalareas = [this.totalSF1, this.totalSF2, this.totalSF3, this.totalSF4];  
          var planareas = [Number(this.hvac_1_area), Number(this.hvac_2_area), Number(this.hvac_3_area), Number(this.hvac_4_area)];

          let sumoptareas = totalareas.reduce((prev, curr) => prev + curr, 0);
          let sumplanareas = planareas.reduce((prev, curr) => prev + curr, 0);  

          } else {

            this.hvac_1_area = 0;
            this.hvac_2_area = 0;
            this.hvac_3_area = 0;
            this.hvac_4_area = 0;
            this.hvac1_ceil_ht = 0;
            this.hvac2_ceil_ht = 0;
            this.hvac3_ceil_ht = 0;
            this.hvac4_ceil_ht = 0;
            this.bedrooms =  0;
            this.bathrooms = 0;
            this.plan_name = "No plan assigned";
            this.plan_notes ="No notes";
            this.addvol = 0;
            this.sfbe = 0;
            //this.volume = (this.hvac_1_area * this.hvac1_ceil_ht) + (this.hvac_2_area * this.hvac2_ceil_ht) + (this.hvac_3_area * this.hvac3_ceil_ht) + (this.hvac_4_area * this.hvac4_ceil_ht)  + (  (  this.raterform.get('this.hvac1_option1_sf').value +  this.raterform.get('this.hvac1_option2_sf').value) * (this.raterform.get('this.hvac1_optceilheight').value) ) + (((this.hvac2_option1_sf) + (this.hvac2_option2_sf)) * (this.hvac2_optceilheight)) + ((this.hvac3_option_sf) * (this.hvac3_optceilheight)) + ((this.hvac4_option1_sf) * (this.hvac4_optceilheight)) + parseFloat(this.addvol.toString());
            this.volume = (   this.hvac_1_area * this.hvac1_ceil_ht) + (this.hvac_2_area * this.hvac2_ceil_ht) + (this.hvac_3_area * this.hvac3_ceil_ht) + (this.hvac_4_area * this.hvac4_ceil_ht)  + (  (    parseFloat(this.raterform.get('hvac1_option1_sf').value) + parseFloat(this.raterform.get('hvac1_option2_sf').value) ) * ( parseFloat(this.raterform.get('hvac1_optceilheight').value))  )  + (  (    parseFloat(this.raterform.get('hvac2_option1_sf').value) + parseFloat(this.raterform.get('hvac2_option2_sf').value)  ) * (   parseFloat(this.raterform.get('hvac2_optceilheight').value) ) ) + (  parseFloat(this.raterform.get('hvac3_option_sf').value) * parseFloat(this.raterform.get('hvac3_optceilheight').value) ) + ( parseFloat(this.raterform.get('hvac4_option1_sf').value) * parseFloat(this.raterform.get('hvac4_optceilheight').value) ) + parseFloat(this.addvol.toString());



            this.elr = parseFloat(this.raterform.get('corcfm50').value) / this.sfbe;

            //let valuee = ( parseFloat(this.raterform.get('blower_door').value)  * 60)/ (parseFloat(this.addvol.toString()) + (parseFloat(this.hvac_1_area.toString()) * parseFloat(this.hvac1_ceil_ht.toString()  )) + (parseFloat(this.hvac_2_area.toString()  ) * parseFloat(this.hvac2_ceil_ht.toString()  )) + (parseFloat(this.hvac_3_area.toString()  ) * parseFloat(this.hvac3_ceil_ht.toString()  )) + (parseFloat(this.hvac_4_area.toString()  ) * parseFloat(this.hvac4_ceil_ht.toString()  ))  + ((parseFloat(this.hvac1_option1_sf.toString()  ) + parseFloat(this.hvac1_option2_sf.toString()  )) * parseFloat(this.hvac1_optceilheight.toString()  )) +  ((parseFloat(this.hvac2_option1_sf.toString()  ) + parseFloat(this.hvac2_option2_sf.toString()  )) * parseFloat(this.hvac2_optceilheight.toString()  )) + (parseFloat(this.hvac3_option_sf.toString()  ) * parseFloat(this.hvac3_optceilheight.toString()  )));
            let valuee = (parseFloat(this.raterform.get('blower_door').value) * 60) / (parseFloat(this.addvol.toString()) + (parseFloat(this.hvac_1_area.toString()) * parseFloat(this.hvac1_ceil_ht.toString())) + (parseFloat(this.hvac_2_area.toString()) * parseFloat(this.hvac2_ceil_ht.toString())) + (parseFloat(this.hvac_3_area.toString()) * parseFloat(this.hvac3_ceil_ht.toString())) + (parseFloat(this.hvac_4_area.toString()) * parseFloat(this.hvac4_ceil_ht.toString())) + ((parseFloat(this.raterform.get('hvac1_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac1_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac1_optceilheight').value.toString())) + ((parseFloat(this.raterform.get('hvac2_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac2_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac2_optceilheight').value.toString())) + (parseFloat(this.raterform.get('hvac3_option_sf').value.toString()) * parseFloat(this.raterform.get('hvac3_optceilheight').value.toString())));

/////////////////ACH50 here/

            this.raterform.get('ach50').setValue(Number.isNaN(valuee) || !Number.isFinite(valuee) ? "0" : valuee.toFixed(3));

            let ashraee = this.computeAshrae().toString();

            this.ashrae= parseFloat(ashraee);
            this.raterform.get('ashrae').setValue( ashraee, {onlySelf: true, emitEvent: false});

            this.dbtotalCalc(this.raterform.get('db1_total').value, this.raterform.get('hvac1_option1_sf').value, this.raterform.get('hvac1_option2_sf').value, this.hvac_1_area, 1, false);
            this.dbtotalCalc(this.raterform.get('db2_total').value, this.raterform.get('hvac2_option1_sf').value, this.raterform.get('hvac2_option2_sf').value, this.hvac_2_area, 2, false);
            this.dbtotalCalc(this.raterform.get('db3_total').value, this.raterform.get('hvac3_option_sf').value, 0, this.hvac_3_area, 3, false);
            this.dbtotalCalc(this.raterform.get('db4_total').value, this.raterform.get('hvac4_option_sf').value, 0, this.hvac_4_area, 4, false);
            this.dbextCalc(this.raterform.get('db1_ext').value, this.raterform.get('hvac1_option1_sf').value,this.raterform.get('hvac1_option2_sf').value, this.hvac_1_area, 1, false);
            this.dbextCalc(this.raterform.get('db2_ext').value, this.raterform.get('hvac2_option1_sf').value,this.raterform.get('hvac2_option2_sf').value, this.hvac_2_area, 2, false);
            this.dbextCalc(this.raterform.get('db3_ext').value, this.raterform.get('hvac3_option_sf').value,0, this.hvac_3_area, 3, false);
            this.dbextCalc(this.raterform.get('db4_ext').value, this.raterform.get('hvac4_option_sf').value,0, this.hvac_4_area, 4, false);
            this.optionalSFCalc(this.raterform.get('db1_ext').value, this.raterform.get('db1_total').value, this.raterform.get('hvac1_option1_sf').value, this.raterform.get('hvac1_option2_sf').value, this.hvac_1_area, 0);
            this.optionalSFCalc(this.raterform.get('db2_ext').value, this.raterform.get('db2_total').value, this.raterform.get('hvac2_option1_sf').value, this.raterform.get('hvac2_option2_sf').value, this.hvac_2_area, 0);
            this.optionalSFCalc(this.raterform.get('db3_ext').value, this.raterform.get('db3_total').value, this.raterform.get('hvac3_option_sf').value, 0, this.hvac_3_area, 0);
            this.optionalSFCalc(this.raterform.get('db4_ext').value, this.raterform.get('db4_total').value, this.raterform.get('hvac4_option_sf').value, 0, this.hvac_4_area, 0);

          }



        }, err => {
              //initialize bd values
              this.dbtotalCalc(this.raterform.get('db1_total').value, this.raterform.get('hvac1_option1_sf').value, this.raterform.get('hvac1_option2_sf').value, this.hvac_1_area, 1, false);
              this.dbtotalCalc(this.raterform.get('db2_total').value, this.raterform.get('hvac2_option1_sf').value, this.raterform.get('hvac2_option2_sf').value, this.hvac_2_area, 2, false);
              this.dbtotalCalc(this.raterform.get('db3_total').value, this.raterform.get('hvac3_option_sf').value, 0, this.hvac_3_area, 3, false);
              this.dbtotalCalc(this.raterform.get('db4_total').value, this.raterform.get('hvac4_option_sf').value, 0, this.hvac_4_area, 4, false);
              this.dbextCalc(this.raterform.get('db1_ext').value, this.raterform.get('hvac1_option1_sf').value,this.raterform.get('hvac1_option2_sf').value, this.hvac_1_area, 1, false);
              this.dbextCalc(this.raterform.get('db2_ext').value, this.raterform.get('hvac2_option1_sf').value,this.raterform.get('hvac2_option2_sf').value, this.hvac_2_area, 2, false);
              this.dbextCalc(this.raterform.get('db3_ext').value, this.raterform.get('hvac3_option_sf').value,0, this.hvac_3_area, 3, false);
              this.dbextCalc(this.raterform.get('db4_ext').value, this.raterform.get('hvac4_option_sf').value,0, this.hvac_4_area, 4, false);
              this.optionalSFCalc(this.raterform.get('db1_ext').value, this.raterform.get('db1_total').value, this.raterform.get('hvac1_option1_sf').value, this.raterform.get('hvac1_option2_sf').value, this.hvac_1_area, 0);
              this.optionalSFCalc(this.raterform.get('db2_ext').value, this.raterform.get('db2_total').value, this.raterform.get('hvac2_option1_sf').value, this.raterform.get('hvac2_option2_sf').value, this.hvac_2_area, 0);
              this.optionalSFCalc(this.raterform.get('db3_ext').value, this.raterform.get('db3_total').value, this.raterform.get('hvac3_option_sf').value, 0, this.hvac_3_area, 0);
              this.optionalSFCalc(this.raterform.get('db4_ext').value, this.raterform.get('db4_total').value, this.raterform.get('hvac4_option_sf').value, 0, this.hvac_4_area, 0);
        }));

    this.loadThresholds();
    this.recalculateLightPct();

    this.subscriptions.add(this.locservice.getOneLocation(this.location_id).subscribe(
      res => {
        this.subdivision_name = res.Location.subdivision_name;
        this.subdivision = res.Location.subdivision;
        this.lot = res.Location.lot;
        this.street_address = res.Location.street_address;
        this.locationTxt = this.subdivision_name.length > 0 ? this.subdivision_name + ' ' + this.lot : this.street_address;
        this.adminNotesText = res.Location.adminnotes;

        this.subscriptions.add(this.raterFormService.getSubdivisionByID(this.subdivision).subscribe(
          res => {

            if(res.Error == false){
              this.subdivisionCZ = res.Subdivision.cz;
              this.stickerLocation = res.Subdivision.stickerlocation || '';
              this.showStickerLocation = this.stickerLocation.trim().length > 0;
              this.subdivisionEnvSpecs = res.Subdivision.envspecs || '';
              this.showSubdivisionEnvSpecs = this.subdivisionEnvSpecs.trim().length > 0;
              if(res.Subdivision.consultant && res.Subdivision.consultant > 0){
                this.subscriptions.add(this.employeeService.getOneEmployee(res.Subdivision.consultant).subscribe(
                  res => {
                    this.consultant = res.employee_name ? String(res.employee_name).trim() : '';
                    this.consultantPhone = res.phone ? String(res.phone).trim() : '';
                  }))
              }
              if(this.raterform.get('elevation').value == 0 || this.raterform.get('elevation').value == null){
                this.raterform.get('elevation').setValue(res.Subdivision.elevation);
                //this.updateSingleField('elevation');
              }
            }
          }, err => {
          }
        ));
      }, err => {
      }
    ));

    this.subscriptions.add(this.raterFormService.getElevPhotos(this.location_id).subscribe(
      res => {
        if (res.Error) {
          //do nothing
          this.messager.openSnackBar('Error loading elevation photos', '', 'errorAlert');
        } else {
          this.elev_left = res.Photos.elevleft;
          this.elev_right = res.Photos.elevright;
          this.elev_front = res.Photos.elevfront;
          this.elev_back = res.Photos.elevback;
        }
      }, err => {
        this.messager.openSnackBar('Error loading elevation photos', '', 'errorAlert');
      }));

    this.class = 'hidden';
    this.initClass = 'fulldivInit';
    // set Raterform Items
    for(i=0;i<this.checklistItemsFields.length;i++){
      const values = this.checklistItemsFields[i]
      if(i != 70 )  // skipping gutextensn
      {
        this.checklistItems[i].value =this.data.formData[values] || '';
        this.checklistItems[i].note = this.data.notes[values] || '';
      }
      if(this.data.pics[values]?.length > 0){  
        this.checklistItems[i].photos.push(this.data.pics[values]) 
      }
    }

  //}


  combineLatest([
    this.raterform.get('hvac1_option1_sf').valueChanges.pipe(startWith(this.raterform.get('hvac1_option1_sf').value)),
    this.raterform.get('hvac1_option2_sf').valueChanges.pipe(startWith(this.raterform.get('hvac1_option2_sf').value)),
  ]).subscribe(() => {
    this.calculateTotalSF1();
  });

  combineLatest([
    this.raterform.get('hvac2_option1_sf').valueChanges.pipe(startWith(this.raterform.get('hvac2_option1_sf').value)),
    this.raterform.get('hvac2_option2_sf').valueChanges.pipe(startWith(this.raterform.get('hvac2_option2_sf').value)),
  ]).subscribe(() => {
    this.calculateTotalSF2();
  });

  combineLatest([
    this.raterform.get('hvac3_option_sf').valueChanges.pipe(startWith(this.raterform.get('hvac3_option_sf').value))
  ]).subscribe(() => {
    this.calculateTotalSF3();
  });

  combineLatest([
    this.raterform.get('hvac4_option1_sf').valueChanges.pipe(startWith(this.raterform.get('hvac4_option1_sf').value)),
    this.raterform.get('hvac4_option2_sf').valueChanges.pipe(startWith(this.raterform.get('hvac4_option2_sf').value)),
  ]).subscribe(() => {
    this.calculateTotalSF4();
  });
    //build summary notes
    this.checklistItems.forEach((item) => {
      if(item.note.length > 1){

        if(item.stage == 1)
        {
          this.predrywallnotesSummary += item.description.substring(0,3) + '_' + item.note + '\n';
        } else {
          this.finalnotesSummary += item.description.substring(0,3) + '_' + item.note + '\n';
        }
      }

      if(item.value.includes('/')){
        item.value = 'NA';
      }

    })
    //address
    this.subscriptions.add(this.raterFormService.getLocationData(this.data.location_id).subscribe(
      (res) => {
        this.subdivision_name = res.Location.subdivision_name;
        this.lot = res.Location.lot;
        this.street_address = res.Location.street_address;
        this.weatherlocation = res.weatherloc;
      }, err => {
      }
    ));


let val = (parseFloat(this.raterform.get('blower_door').value) * 60) / (parseFloat(this.addvol.toString()) + (parseFloat(this.hvac_1_area.toString()) * parseFloat(this.hvac1_ceil_ht.toString())) + (parseFloat(this.hvac_2_area.toString()) * parseFloat(this.hvac2_ceil_ht.toString())) + (parseFloat(this.hvac_3_area.toString()) * parseFloat(this.hvac3_ceil_ht.toString())) + (parseFloat(this.hvac_4_area.toString()) * parseFloat(this.hvac4_ceil_ht.toString())) + ((parseFloat(this.raterform.get('hvac1_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac1_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac1_optceilheight').value.toString())) + ((parseFloat(this.raterform.get('hvac2_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac2_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac2_optceilheight').value.toString())) + (parseFloat(this.raterform.get('hvac3_option_sf').value.toString()) * parseFloat(this.raterform.get('hvac3_optceilheight').value.toString())));
//let val = ((this.raterform.get('blower_door').value) * 60) / ((this.addvol) + ((this.hvac_1_area) * (this.hvac1_ceil_ht)) + ((this.hvac_2_area) * (this.hvac2_ceil_ht)) + ((this.hvac_3_area) * (this.hvac3_ceil_ht)) + ((this.hvac_4_area) * (this.hvac4_ceil_ht)) + (((this.hvac1_option1_sf) + (this.hvac1_option2_sf)) * (this.hvac1_optceilheight)) + (((this.hvac2_option1_sf) + (this.hvac2_option2_sf)) * (this.hvac2_optceilheight)) + ((this.hvac3_option_sf) * (this.hvac3_optceilheight)));
    this.ach50 = (Number.isNaN(val) || !Number.isFinite(val) ? "0" : val.toFixed(3));
    //this.ashrae = (7.5 * (1 + parseFloat(this.bedrooms.toString())) + ((parseFloat(this.hvac_1_area.toString()) + parseFloat(this.hvac_2_area.toString()) + parseFloat(this.hvac_3_area.toString()) + parseFloat(this.hvac_4_area.toString())) / 100));
    //this.raterform.get('ashrae').setValue(this.ashrae,{onlySelf: true, emitEvent: false});
    this.subscriptions.add(this.raterFormService.getElevPhotos(this.data.location_id).subscribe(
      (res) => {
        this.elev_left = res.Photos.elevleft;
        this.elev_right = res.Photos.elevright;
        this.elev_front = res.Photos.elevfront;
        this.elev_back = res.Photos.elevback;
      }, err => {
      }));
    //job scope

    // set CSS default classes for checklist items
    for (let index = 0; index < this.checklist.length; ++index) {
      this.checklistClasses[index] = this.setClass(this.checklist[index]);
    }

    //
    this.warningCheck(true,0);
  }

  updateThresholdText(): void {

    var threshtext1 = document.getElementById('threshtext_1');
    var threshtext2 = document.getElementById('threshtext_2');

    if(threshtext1 && threshtext2){
        if(this.thresholds && this.raterform.get('blower_door').value <=  this.thresholds.cfm50){
          threshtext1.classList.remove('redthreshtext');
          threshtext1.classList.add('greenthreshtext');
          
          threshtext2.classList.remove('redthreshtext');
          threshtext2.classList.add('greenthreshtext');
          
        }else if(this.thresholds && this.raterform.get('blower_door').value >  this.thresholds.cfm50){
            threshtext1.classList.remove('greenthreshtext');
            threshtext1.classList.add('redthreshtext');
            threshtext2.classList.remove('greenthreshtext');
            threshtext2.classList.add('redthreshtext');
        }
    }
  }

  loadThresholds(): void {
        this.raterFormService.getThresholdData(this.data.formData.location_id).subscribe(
          res => {
            if(!res.Error){
            this.thresholds = {
              ...this.thresholds,
              cfm50 : Number.parseFloat(res.ThresholdValues.cfm50).toFixed(1) || 0,
              lto : Number.parseFloat(res.ThresholdValues.lto).toFixed(1) || 0
            }
          }else {
            this.thresholds = {
              ...this.thresholds,
              cfm50 : 0,
              lto : 0
            }
          } 
        });
  }

  
  calculateTotalSF1(): void {
    const hvac1Option1SF = this.raterform.get('hvac1_option1_sf').value || 0;
    const hvac1Option2SF = this.raterform.get('hvac1_option2_sf').value || 0;
    this.totalSF1 =(Number(this.hvac_1_area) + Number(hvac1Option1SF) + Number(hvac1Option2SF))
  }

  calculateTotalSF2(): void {
    const hvac1Option1SF = this.raterform.get('hvac2_option1_sf').value || 0;
    const hvac1Option2SF = this.raterform.get('hvac2_option2_sf').value || 0;
    this.totalSF2 =  (Number(this.hvac_2_area) + Number(hvac1Option1SF) + Number(hvac1Option2SF))
  }

  calculateTotalSF3(): void {
    const hvac1Option1SF = this.raterform.get('hvac3_option_sf').value || 0;
    const hvac1Option2SF = 0;
    this.totalSF3 = (Number(this.hvac_3_area) + Number(hvac1Option1SF) + Number(hvac1Option2SF))  }

  calculateTotalSF4(): void {
    const hvac1Option1SF = this.raterform.get('hvac4_option1_sf').value || 0;
    const hvac1Option2SF = this.raterform.get('hvac4_option2_sf').value || 0;
    this.totalSF4 = (Number(this.hvac_4_area) + Number(hvac1Option1SF) + Number(hvac1Option2SF)); // .toFixed(2) if you need decimal precision
  }

  getStickerFloorValue(): string {
    const foundationType = (this.raterform.get('foundation_type').value || '').toLowerCase();
    const floorAboveGarage = this.raterform.get('floor_above_garage').value || '';
    const cantileverFloor = this.raterform.get('cantilever_floor').value || '';
    const firstFloor = this.raterform.get('_1st_floor').value || '';

    if (foundationType.includes('slab') || foundationType.includes('cond crawl') || foundationType.includes('conditioned crawl') || foundationType.includes('cond bsmt')) {
      return floorAboveGarage || cantileverFloor || '';
    } else if (foundationType.includes('vented crawl') || foundationType.includes('uncon bsmt')) {
      return firstFloor;
    }
    return firstFloor;
  }



  clearOut(fieldName:string, value?:string):void {
    this.raterform.controls[fieldName].setValue('', {onlySelf: true, emitEvent: false});
    this.updateSingleField(fieldName);
  }

  clearSquareFootage(number){

    if(number < 3){
      this.raterform.get(`hvac${number}_option1_sf`).setValue(0);
      this.raterform.get(`hvac${number}_option2_sf`).setValue(0);
      this.raterform.get(`hvac${number}_optceilheight`).setValue(0);
    }else {
      this.raterform.get(`hvac${number}_option_sf`).setValue(0);
      this.raterform.get(`hvac${number}_optceilheight`).setValue(0);
    }


  }

  /*
  * Function for checking Duct % and displaying warnings
  */
  checkWarning(isInit: boolean){
    if(this.raterform.get('hvac1name').value.length > 1 ){
      if(   (this.raterform.get('noreturn1').value < 3 && this.raterform.get('hvac1totpcnt').value > 8.0) && (this.raterform.get('noreturn1').value >= 3 && this.raterform.get('hvac1totpcnt').value > 12.0) && (this.raterform.get('hvac1extpcnt').value > 4)  ){
        this.isWarning = true
      }else if(  (this.raterform.get('noreturn1').value >= 3 && this.raterform.get('hvac1totpcnt').value > 12.0)  ){
        this.isWarning = true

      }else if (this.raterform.get('hvac1extpcnt').value > 4){
        this.isWarning = true
      }
      else {
        this.isWarning = false;
      }
    }
    //check for system 2
      else if(this.raterform.get('hvac2name').value.length > 1 )
      {
        if(  this.raterform.get('noreturn2').value < 3 && this.raterform.get('hvac2totpcnt').value > 8.0     ){
          this.isWarning = true
        }else if(this.raterform.get('noreturn2').value >= 3 && this.raterform.get('hvac2totpcnt').value > 12.0 ){
          this.isWarning = true
        }else if (this.raterform.get('hvac2extpcnt').value > 4){
          this.isWarning = true
        }
        else {
          this.isWarning = false;
        }
      }

    //check for system 3
      else if(this.raterform.get('hvac3name').value.length > 1 )
      {
        if(this.raterform.get('noreturn3').value < 3 && this.raterform.get('hvac3totpcnt').value > 8.0 ){
          this.isWarning = true
        }else if(this.raterform.get('noreturn3').value >= 3 && this.raterform.get('hvac3totpcnt').value > 12.0 ){
          this.isWarning = true
        }else if (this.raterform.get('hvac3extpcnt').value > 4){
          this.isWarning = true
        }
        else {
          this.isWarning = false;
        }
      }


    //check for system 4

      else if(this.raterform.get('hvac4name').value.length > 1 )
      {
        if(this.raterform.get('noreturn4').value < 3 && this.raterform.get('hvac4totpcnt').value > 8.0 ){
          this.isWarning = true
        }else if(this.raterform.get('noreturn4').value >= 3 && this.raterform.get('hvac4totpcnt').value > 12.0 ){
          this.isWarning = true
        }else if (this.raterform.get('hvac4extpcnt').value > 4){
          this.isWarning = true
        }
        else {
          this.isWarning = false;
        }
      }


    if(isInit && this[`isWarning`] == true){
      this.dialog.open(ESLeakageDialogComponent, {
        width: '300px',
        height: '340px',
      })
    }



  }

  warningCheck(isInit: boolean, systemno){

    this.cdr.detectChanges();

    //check for system 1
    if(systemno == 1 || systemno == 0){
      if(   (this.raterform.get('noreturn1').value < 3 && this.raterform.get('hvac1totpcnt').value > 8.0) && (this.raterform.get('noreturn1').value >= 3 && this.raterform.get('hvac1totpcnt').value > 12.0) && (this.raterform.get('hvac1extpcnt').value > 4)  ){
        this.isWarning1 = true
      }else if(  (this.raterform.get('noreturn1').value >= 3 && this.raterform.get('hvac1totpcnt').value > 12.0)  ){
        this.isWarning1 = true
      }else if (this.raterform.get('hvac1extpcnt').value > 4){
        this.isWarning1 = true
      }
      else {
        this.isWarning1 = false;
      }
    }
    //check for system 2
    if(systemno == 2 || systemno == 0){
      if(this.raterform.get('hvac2name').value.length > 1 )
      {
        if(  this.raterform.get('noreturn2').value < 3 && this.raterform.get('hvac2totpcnt').value > 8.0     ){
          this.isWarning2 = true
        }else if(this.raterform.get('noreturn2').value >= 3 && this.raterform.get('hvac2totpcnt').value > 12.0 ){
          this.isWarning2 = true
        }else if (this.raterform.get('hvac2extpcnt').value > 4){
          this.isWarning2 = true
        }
        else {
          this.isWarning2 = false;
        }
      }
    }

    //check for system 3
    if(systemno == 3 || systemno == 0){
      if(this.raterform.get('hvac3name').value.length > 1 )
      {
        if(this.raterform.get('noreturn3').value < 3 && this.raterform.get('hvac3totpcnt').value > 8.0 ){
          this.isWarning3 = true
        }else if(this.raterform.get('noreturn3').value >= 3 && this.raterform.get('hvac3totpcnt').value > 12.0 ){
          this.isWarning3 = true
        }else if (this.raterform.get('hvac3extpcnt').value > 4){
          this.isWarning3 = true
        }
        else {
          this.isWarning3 = false;
        }
      }
    }


    //check for system 4
    if(systemno == 4 || systemno == 0)
    {
      if(this.raterform.get('hvac4name').value.length > 1 )
      {
        if(this.raterform.get('noreturn4').value < 3 && this.raterform.get('hvac4totpcnt').value > 8.0 ){
          this.isWarning4 = true
        }else if(this.raterform.get('noreturn4').value >= 3 && this.raterform.get('hvac4totpcnt').value > 12.0 ){
          this.isWarning4 = true
        }else if (this.raterform.get('hvac4extpcnt').value > 4){
          this.isWarning4 = true
        }
        else {
          this.isWarning4 = false;
        }
      }
    }


    this.cdr.detectChanges();

    if(!isInit && this[`isWarning${systemno}`] == true){
      this.dialog.open(ESPercentDialogComponent, {
        width: '300px',
        height: '300px',
      })
    }




  }

  getLowerBound(tonnage): number {
    const entry = this.tonnageTable.find(item => item.tonnage === tonnage);
    if (entry) {
      return entry.lowerbound;
    } else {
      return 0;
    }
  }

  getUpperBound(tonnage): number {
    // Search tonnageTable for the correct tonnage and return the upper bound property
    const entry = this.tonnageTable.find(item => item.tonnage === tonnage);
    if (entry) {
      return entry.upperbound;
    } else {
      return 0;
    }
  }

  isNumberFunc(value) {
    return !isNaN(Number(value));
  }
  

  getGradingTotalAirflow(locNum: number = -1): number {

    if(locNum == -1){
      return 0;
    } else {

        //for each item in syslocs, add airflow to total
        let total = 0;
        this[`sys${locNum}grade`].syslocs.forEach((item) => {
          total += Number(item.airflow);
        });
        return total;

    }

  }



getAirflowGrade(measurement: number, totalAirflow: number, manual: boolean): string {
  if(measurement == 0 || measurement == null){
    return "N/A";
  }

  let manualDesignAirflow = measurement; 
  
  if (!manual) {
    const airflowFactor = this.raterform.get('cfm_per_ton').value || 400;
    manualDesignAirflow = measurement * airflowFactor;
  }
    
  return this.getAirflowGradePcnt(manualDesignAirflow, totalAirflow);
}

getAirflowGradePcnt(manualDesignAirflow: number, totalAirflow: number): string {
    this.rangeText = '';
    const percentageDiff = (totalAirflow - manualDesignAirflow) / Math.abs(manualDesignAirflow) * 100;
    
    //Per Matthew's request, always show grade one range. 
    const lowerRange = manualDesignAirflow * 0.85;
    const upperRange = manualDesignAirflow * 1.15;

    this.rangeText =  `Grade 1: ${Math.round(lowerRange)} <-> ${Math.round(upperRange)}`;
    
    if (percentageDiff >= -15 && percentageDiff < 15) {
        // Grade 1: -15% to +15%
        return "Grade 1";
    } else if ((percentageDiff >= -25 && percentageDiff < -15) || (percentageDiff >= 15 && percentageDiff < 25)) {
        // Grade 2: -25% to -15% OR +15% to +25%
        let lowerRange, upperRange;
        if (percentageDiff < 0) {
            lowerRange = manualDesignAirflow * 0.75;
            upperRange = manualDesignAirflow * 0.85;
        } else {
            lowerRange = manualDesignAirflow * 1.15;
            upperRange = manualDesignAirflow * 1.25;
        }
        return "Grade 2";
    } else {
        // Grade 3: ≤ -25% OR ≥ +25%
        let displayText;
        if (percentageDiff <= -25) {
            const limit = manualDesignAirflow * 0.75;
            displayText = `Grade 3 range: < ${Math.round(limit)} CFM`;
        } else {
            const limit = manualDesignAirflow * 1.25;
            displayText = `Grade 3 range: > ${Math.round(limit)} CFM`;
        }
        return "Grade 3";
    }
}


  isAreaValid(): boolean {
    return this.raterform.get('airFlow')?.value && this.raterform.get('locationName')?.value;
  }


  addGradeLocation(locNum: number): void {


    const name = this.raterform.get('locationName')?.value;
    const airflow = this.raterform.get('airFlow')?.value;

    if(this.isNumberFunc(airflow)){
 
      if ((name && airflow !== null)) {
        this[`sys${locNum}grade`].syslocs.push({ name, airflow });

        var value = `${name} - ${airflow}`;
        this.subscriptions.add(this.raterFormService.updateRFLog(`System_${locNum}_syslocs (room)`, this.form_id, value, (this.usernamee || 'Inspector')).subscribe(
          res => {
            if (res.Error) {
            }
          }, err => {
    
          }
        ));

        // Reset form fields
        this.raterform.patchValue({
          locationName: '',
          airFlow: null
        });

        this.calculateGrade();
      }else{
        this.messager.openSnackBar('Please ensure that location name AND airflow are filled in.', '', 'errorAlert');
      }

    }else{
    }

    
  }


  setSelectedItem(menuNumber): void {

    this.selectedItem = menuNumber;
    //let el = document.getElementById('chklistitems');

    //reset preset notes array
    if (menuNumber == 0) {
      this.presetArray = this.displayPresets('gen');
      this.checkWarning(true)
    }

    if (menuNumber == 4) {
      this.recalculateLightPct();
    }


    let tabItem = document.querySelectorAll(".tab-item");
    tabItem.forEach((item: any, index: any) => {
      item.classList.remove("active")
    })
    switch (menuNumber) {
      case 1:
        let el1 = document.getElementById('item1');
        el1.classList.add("active");
        break;
      case 2:
        let el2 = document.getElementById('item2');
        el2.classList.add("active");
        //this.updateThresholdText();
        break;
      case 3:
        let el3 = document.getElementById('item3');
        el3.classList.add("active");
        break;
      case 4:
        let el4 = document.getElementById('item4');
        el4.classList.add("active");
        break;
      case 5:
        let el5 = document.getElementById('item5');
        el5.classList.add("active");
        break;
      case 6:
        let el6 = document.getElementById('item6');
        el6.classList.add("active");
        break;
      case 7:
        let el7 = document.getElementById('item7');
        el7.classList.add("active");
        break;
      case 8:
      let el8 = document.getElementById('item8');
      el8.classList.add("active");
      break;
      case 9:
        let el9 = document.getElementById('item9');
        el9.classList.add("active");
        break;
    }
  }



  displayPresets(itemNo) {

    let currItems = [];

    this.raterNotePresets.forEach(function (preset) {
      if (itemNo == preset.itemno) {
        currItems.push(preset);
      }
    });

    return currItems;

  }



  setInspectionType(inspection: number): void {
    this.inspectionType = inspection;
  }

  setMFInspectionType(inspection: number): void {
    this.mfinspectionType = inspection;
  }

  onFileUpload(): void {

  }


  getMultifamilyData(form_id): void {
    this.raterFormService.getMultifamilyData(form_id).subscribe(
      res => {
        this.multifamilyData = res.Response.mfdata;
        this.multifamilyLoaded = true;

        return;
      }, err => {
        this.multifamilyLoaded = false;
        this.multifamilyData = {};
        return;
      })

  }

  checkAffBoxes(log: boolean = true): void {

  this.raterform.get('aff').setValue(true); 
  this.showAff = true;
    let affBoxes = [
      'r6_corner', 
      'ins_headr', 
      'min_wind_dr_framing', 
      'ins_wall_intersect', 
      'min_stud_spacing'
    ];
    affBoxes.forEach((item) => {
      const value = this.raterform.get(item).value;
      if(!value?.toLowerCase().includes('verified')){
        this.raterform.get('aff').setValue(false); 
        this.showAff = false;
      }
    })

    if(log){
      this.updateSingleField('aff');
    }
  }

  updateSingleFieldChecklist(selectedIndex) {

    let value = this.checklistItems[selectedIndex].value;
    let name = this.checklistItems[selectedIndex].field;

    this.subscriptions.add(this.raterFormService.updateSingleField(name, this.form_id, value).subscribe(
      res => {

        if (res.Error) {
          this.messager.openSnackBar(res.Message, '', 'errorAlert');
        }
        else {
          //update RF log
          this.subscriptions.add(this.raterFormService.updateRFLog(name, this.form_id, value, (this.usernamee || 'Inspector')).subscribe(
            res => {
              if (res.Error) {
              }
            }, err => {

            }
          ));
          //this.messager.openSnackBar(res.Message, '', 'successAlert');
        }

      }, err => {
      }
    ));


  }

  updateSingleField(name, background = false) {

    if(name == 'numpa'){
      if(parseFloat(this.raterform.get(name).value) < 0){
        this.messager.openSnackBar('Positive values only for Pascal Reading!', '', 'errorAlert');
        this.raterform.get(name).setValue(0);
        return;
      }
    }


    if(this.initialValue == this.raterform.get(name).value){
      return; 
    }
    if(!this.data.noSave){
      this.cdr.detectChanges;

      let value = this.raterform.controls[name].value;

      this.subscriptions.add(
        this.raterFormService.updateSingleField(name, this.form_id, value).subscribe(
        res => {

            this.subscriptions.add(this.raterFormService.updateRFLog(name, this.form_id, value, (this.usernamee || 'Inspector')).subscribe(
              res => {
                if (res.Error) {
                }
              }, err => {

              }
            ));
          if (res.Error) {
            let elem = document.getElementById(name);
            elem.style.color = '#c30000;';
            elem.style.backgroundColor = 'pink';
            //elem.style.height = '40px';
            this.messager.openSnackBar('Field: ' + name + ' ' + res.Message, '', 'errorAlert');

          }
          else {

            let elem = document.getElementById(name);
            elem.style.color = '#c30000;';
            elem.style.backgroundColor = '#e7f6e5';

            if (background) {
              let fieldname = name;
              //let fieldname = name + '-div';
              document.getElementById(name).style.backgroundColor = '#cdf1cd !important;';
            } else {
              document.getElementById(name).style.color = '#04c004 !important;';
            }
          }
        }, err => {
        }
      ));
    }
  }

  setInitialValue(name){
    this.initialValue = this.raterform.get(name).value;
  }

  displayFunctionMF(obj: any){
    if (obj) {return obj.name; }
  }

  bail(): void {
    let changedProperties = [];
    Object.keys(this.raterform.controls).forEach((name) => {
      const currentControl = this.raterform.controls[name];

      if (currentControl.dirty) {
        changedProperties.push(name + ': ' + this.raterform.controls[name].value);

        this.subscriptions.add(this.raterFormService.updateSingleField(name, this.form_id, this.raterform.controls[name].value).subscribe(
          res => {
            if (res.Error) {
              document.getElementById(name).className = 'fieldError';
              document.getElementById(name).style.backgroundColor = 'red';
              this.log.error('Rater experienced an error bailing for' + this.street_address + ': ' + name + ' _' + res.Message);
              this.messager.openSnackBar('Error with field: ' + name + ' ' + res.Message, '', 'errorAlert');
            } else {
              document.getElementById(name).classList.remove('fieldError');
              //document.getElementById(name).className = 'mat-form-field';

              //this.messager.openSnackBar('Saved: ' + name + ' with value ' + this.raterform.controls[name].value, '', 'successAlert');
            }
          }, err => {
            this.log.error('Rater experienced an app error bailing for ' + this.street_address);
          }));

      }




    });

    let bigObj = {
      rfvalue : this.raterform.value,
      clitems : this.checklistItems,
      photos : this.data.pics,
    }

    this.messager.openSnackBar('Email with all of this form\'s input data sent to support.', '[close]', 'successAlert');

    this.subscriptions.add(this.ges.sendDebugEmail('IMPORTANT', bigObj, 'Raterform: ' + this.street_address + '_ ' + this.subdivision_name + '- ' + this.lot, 'Bailed').subscribe(
      res => {
        if (res.Error) {
          this.log.error('Error sending bail email for raterform page: ' + res.Message)
        } else {
          this.log.info('Bail email sent to support from the raterform page for ' + this.street_address + '_ ' + this.subdivision_name + '- ' + this.lot);
        }
      }, err => {
        this.log.error('Application error sending bail email: ' + err.toString());
      }));

  }




  getPhotoCardID(currIndex: number,mf: boolean = false): string {
    if(mf){
      return "mfchklstphoto_" + currIndex;
    }else {
      return "chklstphoto_" + currIndex;
    }
  }


  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.tags.filter(tag => tag.displayname.toLowerCase().includes(filterValue));
  }


  dbtotalCalc(db_total, hvac_option_sf, hvac_option_sf2, hvac_area, totpcnt, updateLog) {
    let value = 100 * parseFloat(db_total) / (1 + (parseFloat(hvac_option_sf)) + (parseFloat(hvac_option_sf2)) + parseFloat(hvac_area));



    this.volume = (   this.hvac_1_area * this.hvac1_ceil_ht) + (this.hvac_2_area * this.hvac2_ceil_ht) + (this.hvac_3_area * this.hvac3_ceil_ht) + (this.hvac_4_area * this.hvac4_ceil_ht)  + (  (    parseFloat(this.raterform.get('hvac1_option1_sf').value) + parseFloat(this.raterform.get('hvac1_option2_sf').value) ) * ( parseFloat(this.raterform.get('hvac1_optceilheight').value))  )  + (  (    parseFloat(this.raterform.get('hvac2_option1_sf').value) + parseFloat(this.raterform.get('hvac2_option2_sf').value)  ) * (   parseFloat(this.raterform.get('hvac2_optceilheight').value) ) ) + (  parseFloat(this.raterform.get('hvac3_option_sf').value) * parseFloat(this.raterform.get('hvac3_optceilheight').value) ) + ( parseFloat(this.raterform.get('hvac4_option1_sf').value) * parseFloat(this.raterform.get('hvac4_optceilheight').value) ) + parseFloat(this.addvol.toString());


    if (totpcnt === 1) {
      this.raterform.get('hvac1totpcnt').setValue(Number.isNaN(value) || !Number.isFinite(value) ? "0" : value.toFixed(3).toString());

        if (updateLog) {
          this.updateSingleField('hvac1totpcnt', this.raterform.get('hvac1totpcnt').value);
        }
    } else if (totpcnt === 2) {
      this.raterform.get('hvac2totpcnt').setValue(Number.isNaN(value) || !Number.isFinite(value) ? "0" : value.toFixed(3).toString());
        if (updateLog) {
          this.updateSingleField('hvac2totpcnt', this.raterform.get('hvac2totpcnt').value);
        }
    } else if (totpcnt === 3) {
      this.raterform.get('hvac3totpcnt').setValue(Number.isNaN(value) || !Number.isFinite(value) ? "0" : value.toFixed(3).toString());
        if (updateLog) {
          this.updateSingleField('hvac3totpcnt', this.raterform.get('hvac3totpcnt').value);
        }
    } else if (totpcnt === 4) {
      this.raterform.get('hvac4totpcnt').setValue(Number.isNaN(value) || !Number.isFinite(value) ? "0" : value.toFixed(3).toString());
        if (updateLog) {
          this.updateSingleField('hvac4totpcnt', this.raterform.get('hvac4totpcnt').value);
        }
    }

  }

  dbextCalc(db_ext, hvac_option_sf, hvac_option_sf2, hvac_area, extpcnt, updateLog) {
    let value = 100 * parseFloat(db_ext) / (1 + (parseFloat(hvac_option_sf)) + (parseFloat(hvac_option_sf2)) + parseFloat(hvac_area));


    switch (extpcnt) {
      case 1:
        this.raterform.get('hvac1extpcnt').setValue(Number.isNaN(value) || !Number.isFinite(value) ? "0" : value.toFixed(3).toString());
          if(updateLog){
            this.updateSingleField('hvac1extpcnt', this.raterform.get('hvac1extpcnt').value);
          }
        break;
      case 2:
        this.raterform.get('hvac2extpcnt').setValue(Number.isNaN(value) || !Number.isFinite(value) ? "0" : value.toFixed(3).toString());
        if(updateLog){
          this.updateSingleField('hvac2extpcnt', this.raterform.get('hvac2extpcnt').value);
        }
        break;
      case 3:
        this.raterform.get('hvac3extpcnt').setValue(Number.isNaN(value) || !Number.isFinite(value) ? "0" : value.toFixed(3).toString());
        if(updateLog){
          this.updateSingleField('hvac3extpcnt', this.raterform.get('hvac3extpcnt').value);
        }
        break;
      case 4:
        this.raterform.get('hvac4extpcnt').setValue(Number.isNaN(value) || !Number.isFinite(value) ? "0" : value.toFixed(3).toString());
        if(updateLog){
          this.updateSingleField('hvac4extpcnt', this.raterform.get('hvac4extpcnt').value);
        }
        break;
    }
  }

  optionalSFCalc(db_ext, db_tot, hvac_option_sf, hvac_option_sf2, hvac_area, system) {

    this.dbextCalc(db_ext, hvac_option_sf, hvac_option_sf2, hvac_area, system, true);
    this.dbtotalCalc(db_tot, hvac_option_sf, hvac_option_sf2, hvac_area, system, true);


  }

  optionalSFHeightWarningCheck(): void{

    if(this.hvac_1_area > 0){

    for (var i = 1;i <5; i++){
      if(this.raterform.get(`hvac${i}_optceilheight`).value != 0){
        this.messager.openSnackBar("WARNING! You are changing the ACH50. ", '[close]', 'errorAlert');
        break;
      }
    }

  }


  }


  checkMinimum() {


    let errorString = '';

    // toastr.error("form!");
    if (this.raterform.get('blower_door').value == 0 && this.isFinal) {
      errorString += 'This job requires BLOWER DOOR to be filled in! \n';
    }

    if (this.raterform.get('close_dryer_fuel').value == null && this.isFinal) {
      errorString += 'This job requires CLOTHES DRYER FUEL (final tab) to be filled in! \n';
    }

    if (this.raterform.get('rangefueltype').value == null && this.isFinal) {
      errorString += 'This job requires RANGE FUEL TYPE (final tab) to be filled in! \n';
    }

    if (this.raterform.get('orientation').value == null && this.isFinal) {
      errorString += 'This job requires ORIENTATION (envelope tab) to be filled in! \n';
    }

    if (this.raterform.get('flat_ceilings').value == null && this.isFinal) {
      errorString += 'This job requires FLAT CEILINGS (envelope tab) to be filled in! \n';
    }

    if (this.raterform.get('window_u').value == 0 && this.isFinal) {
      errorString += 'This job requires WINDOW U (envelope tab) to be filled in! \n';
    }

    if (this.raterform.get('window_shgc').value == 0 && this.isFinal) {
      errorString += 'This job requires WINDOW SHGC (envelope tab) to be filled in! \n';
    }

    if (this.raterform.get('agw').value == null && this.isFinal) {
      errorString += 'This job requires AGW R VALUE (envelope tab) to be filled in! \n';
    }

    if (this.raterform.get('band').value == null && this.isFinal) {
      errorString += 'This job requires BAND R VALUE (envelope tab) to be filled in! \n';
    }

    if (this.raterform.get('floor_above_garage').value == null && this.isFinal) {
      errorString += 'This job requires FLOOR ABOVE GARAGE R VALUE (envelope tab) to be filled in! \n';
    }

    if (this.raterform.get('cantilever_floor').value == null && this.isFinal) {
      errorString += 'This job requires CANTILEVER FLOOR (envelope tab) to be filled in! \n';
    }

    if (this.raterform.get('foundation_type').value == null && this.isFinal) {
      errorString += 'This job requires FOUNDATION TYPE (envelope tab) to be filled in! \n';
    }

    if (this.raterform.get('fdn_r').value == null && this.isFinal) {
      errorString += 'This job requires FOUNDATION R VALUE (envelope tab) to be filled in! \n';
    }

    if (this.raterform.get('_1st_floor').value == null && this.isFinal) {
      errorString += 'This job requires 1st Floor (envelope tab) to be filled in! \n';
    }


    if (((!this.data.pics.e_coil_1_mn) || (!this.data.pics.c_coil_1_mn) || (!this.data.pics.ahu_furn_1_mn)) && this.isFinal) {
      errorString += 'Make sure you have E-COIL, C-COIL and AHU/FURNACE pictures taken (final tab) for system #1 of this job \n';
    }

     if(this.raterform.get('hvac2name').value && ( (!this.data.pics.e_coil_2_mn   && !this.data.pics.e_coil_2_mn  ) || (!this.data.pics.c_coil_2_mn   && this.data.pics.c_coil_2_mn  ) || (!this.data.pics.ahu_furn_2_mn  && this.data.pics.ahu_furn_2_mn  ) ) && this.isFinal){
       errorString += 'Make sure you have E-COIL, C-COIL and AHU/FURNACE pictures taken (final tab) for system #2 of this job \n';
     }

     if(this.raterform.get('hvac3name').value && ( (!this.data.pics.e_coil_3_mn   && !this.data.pics.e_coil_3_mn ) || (!this.data.pics.c_coil_3_mn   && this.data.pics.c_coil_3_mn ) || (!this.data.pics.ahu_furn_3_mn    && this.data.pics.ahu_furn_3_mn  ) ) && this.isFinal){
       errorString += 'Make sure you have E-COIL, C-COIL and AHU/FURNACE pictures taken (final tab) for system #3 of this job \n';
     }

     if(this.raterform.get('hvac4name').value && ( (!this.data.pics.e_coil_4_mn   && !this.data.pics.e_coil_4_mn ) || (!this.data.pics.c_coil_4_mn   && this.data.pics.c_coil_4_mn ) || (!this.data.pics.ahu_furn_4_mn    && this.data.pics.ahu_furn_4_mn ) ) && this.isFinal){
       errorString += 'Make sure you have E-COIL, C-COIL and AHU/FURNACE pictures taken (final tab) for system #4 of this job \n';
     }

    return errorString;

  }


  toggleReviewMode(): void {
    this.reviewMode = !this.reviewMode;
  }

  toggleImageMode(): void {
    this.highImage = !this.highImage;
  }


  savef(): void {
    this.messager.openSnackBar('Saved', '', 'successAlert');
  }



  saveHvacGrading(showMessage: boolean = false, spanid: string[] = []): void {

    let sysGradeObj = {};
    for(let i = 1; i <= 4; i++){
      if(this.raterform.get(`hvac${i}name`).value || i == 1){
        if(i == 1 && this.raterform.get(`hvac${i}name`).value.length < 1){
          this[`sys${i}grade`].name = 'Whole House';
        }else {
          this[`sys${i}grade`].name = this.raterform.get(`hvac${i}name`).value;
        }
        sysGradeObj[`system${i}`] = this[`sys${i}grade`]
      }
    }

    if(Object.keys(sysGradeObj).length === 0){
      return;
    } else {
      this.raterFormService.saveHVACGrading(sysGradeObj, this.form_id).subscribe(
        res => {
          if(showMessage){
            this.messager.openSnackBar('HVAC Grading Saved!', '', 'successAlert');
          }
          if(spanid.length > 0){
            for(let i = 0; i < spanid.length; i++){
                let el = document.getElementById(spanid[i]);
              if(el){
                el.classList.remove('svgHidden');
                el.classList.add('svgVisible');
              }
            }
          }
        },err => {
          this.messager.openSnackBar('Error saving HVAC grading!', '', 'errorAlert');
        } 
      )
    }
  } 

  save(): void {


    //this.formSubcription.unsubscribe();
    //map chekclistItems array to raterform object

      if(this.raterform.get('numpa').value < 0) {
        this.messager.openSnackBar('Positive values only for Pascal Reading!', '', 'errorAlert');
        this.raterform.get('numpa').setValue(0);
        return;
      }
    //handle multifamily

    if(this.templateName.length > 1){
      this.saveMF(this.fcs.getData(),false);
    }


    this.raterform.get('fenlevels').setValue(this.checklistItems[0].value);
    this.raterform.get('insmeets').setValue(this.checklistItems[1].value);
    this.raterform.get('insachieve').setValue(this.checklistItems[2].value);
    this.raterform.get('dropped_ceiling_soffit').setValue(this.checklistItems[3].value);
    this.raterform.get('wall_b_shower_tub').setValue(this.checklistItems[4].value);
    this.raterform.get('attic_knee_walls').setValue(this.checklistItems[5].value);
    this.raterform.get('wall_a_porch_roof').setValue(this.checklistItems[6].value);
    this.raterform.get('double_walls').setValue(this.checklistItems[7].value);
    this.raterform.get('flr_o_unconbsmt_crawl').setValue(this.checklistItems[8].value);
    this.raterform.get('cantilevered_floor').setValue(this.checklistItems[9].value);
    this.raterform.get('r21_o_wall').setValue(this.checklistItems[10].value);
    this.raterform.get('slab_edge_insulation').setValue(this.checklistItems[11].value);
    this.raterform.get('r21_attic_platform').setValue(this.checklistItems[12].value);
    this.raterform.get('ins_sheathing').setValue(this.checklistItems[13].value);
    this.raterform.get('sip').setValue(this.checklistItems[14].value);
    this.raterform.get('r6_corner').setValue(this.checklistItems[15].value);
    this.raterform.get('ins_headr').setValue(this.checklistItems[16].value);
    this.raterform.get('min_wind_dr_framing').setValue(this.checklistItems[17].value);
    this.raterform.get('ins_wall_intersect').setValue(this.checklistItems[18].value);
    this.raterform.get('min_stud_spacing').setValue(this.checklistItems[19].value);
    this.raterform.get('duct_flue_shaft').setValue(this.checklistItems[20].value);
    this.raterform.get('attic_dropdown').setValue(this.checklistItems[21].value);
    this.raterform.get('recessed_light').setValue(this.checklistItems[22].value);
    this.raterform.get('sealedtopplate').setValue(this.checklistItems[23].value);
    this.raterform.get('sealedwindows').setValue(this.checklistItems[24].value);
    this.raterform.get('sealedmarriagejointsmodhomes').setValue(this.checklistItems[25].value);
    this.raterform.get('door_to_uncon').setValue(this.checklistItems[26].value);
    this.raterform.get('sealedsillplate').setValue(this.checklistItems[27].value);
    this.raterform.get('sealed_common_wall').setValue(this.checklistItems[28].value);
    this.raterform.get('topplatespresent').setValue(this.checklistItems[29].value);
    this.raterform.get('ach50_cl').setValue(this.checklistItems[30].value);
    this.raterform.get('cfm50_cl').setValue(this.checklistItems[31].value);
    this.raterform.get('blowfanvol').setValue(this.checklistItems[32].value);
    this.raterform.get('blowfanwatt').setValue(this.checklistItems[33].value);
    this.raterform.get('refcharge').setValue(this.checklistItems[34].value);
    this.raterform.get('ext_static_pr').setValue(this.checklistItems[35].value);
    //this.raterform.get('modelNumbers').setValue(this.checklistItems[36].value);
    this.raterform.get('kinked_ducts').setValue(this.checklistItems[36].value);
    this.raterform.get('pressure_balanced').setValue(this.checklistItems[37].value);
    this.raterform.get('min_r6_uncond').setValue(this.checklistItems[38].value);
    this.raterform.get('boots_sealed').setValue(this.checklistItems[39].value);
    this.raterform.get('finalcfm').setValue(this.checklistItems[40].value);
    this.raterform.get('leakageotdr').setValue(this.checklistItems[41].value);
    this.raterform.get('measvent').setValue(this.checklistItems[42].value);
    this.raterform.get('continuous_control').setValue(this.checklistItems[43].value);
    this.raterform.get('returnside').setValue(this.checklistItems[44].value);
    this.raterform.get('motodamp').setValue(this.checklistItems[45].value);
    this.raterform.get('abvdesval').setValue(this.checklistItems[46].value);
    this.raterform.get('quitet_intermittent_fans').setValue(this.checklistItems[47].value);
    this.raterform.get('quiet_continuous_fans').setValue(this.checklistItems[48].value);
    this.raterform.get('continuous_fan_esq').setValue(this.checklistItems[49].value);
    this.raterform.get('airinletloc').setValue(this.checklistItems[50].value);
    this.raterform.get('inlet_outside').setValue(this.checklistItems[51].value);
    this.raterform.get('inlet_2ft').setValue(this.checklistItems[52].value);
    this.raterform.get('inlet_screen').setValue(this.checklistItems[53].value);
    this.raterform.get('kitchen_cfm').setValue(this.checklistItems[54].value);
    this.raterform.get('bathroom_cfm').setValue(this.checklistItems[55].value);
    this.raterform.get('merv6_filters').setValue(this.checklistItems[56].value);
    this.raterform.get('gasketed_filter').setValue(this.checklistItems[57].value);
    this.raterform.get('air_is_filtered').setValue(this.checklistItems[58].value);
    this.raterform.get('vent_combust_right').setValue(this.checklistItems[59].value);
    this.raterform.get('vent_fireplace_right').setValue(this.checklistItems[60].value);
    this.raterform.get('co_less_35ppm').setValue(this.checklistItems[61].value);
    this.raterform.get('ductdebris').setValue(this.checklistItems[62].value);
    this.raterform.get('filtclean').setValue(this.checklistItems[63].value);
    this.raterform.get('carbmondet').setValue(this.checklistItems[64].value);
    this.raterform.get('gardoorclo').setValue(this.checklistItems[65].value);
    this.raterform.get('ductclean').setValue(this.checklistItems[66].value);
    this.raterform.get('gutextensn').setValue(this.checklistItems[67].value);
    //this.raterform.get('co_less_35ppm').setValue(this.checklistItems[65].value,{onlySelf: true, emitEvent: false});

    /*
        if(this.isFinal){

          let flags = 0;
          let desc = [];

          for(let i = 3; i < this.checklistItems.length; i++){
            if(this.checklistItems[i].value.length < 1){
              desc.push(this.checklistItems[i].description);
              flags ++;
            }
          }

          if(flags > 0){
            const dialogRef = this.dialog.open(RFWarningDialogComponent, {
              minWidth: '90vw',
              height: '90vh',
              data: desc
            });

            dialogRef.afterClosed().subscribe(result => {

              //this.animal = result;
            });

          }

        }
    */

    //notes
    let notesObj = {

      fenlevels: this.checklistItems[0].note,
      insmeets: this.checklistItems[1].note,
      insachieve: this.checklistItems[2].note,
      dropped_ceiling_soffit: this.checklistItems[3].note,
      wall_b_shower_tub: this.checklistItems[4].note,
      attic_knee_walls: this.checklistItems[5].note,
      wall_a_porch_roof: this.checklistItems[6].note,
      double_walls: this.checklistItems[7].note,
      flr_o_unconbsmt_crawl: this.checklistItems[8].note,
      cantilevered_floor: this.checklistItems[9].note,
      r21_o_wall: this.checklistItems[10].note,
      slab_edge_insulation: this.checklistItems[11].note,
      r21_attic_platform: this.checklistItems[12].note,
      ins_sheathing: this.checklistItems[13].note,
      sip: this.checklistItems[14].note,
      r6_corner: this.checklistItems[15].note,
      ins_headr: this.checklistItems[16].note,
      min_wind_dr_framing: this.checklistItems[17].note,
      ins_wall_intersect: this.checklistItems[18].note,
      min_stud_spacing: this.checklistItems[19].note,
      duct_flue_shaft: this.checklistItems[20].note,
      attic_dropdown: this.checklistItems[21].note,
      recessed_light: this.checklistItems[22].note,
      sealedtopplate: this.checklistItems[23].note,
      sealedwindows: this.checklistItems[24].note,
      sealedmarriagejointsmodhomes: this.checklistItems[25].note,
      door_to_uncon: this.checklistItems[26].note,
      sealedsillplate: this.checklistItems[27].note,
      sealed_common_wall: this.checklistItems[28].note,
      topplatespresent: this.checklistItems[29].note,
      ach50_cl: this.checklistItems[30].note,
      cfm50_cl: this.checklistItems[31].note,
      blowfanvol: this.checklistItems[32].note,
      blowfanwatt: this.checklistItems[33].note,
      refcharge: this.checklistItems[34].note,
      ext_static_pr: this.checklistItems[35].note,
      //modelNumbers: this.checklistItems[36].note,
      kinked_ducts: this.checklistItems[36].note,
      pressure_balanced: this.checklistItems[37].note,
      min_r6_uncond: this.checklistItems[38].note,
      boots_sealed: this.checklistItems[39].note,
      finalcfm: this.checklistItems[40].note,
      leakageotdr: this.checklistItems[41].note,
      measvent: this.checklistItems[42].note,
      continuous_control: this.checklistItems[43].note,
      returnside: this.checklistItems[44].note,
      motodamp: this.checklistItems[45].note,
      abvdesval: this.checklistItems[46].note,
      quitet_intermittent_fans: this.checklistItems[47].note,
      quiet_continuous_fans: this.checklistItems[48].note,
      continuous_fan_esq: this.checklistItems[49].note,
      airinletloc: this.checklistItems[50].note,
      inlet_outside: this.checklistItems[51].note,
      inlet_2ft: this.checklistItems[52].note,
      inlet_screen: this.checklistItems[53].note,
      kitchen_cfm: this.checklistItems[54].note,
      bathroom_cfm: this.checklistItems[55].note,
      merv6_filters: this.checklistItems[56].note,
      gasketed_filter: this.checklistItems[57].note,
      air_is_filtered: this.checklistItems[58].note,
      vent_combust_right: this.checklistItems[59].note,
      vent_fireplace_right: this.checklistItems[60].note,
      co_less_35ppm: this.checklistItems[61].note

    }

    this.data.notes = notesObj;
    notesObj = undefined;
    this.subscriptions.add(this.raterFormService.updateNotes(this.location_id, this.data.notes).subscribe(
      res => {
        if (res.Error) {
          this.messager.openSnackBar('Error saving notes: ' + res.Message, '', 'errorAlert');
        } else {
          this.messager.openSnackBar('Notes saved successfully!', '', 'successAlert');
        }
      }, err => {
        this.messager.openSnackBar('Error saving notes', '', 'errorAlert');
      }));



    let rf = this.raterform.value;

    for (const key in rf) {
      if (rf[key] === '') {
        rf[key] = null;
      }
    }




    this.subscriptions.add(this.raterFormService.updateRaterForm(this.form_id, this.raterform.value).subscribe(
      (res)=> {
        if(res.Error){
          this.messager.openSnackBar('Error saving form: ' + res.Message + ' Use \'Bail\' button to help find field causing error.', '', 'errorAlert' );
        }else{
          this.messager.openSnackBar('Saved successfully!', '', 'successAlert');
        }
      }, err => {
          this.messager.openSnackBar('Form did not save: ' + err.Message, '', 'errorAlert');
      }));



    // check for warnings


  }//end function

  processTags(){

    //loop through all tags, grab the id and push to id array;
    let idArray = [];
    this.inputTags.forEach(element => idArray.push(element.id));

    //call API function to update tag use count:

    this.locservice.updateTagUseCount(idArray).subscribe(
      res => {
      });

  }

  checkEngineerLetterNeeded(mf:boolean = false): void {

              //check to see if any of the notes fields contain  'engineering letter'
              let engineerTagNeeded = false;

              //first check to see if all fields are either verified or N/A
              if( !this.checklistItems[15]?.value?.toLowerCase().includes('correct') && !this.checklistItems[16]?.value?.toLowerCase().includes('correct')
              && !this.checklistItems[17]?.value?.toLowerCase().includes('correct') && !this.checklistItems[18]?.value?.toLowerCase().includes('correct')
              && !this.checklistItems[19]?.value?.toLowerCase().includes('correct') ){
                engineerTagNeeded = false;
              }else { // if one of them must be corrected, check for notes requiring engineer letter
                if( this.checklistItems[15]?.note?.toLowerCase().includes('engineer') || this.checklistItems[16]?.note?.toLowerCase().includes('engineer')
                || this.checklistItems[17]?.note?.toLowerCase().includes('engineer') || this.checklistItems[18]?.note?.toLowerCase().includes('engineer')
                || this.checklistItems[19]?.note?.toLowerCase().includes('engineer') ){
                  engineerTagNeeded = true;
                }
              }

              //also check MF fields as well
              if(mf){
                if( !this.mfChecklistItems[25]?.value?.toLowerCase().includes('correct') && !this.mfChecklistItems[26]?.value?.toLowerCase().includes('correct')
                  && !this.mfChecklistItems[27]?.value?.toLowerCase().includes('correct') && !this.mfChecklistItems[28]?.value?.toLowerCase().includes('correct')
                ){
                    engineerTagNeeded = false;
                  }else { // if one of them must be corrected, check for notes requiring engineer letter
                    if( this.mfChecklistItems[25]?.note?.toLowerCase().includes('engineer') || this.mfChecklistItems[26]?.note?.toLowerCase().includes('engineer')
                    || this.mfChecklistItems[27]?.note?.toLowerCase().includes('engineer') || this.mfChecklistItems[28]?.note?.toLowerCase().includes('engineer')
                    ){
                      engineerTagNeeded = true;
                    }
                  }
              }

              //add engineering tag to job
              if(engineerTagNeeded && !this.inputTags.some(tag => tag.id === 13)){
                this.inputTags.push({id: 13, displayname: 'Engineering Letter Requested'});
                this.log.info(this.usernamee + ' added Engineering tag (via must correct automation) to form with id: ' + this.form_id + ' street address: ' + this.street_address + ' subdivision and lot: ' + this.subdivision_name + ' - ' + this.lot);
              }

              //if engineering tag is present, but no longer needed, remove it
              if(!engineerTagNeeded && this.inputTags.some(tag => tag.id === 13)){
                this.inputTags = this.inputTags.filter(tag => tag.id !== 13);
                this.log.info(this.usernamee + ' removed Engineering tag (via must correct automation) from form with id: ' + this.form_id + ' street address: ' + this.street_address + ' subdivision and lot: ' + this.subdivision_name + ' - ' + this.lot);
              }
    
              //add engineering letter tag to location
              if(engineerTagNeeded){
                //call API function to add tag to location:
                this.raterFormService.addEngineerLetterTag(this.location_id).subscribe();
              }else {
                //call API function to remove tag from location:
                this.raterFormService.removeEngineerLetterTag(this.location_id).subscribe();
              }


  }


  removeLocation(index:number): void {

      this[`sys${this.systemNo}grade`].syslocs.splice(index, 1);

  }


  closeFunction( data:any ): void {
          // check for warnings
          //check for attic tent warning
          let atticTentWarning = false;
          //if tag with id 7 is in the input tags check to see if tag with id 8, 9 or 10 is present
          //if so, warn user that attic tent is required
          /*
          if(this.inputTags.some(tag => tag.id =  == 7)){
            if(!this.inputTags.some(tag => tag.id === 8) && !this.inputTags.some(tag => tag.id === 9) && !this.inputTags.some(tag => tag.id === 10)){
              atticTentWarning = true;
            }
          }
          */
          //let numOfWarnings = 0;

          ////need to save tags on Close

          this.checkEngineerLetterNeeded(this.isESMFNC);

          this.saveHvacGrading();
          this.processTags();
          this.checkAffBoxes(false);
          const tagIds = this.inputTags.map(tag => tag.id);

          // Skip the automatic builder-portal reset when the form was opened from the locations page.
          // (Office staff use the explicit "Reset Builder TEC" button there; the auto-reset-on-Close
          // was re-sending forms back to the builder when simply opened and closed.)
          if (!this.fromLocations) {
            this.checklistItems.some((item) => {
              if (item.value === 'Must Correct'){

                // set builder done to false, and remove the TEC signature and date if applicable.
                this.raterFormService.resetBuilderLocation(this.location_id).subscribe(
                  res => {
                    if (res.Error) {
                      this.log.error(this.usernamee + ' experienced error resetting builder portal for location with id: ' + this.location_id + ' street address: ' + this.street_address + ' subdivision and lot: ' + this.subdivision_name + ' - ' + this.lot + ' Error: ' + res.Message);
                      //this.messager.openSnackBar('Error resetting builder portal: ' + res.Message, '', 'errorAlert');
                    } else {
                      this.log.info(this.usernamee + ' reset builder portal for location with id: ' + this.location_id + ' street address: ' + this.street_address + ' subdivision and lot: ' + this.subdivision_name + ' - ' + this.lot);
                      //this.messager.openSnackBar(res.Message, '', 'successAlert');
                    }
                  })
                //return true; //break out of loop
              }
            });
          } else {
            this.log.info(this.usernamee + ' closed form (opened from locations page) without auto-resetting builder portal for location with id: ' + this.location_id + ' street address: ' + this.street_address + ' subdivision and lot: ' + this.subdivision_name + ' - ' + this.lot);
          }

          this.raterFormService.saveTags(this.job_id, tagIds).subscribe(
            res => {
              //after tags are saved, see what tags we have there. Make sure that if tag with id 7 is present, then either 8, 9 or 10 is present as well.
              //if not, warn user that attic tent is required
              if(tagIds.includes(7)){

                if(!tagIds.includes(8) && !tagIds.includes(9) && !tagIds.includes(10)){
                  atticTentWarning = true;
                }
              }

              this.numOfWarnings = 0;
              let warnings = "";
              if(this.isFinal){
                warnings = this.checkFinal();
              }

              if(this.isPDWI){
                warnings = this.checkPDWI();
              }

              const ductLeakageWarnings = this.checkDuctLeakageWarnings();
              if (!this.checkGradingWarnings().canClose){
                this.openHVACGradingWarningsModal();
              }
              else if(!ductLeakageWarnings.canClose){
                this.openDuctLeakageWarningsModal(ductLeakageWarnings.warningText);
              }
              else if(this.numOfWarnings > 0){
                this.openFinalWarningsModal(warnings);
              }
              else if(atticTentWarning) {
                this.openAtticTentModal();
              }else {
                this.dialogRef.close();
              }


            });

  }

openHVACGradingWarningsModal(): void {
  const dialogRef = this.dialog.open(HvacGradingWarningComponent, {
    minWidth: '400px',
    height: '400px',
    data: {},
    panelClass: 'custom-dialog-container'
  });

  dialogRef.afterClosed().subscribe(result => {
    if(result === 1){
      this.dialog.closeAll();
    }
  });

}

openDuctLeakageWarningsModal(warningText): void {
  const dialogRef = this.dialog.open(DuctLeakageWarningComponent, {
    minWidth: '400px',
    height: '400px',
    data: warningText,
    panelClass: 'custom-dialog-container'
  });

  dialogRef.afterClosed().subscribe(result => {
    if(result === 1){
      this.log.info(this.usernamee + ' closed the raterform despite missing Total Duct Leakage for form with id: ' + this.form_id + ' street address: ' + this.street_address + ' subdivision and lot: ' + this.subdivision_name + ' - ' + this.lot + ' Warnings: ' + warningText);
      this.dialog.closeAll();
    }
  });

}

checkGradingWarnings(): any {
  //check jobtype for 'HVG' 
  var warningText = '';
  if(this.data.formData.jobinfo.customer_jobtype?.toLowerCase().includes('hvg')){
    if(this.raterform.get('hvac1name').value.length > 1 ){
      if(this.sys1grade.linesetLength == null || this.sys1grade.liquidLineDiameter == null){
        warningText += 'System 1: Lineset Length and Liquid Line Diameter are required for HVAC Grading. (HVAC tab) \n';
      }
    }

    if(this.raterform.get('hvac2name').value.length > 1 ){
      if(this.sys2grade.linesetLength == null || this.sys2grade.liquidLineDiameter == null){
        warningText += 'System 2: Lineset Length and Liquid Line Diameter are required for HVAC Grading. (HVAC tab) \n';
      }
    }

    if(this.raterform.get('hvac3name').value.length > 1 ){
      if(this.sys3grade.linesetLength == null || this.sys3grade.liquidLineDiameter == null){
        warningText += 'System 3: Lineset Length and Liquid Line Diameter are required for HVAC Grading. (HVAC tab) \n';
      }
    }

    if(this.raterform.get('hvac4name').value.length > 1 ){
      if(this.sys4grade.linesetLength == null || this.sys4grade.liquidLineDiameter == null){
        warningText += 'System 4: Lineset Length and Liquid Line Diameter are required for HVAC Grading. (HVAC tab) \n';
      }
    }

  }

  if(warningText.length > 1){
    return {warningText: warningText, canClose: false};
  }else {
    return {warningText: '', canClose: true};
  }
}

// Alert for missing Total Duct Leakage (DB Total) on HVG (HVAC Grading) job types.
// This is being missed on houses that don't get tested at rough-in (mainly Mattamy),
// where the "DB Total" (db{n}_total) field on the Testing tab is left at 0.
// PDWI HvG jobs are exempt: there is no duct blast at pre-drywall unless the jobtype
// is the "(Rough Testing)" variant (True Homes), where the rough test happens on that visit.
checkDuctLeakageWarnings(): any {
  var warningText = '';
  const jobtype = this.data.formData.jobinfo.customer_jobtype?.toLowerCase() || '';
  const isPdwiWithoutRoughTesting = jobtype.includes('pdwi') && !jobtype.includes('rough testing');

  if(jobtype.includes('hvg') && !isPdwiWithoutRoughTesting){
    for(let i = 1; i < 5; i++){
      // only check systems that are actually present (have a name), matching checkGradingWarnings
      if(this.raterform.get(`hvac${i}name`).value?.length > 1){
        const dbTotal = this.raterform.get(`db${i}_total`).value;
        if(!dbTotal || Number(dbTotal) === 0){
          warningText += 'System ' + i + ': Total Duct Leakage (DB Total) is missing. This house may not have been tested at rough-in. (Testing tab) \n';
        }
      }
    }
  }

  if(warningText.length > 1){
    return {warningText: warningText, canClose: false};
  }else {
    return {warningText: '', canClose: true};
  }
}

resizeWithExif(
  file: File,
  maxWidth: number
): Promise<{ exif: any; resizedFile: File }> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    const img = new Image();
    let canvas: HTMLCanvasElement | null = null;

    const cleanup = () => {
      reader.onload = null;
      reader.onerror = null;
      img.onload = null;
      img.onerror = null;

      if (canvas) {
        canvas.width = 0;
        canvas.height = 0;
        canvas = null;
      }
    };

    reader.onerror = () => {
      this.logPictureError(
        'resizeWithExif - Failed to read image data',
        this.usernamee,
        this.form_id,
        this.street_address,
        this.subdivision_name,
        this.lot,
        {}
      );
      cleanup();
      reject(new Error('Failed to read image data'));
    };

    reader.onload = () => {
      const dataUrl = reader.result as string;

      let exifObj: any;
      try {
        exifObj = piexif.load(dataUrl);
      } catch (e) {
        exifObj = {};
      }

      img.onload = () => {
        const originalWidth = img.naturalWidth;
        const originalHeight = img.naturalHeight;

        const scale =
          originalWidth > maxWidth ? maxWidth / originalWidth : 1;

        const targetWidth = Math.round(originalWidth * scale);
        const targetHeight = Math.round(originalHeight * scale);

        canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          this.logPictureError(
            'resizeWithExif - Canvas 2D context not available',
            this.usernamee,
            this.form_id,
            this.street_address,
            this.subdivision_name,
            this.lot,
            {}
          );
          cleanup();
          reject(new Error('Canvas 2D context not available'));
          return;
        }

        ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              cleanup();
              reject(new Error('Canvas toBlob failed'));
              return;
            }

            const resizedFile = new File([blob], file.name, {
              type: 'image/jpeg',
            });

            cleanup();
            resolve({ exif: exifObj, resizedFile });
          },
          'image/jpeg',
          0.8
        );
      };

      img.onerror = () => {
        this.logPictureError(
          'resizeWithExif - Failed to decode image',
          this.usernamee,
          this.form_id,
          this.street_address,
          this.subdivision_name,
          this.lot,
          {}
        );
        cleanup();
        reject(new Error('Failed to decode image'));
      };

      img.src = dataUrl;
    };

    reader.readAsDataURL(file);
  });
}



downloadFormData() {
  // Get the value of the form

  let bigObj = {
    rfvalue : this.raterform.value,
    clitems : this.checklistItems,
    photos : this.data.pics,
  }

  const data = bigObj;
  const jsonStr = JSON.stringify(data);

  const blob = new Blob([jsonStr], { type: 'application/json' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = this.street_address +'_FormData.json';  
  document.body.appendChild(a);
  a.click();  

  // Cleanup: remove the anchor and revoke the blob URL
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

  sendMFReports(): void {

          //sendMultifamilyReport
          if(this.templateName.length > 1){
            this.saveMF(this.fcs.getData(),true);
          }
          //send esmfnc if applicable
          if(this.mfChecklistID > 0){
            let data = {
              mfItems : this.mfChecklistItems,
              street_address : this.street_address,
              subdivision_name : this.subdivision_name,
              lot: this.lot,
              jobtype: this.data.formData.jobinfo.customer_jobtype,
              job_id: this.job_id,
              folderid : this.drivelink
            }
            this.raterFormService.sendESMFNCReportEmail(data).subscribe(
              res => {
                if (res.Error) {
                  this.messager.openSnackBar('Error sending ES MFNC: ' + res.Message, '', 'errorAlert');
                } else {
                  this.messager.openSnackBar('ES MFNC sent successfully!', '', 'successAlert');
                }
              }, err => {
                this.messager.openSnackBar('Error sending ES MFNC', '', 'errorAlert');
              });
            }

  }

  getFontSize(description: string): string {

    let x = description.length;
    var length = 5.0 - ((x/100));
    let viewport = window.innerWidth || document.documentElement.clientWidth;

    if(viewport > 600){
      return '16px;'
    }else{
      if (length < 1.3) {
        return '12px;'
      }
      return length + 'vw';
    }
    //return description.length > 100 ? (description.length > 275 ? '10px' : '12px') : '14px';
  }

  mfPhotoTaken(event: Event, field, form) {
   let elem = document.getElementById(field);


   let href = 'https://inspexn.s3.amazonaws.com/' + this.job_id + '_' + field + '.jpg';
   let picElement = document.createElement('a');
   picElement.href= href;
   form.get(field).setValue(href);
   picElement.target = '_blank';
   picElement.innerText = 'View Picture';
   picElement.setAttribute('style', 'font-size: 16px !important; color: white !important; text-decoration: none !important;');
   elem.insertAdjacentElement('afterend',picElement);

   this.messager.openSnackBar('Uploading picture in background...', '', 'basicAlert');
   const _self = this;
   //let fileObj =  File;
   const file: File = (event.target as HTMLInputElement).files[0];
   const uploadImageLabel = this.job_id + '_' + field;
   const fileExt = file.name.split('.').pop()?.toLowerCase();
   if (fileExt !== 'jpg' && fileExt !== 'jpeg') {
      this.messager.openSnackBar('Only JPG and JPEG images are allowed!', '', 'errorAlert');
      return; // Exit the function if the file type is not JPG or JPEG
    }
   //fileObj = FILE;
   let fileUrl;
   let jid = this.job_id;
   //File.name = this.job_id + '_' + field;
   const reader = new FileReader();
   reader.readAsDataURL(file);

   reader.onload = function(event){

     let imgurl = event.target.result as string;
     let image = _self.image;


     image.src = imgurl;

     image.onload = function(this: HTMLImageElement){
       let canvas = document.createElement("canvas");
       const WIDTH = 700;


       let ratio = WIDTH / this.width;
       canvas.width = WIDTH;
       canvas.height = this.height * ratio;



       const context = canvas.getContext("2d");
       context.drawImage(image, 0, 0, canvas.width, canvas.height);

       let newimage = context.canvas.toDataURL("image/jpeg", 85);

       context.clearRect(0, 0, canvas.width, canvas.height);

       //let qualityDisplay = document.createElement("img");
       //qualityDisplay.src = newimage;

       let thefile = urlToFile(newimage, uploadImageLabel);

       _self.subscriptions.add(_self.raterFormService.uploadImageChecklist(thefile, uploadImageLabel).subscribe(
         (response) => {

           _self.messager.openSnackBar('Successfully uploaded!', '', 'successAlert');
           var urlpic = 'https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.jpg';


           _self.subscriptions.add(_self.raterFormService.multifamilypicUpload(jid, field).subscribe(
             (res) => {

               //_self.data.pics[field] = 'https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.jpg';
               _self.cdr.detectChanges();
               //_self.messager.openSnackBar('Image field dated!', '', 'successAlert');
             }, err => {
               _self.messager.openSnackBar('Error updating the field: ' + err, '', 'errorAlert');
             }));


         },
         (error) => {
           _self.messager.openSnackBar('Failed: ' + error, '', 'errorAlert');
           //alert('fail');
         }));
         thefile=undefined
     }

   }

   function urlToFile(url, name) {

     let arr = url.split(",");
     let mime = arr[0];
     let data = arr[1];

     let dataString = atob(data);
     let l = dataString.length;
     let dataArr = new Uint8Array(l);

     while(l--)
     {
       dataArr[l] = dataString.charCodeAt(l);
     }

     let file = new File([dataArr], 'file.jpg', {type: 'image/jpeg'})

     return file;

   }




  }

  saveMF(data, sendReport: boolean = false){

    data = JSON.parse(data);
    this.messager.openSnackBar('Creating report...', '', 'successAlert');


    data = JSON.parse(data);
    this.messager.openSnackBar('Creating report...', '', 'successAlert');


    data.street_address = this.street_address;
    data.subdivision_name = this.subdivision_name;
    data.lot = this.lot;
    data.jobtype = this.data.formData.jobinfo.customer_jobtype;
    data.job_id = this.job_id;
    data.folderid = this.drivelink;

    //set timeout to 5 seconds
    setTimeout(() => {
          this.messager.openSnackBar('Saving data...', '', 'successAlert',10000);
    }, 5000);

    setTimeout(() => {
      this.messager.openSnackBar('Preparing Reports...', '', 'successAlert',10000);
    }, 15000);

    setTimeout(() => {
      this.messager.openSnackBar('Sending Reports...', '', 'successAlert',10000);
    }, 25000);

    /*
    //set timeout to 5 seconds
    setTimeout(() => {
          this.messager.openSnackBar('Saving data...', '', 'successAlert',10000);
    }, 5000);

    setTimeout(() => {
      this.messager.openSnackBar('Preparing Reports...', '', 'successAlert',10000);
    }, 15000);

    setTimeout(() => {
      this.messager.openSnackBar('Sending Reports...', '', 'successAlert',10000);
    }, 25000);

    /*
    this.raterFormService.sendMFdataEmail(data, this.location_id).subscribe(
      res => {
        this.messager.openSnackBar('Data saved and sent to Jon.', '', 'successAlert');
      }
    )
      */
      

    this.raterFormService.updateMFdata(this.form_id, this.selectedTemplate, data).subscribe(
      res => {
        this.messager.openSnackBar('Saved Multi family data!', '', 'successAlert');
        //send email here
        let location = {
            street_address : this.street_address,
            subdivision_name : this.subdivision_name,
            lot: this.lot
        }

        if(sendReport) {
          this.messager.openSnackBar('Sending email...', '', 'successAlert');
          this.raterFormService.sendMfReportNGBS(data, this.templateObject, location).subscribe(
            res => {
              this.messager.openSnackBar('Report sent for ' + location.street_address.trim() + '!', '', 'successAlert');
            }
          )
        }
        //reload support page
          this.getMultifamilyData(this.form_id);
      }
    )



  }

  renderMFPics(): void {


    for (const [key, value] of Object.entries(this.multifamilyData)) {
      // Checking if 'key' has '_pic' in its name and 'value' length is greater than 1
      if (key.includes('_pic') && value) {

        let photoObj = {
          photo: '',
          label: ''
        };

        //append an image element to div with the id field[key]_picdiv
        const containerDiv = this.el.nativeElement.querySelector(`${key}div`);
        if (containerDiv) {
          // Create an img element
          const img = this.renderer.createElement('img');

          // Set the src attribute
          //cast value to string

          this.renderer.setAttribute(img, 'src', value.toString());

          // Append the img to the container div
          this.renderer.appendChild(containerDiv, img);

        }
      }
    };


  }

  multiFamilySelected(mfvalue){

    //see if there's data
    this.raterFormService.getMultifamilyData(this.form_id).subscribe(
      res => {
        this.multifamilyData = res.Response.mfdata;
        this.multifamilyLoaded = true;

        this.mfSelected = true;

              //multifamily dat


        let photos= [];


        mfvalue.fields.forEach(function(obj, index){

          let newObj = {
                  descr: index + '_pic',
                  id: index + '_pic',
                  inpt: "1",
                  key: null
          }

          photos.push(newObj);
        })


        let fields = JSON.stringify(mfvalue);

        this.formFields = this.fcs.getFormFields(fields, photos,this.multifamilyData);

        this.selectedTemplate = mfvalue.id;
        this.mfFields = mfvalue.fields;


      let photoObjArray = [];

      for (const [key, value] of Object.entries(this.multifamilyData)) {
        // Checking if 'key' has '_pic' in its name and 'value' length is greater than 1
        if (key.includes('_pic') && value) {

          let photoObj = {
            photo: '',
            label: ''
          };

          //append an image element to div with the id field[key]_picdiv


          // Extracting the key name without '_pic' suffix
          //let correspondingKey = key.replace('_pic', '');
          const matches = key.match(/field(\d+)/);
          const correspondingKey = matches[1];

          // Finding the corresponding object
          //let correspondingItem = mfvalue.fields.find(innerItem => innerItem.key === correspondingKey);
          let correspondingItem = mfvalue.fields[correspondingKey];

          if (correspondingItem) {
            photoObj.photo = value as string;
            photoObj.label = correspondingItem.descr;
            photoObjArray.push(photoObj);
          }
        }
      };

      this.photoObj = photoObjArray;


      setTimeout(() => {
        this.renderMFPics();
      }, 10000);

      }, err => {
        this.multifamilyLoaded = false;
        this.multifamilyData = {};

        this.mfSelected = true;

        let photos= [];


        mfvalue.fields.forEach(function(obj, index){

          let newObj = {
                  descr: index + '_pic',
                  id: index + '_pic',
                  inpt: "1",
                  key: null
          }

          photos.push(newObj);
        })


        let fields = JSON.stringify(mfvalue);

        this.formFields = this.fcs.getFormFields(fields, photos);

        this.selectedTemplate = mfvalue.id;
        this.mfFields = mfvalue.fields;
      })


  }



  checkPDWI(): string {

    let warningString = '';

    if(this.customerObj && this.customerObj.customer_name.toLowerCase().includes('meritage')){

      if (this.data.pics['foamceilings'] === null){
        warningString += '\n Meritage Home Requirement: Foam Ceilings Photo is Missing (envelope tab)';
        this.numOfWarnings ++;
      }

      if(this.raterform.get('fcavgdepth').value == 0){
        warningString += '\n Meritage Home Requirement: Foam Ceilings Average Insulation Depth (envelope tab)';
        this.numOfWarnings ++;
      }

    }

    if(this.raterform.get('orientation').value == ''){
      warningString += '\n Orientation (envelope tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('window_u').value == 0){
      warningString += '\n Window U (envelope tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('window_shgc').value == 0){
      warningString += '\n Window SHGC (envelope tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('foamwalls').value == ''){

    }
    if(this.raterform.get('fwavgdepth').value == 0){
      warningString += '\n Foam Wall Average Depth (envelope tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('agwna').value == false && this.raterform.get('agw').value == ''){
      warningString += '\n Above Grade Walls (envelope tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('agwna').value == false && this.raterform.get('agwspacing').value == ''){
      warningString += '\n Above Grade Walls Spacing (envelope tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('bandna').value == false && this.raterform.get('band').value == ''){
      warningString += '\n Band R- value(envelope tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('bandna').value == false && this.raterform.get('bandspacing').value == ''){
      warningString += '\n Band Spacing (envelope tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('bandna').value == false && this.raterform.get('bandht').value == ''){
      warningString += '\n Joist Height (envelope tab)';
      this.numOfWarnings ++;
    }

    if(this.raterform.get('cantilever_floor').value == ''){
      warningString += '\n Cantilever Floor R-value (envelope tab)';
      this.numOfWarnings ++;
    }

    if(this.raterform.get('cantilever_floor').value != 'N/A'){

      if(this.raterform.get('cantfspacing').value == ''){
        warningString += '\n Cantilever Floor Spacing (envelope tab)';
        this.numOfWarnings ++;
      }
      if(this.raterform.get('cantjoist').value == ''){
        warningString += '\n Cantilever Joist Height (envelope tab)';
        this.numOfWarnings ++;
      }

    }

    if(this.raterform.get('floor_above_garage').value == ''){
      warningString += '\n Floor Above Garage R-Value(envelope tab)';
      this.numOfWarnings ++;
    }


    if(this.raterform.get('floor_above_garage').value != 'N/A'){

      if(this.raterform.get('garspacing').value == ''){
        warningString += '\n Garage Framing Spacing(envelope tab)';
        this.numOfWarnings ++;
      }
      if(this.raterform.get('garjoist').value == ''){
        warningString += '\n Garage Joist Height (envelope tab)';
        this.numOfWarnings ++;
      }

    }

    if(this.raterform.get('size').value == ''){
      warningString += '\n Ceiling or Rafter Framing Size (envelope tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('spacing').value == ''){
      warningString += '\n Ceiling or Rafter Spacing(envelope tab)';
      this.numOfWarnings ++;
    }


    if(this.raterform.get('vaulted_ceilings').value == ''){
        warningString += '\n Vaulted Ceilings R-value (envelope tab)';
        this.numOfWarnings ++;
    }

    if((this.raterform.get('vaulted_ceilings').value.length > 1 && this.raterform.get('vaulted_ceilings').value != 'N/A')){ 
      if(this.raterform.get('sloped_ceilings').value == ''){
      warningString += '\n Sloped Ceilings R-value (envelope tab)';
      this.numOfWarnings ++;
    }}

    if(this.raterform.get('ceilins').value == ''){
      warningString += '\n Ceiling Insulation Accessibility (envelope tab)';
      this.numOfWarnings ++;
    }

    if(this.raterform.get('knee_walls').value == ''){
        warningString += '\n Knee Wall R-Value (envelope tab)';
        this.numOfWarnings ++;
    }

    if((this.raterform.get('knee_walls').value.length > 1 && this.raterform.get('knee_walls').value != 'N/A')){ 
        if(this.raterform.get('kneesheath').value == ''){
          warningString += '\n Knee wall Sheathing(envelope tab)';
          this.numOfWarnings ++;
        }
    }

    if(this.raterform.get('foundation_type').value == ''){
      warningString += '\n Foundation Type (envelope tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('fdn_r').value == ''){
      warningString += '\n Foundation R-Value(envelope tab)';
      this.numOfWarnings ++;
    }

    if(!this.raterform.get('foundation_type').value?.toLowerCase()?.includes('slab')
       && this.raterform.get('foundation_type').value != 'N/A'){

      if(this.raterform.get('_1st_floor').value == ''){
        warningString += '\n First Floor R-value (envelope tab)';
        this.numOfWarnings ++;
      }
      if(this.raterform.get('ffspacing').value == ''){
        warningString += '\n First Floor Framing Spacing(envelope tab)';
        this.numOfWarnings ++;
      }
      if(this.raterform.get('frstflrjoi').value == ''){
        warningString += '\n First Floor Joist Height(envelope tab)';
        this.numOfWarnings ++;
      }


    

    }

    warningString += this.requiredChecklistPhotoWarnings('pdwi');

    return warningString;

  }

//check final
  checkFinal(): string {

    let warningString = '';

    if(this.raterform.get('flowat50').value == 0){
      warningString += '\n Blower Door (Flow at 50 Pascals) is missing (testing tab)';
      this.numOfWarnings ++;
    }
    else if (this.data.pics['ach50'] === null){
      warningString += '\n Blower Door/ Ach50 pic (testing tab) is missing';
      this.numOfWarnings ++;
    }
   
    if(this.raterform.get('insidet1').value == 0 
    && this.raterform.get('insidet2').value == 0 
    && this.raterform.get('insidenq').value == 0){
      warningString += '\n FYI: Lighting Inside Count (final tab) contains all zeroes';
      this.numOfWarnings ++;
    }


    if(this.raterform.get('outsidet1').value == 0 
    && this.raterform.get('outsidet2').value == 0 
    && this.raterform.get('outsidenq').value == 0){
      warningString += '\n FYI: Lighting Outside Count (final tab) contains all zeroes';
      this.numOfWarnings ++;
    }


    if(this.raterform.get('garaget1').value == 0 
    && this.raterform.get('garaget2').value == 0 
    && this.raterform.get('garagenq').value == 0){
      warningString += '\n FYI: Lighting Garage Count (final tab) contains all zeroes';
      this.numOfWarnings ++;
    }



    if(this.isHers){
      for(var i = 1; i < 5; i++){
        if(this.raterform.get(`stagedone${i}`).value === 'Rough-In' && this.data.pics[`db${i}_total`] === null){
          warningString += '\n (HERS) Total Exterior pic for system ' + i + ' % (testing tab) is missing';
          this.numOfWarnings ++;
        }
      }

    }

    if(this.raterform.get('vent_rate_total').value == 0 && !this.isHers){
      warningString += '\n Total House Ventilation CFM is 0 (testing tab)';
      this.numOfWarnings ++;
    }
    if(this.data.pics['regrigerator_mn'] === null){
      warningString += '\n Refrigerator model number picture is missing (final tab)';
      this.numOfWarnings ++;
    }
    Object.keys(this.photoCountFields).forEach(field => {
      const shortfall = this.checklistPhotoCountWarning(field);
      if (shortfall) {
        warningString += '\n ' + this.photoCountFields[field].item + ': ' + shortfall + ' (checklist tab)';
        this.numOfWarnings ++;
      }
    });
    warningString += this.requiredChecklistPhotoWarnings('final');
    if(this.raterform.get('flat_ceilings').value == ''){
      warningString += '\n Flat Ceilings R-value (use N/A if necessary) (envelope tab)';
      this.numOfWarnings ++;
    }else {
      if(this.raterform.get('flat_ceilings').value != 'N/A' &&
      this.raterform.get('flat_ceilings').value != 'R20 Foam' &&
      this.raterform.get('flat_ceilings').value != 'Other' && this.data.pics['flat_ceilings'] === null){
        warningString += '\n Flat Ceilings Picture is missing (envelope tab)';
        this.numOfWarnings ++;
      }
    }

    if(this.raterform.get('vaulted_ceilings').value == ''){
      warningString += '\n Vaulted Ceilings R-value (use N/A if necessary) (envelope tab)';
      this.numOfWarnings ++;
    }else {
      if((this.raterform.get('vaulted_ceilings').value != 'NA' && this.raterform.get('vaulted_ceilings').value != 'N/A') && this.data.pics['vaulted_ceilings'] === null){
        warningString += '\n Vaulted Ceilings Picture is missing (Since "NA" is not selected, envelope tab)';
        this.numOfWarnings ++;
      }
    }

    if(this.raterform.get('foamceilings').value == true && this.raterform.get('vaulted_ceilings').value == '' && this.raterform.get('fcavgdepth').value == 0){
      warningString += '\n You checked foam ceilings but did not include average depth (envelope tab)';
      this.numOfWarnings ++;
    }

    if(this.raterform.get('foamceilings').value == true && this.data.pics['foamceilings'] === null){
      warningString += '\n Foam Ceilings Picture is missing (envelope tab)';
      this.numOfWarnings ++;
    }

    if(this.raterform.get('foundation_type').value == 'Vented Crawl' && this.data.pics['_1st_floor'] === null){
      warningString += '\n First Floor R-Value photo is missing (Vented Crawl selected as Foundation Type) (envelope tab)';
      this.numOfWarnings ++;
    }

    if(this.data.pics['dishwasher_mn'] === null){
      warningString += '\n Dishwasher model number picture is missing (final tab)';
      this.numOfWarnings ++;
    }
    if(this.data.pics['dryer_mn'] === null && this.data.pics['washer_mn'] === null){
      warningString += '\n Picture of Washer or Dryer is required (final tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('close_dryer_fuel').value == ''){
      warningString += '\n Clothes Dryer Fuel value is missing (final tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('rangefueltype').value == ''){
      warningString += '\n Range Fuel Type (final tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('tstattype1').value == ''){
      warningString += '\n Thermostat Type 1 (final tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('heat1fuel').value == ''){
      warningString += '\n Heat 1 Fuel (final tab)';
      this.numOfWarnings ++;
    }
    if(this.raterform.get('hvac_1_mfr').value == ''){
      warningString += '\n Heat Manufacturer (final tab)';
      this.numOfWarnings ++;
    }
    if(this.data.pics['c_coil_1_mn'] === null){
      warningString += '\n C coil 1 model number picture is missing(final tab)';
      this.numOfWarnings ++;
    }
    if(this.data.pics['e_coil_1_mn'] === null){
      warningString += '\n E coil 1 model number picture is missing (final tab)';
      this.numOfWarnings ++;
    }
    if(this.data.pics['ahu_furn_1_mn'] === null){
      warningString += '\n AHU furn 1 model number picture is missing (final tab)';
      this.numOfWarnings ++;
    }
    if(this.data.pics['db1_ext'] === null){
      warningString += '\n DB1 exterior leakage picture is missing (test tab)';
      this.numOfWarnings ++;
    }


    if(this.raterform.get("hvac2name").value.length > 1){

        if(this.raterform.get('tstattype2').value == ''){
          warningString += '\n Thermostat Type 2 (final tab)';
          this.numOfWarnings ++;
        }
        if(this.raterform.get('heat2fuel').value == ''){
          warningString += '\n Heat 2 Fuel (final tab)';
          this.numOfWarnings ++;
        }
        if(this.raterform.get('hvac_2_mfr').value == ''){
          warningString += '\n Heat Manufacturer (final tab)';
          this.numOfWarnings ++;
        }
        if(this.data.pics['c_coil_2_mn'] === null){
          warningString += '\n C coil 2 mn picture is missing  (final tab)';
          this.numOfWarnings ++;
        }
        if(this.data.pics['e_coil_2_mn'] === null){
          warningString += '\n E coil 2 mn picture is missing (final tab)';
          this.numOfWarnings ++;
        }
        if(this.data.pics['ahu_furn_2_mn'] === null){
          warningString += '\n AHU furn 2 mn picture is missing (final tab)';
          this.numOfWarnings ++;
        }
        if(this.data.pics['db2_ext'] === null){
          warningString += '\n DB2 exterior leakage picture is missing (testing tab)';
          this.numOfWarnings ++;
        }

      }


    if(this.raterform.get("hvac3name").value.length > 1){

        if(this.raterform.get('tstattype3').value == ''){
          warningString += '\n Thermostat Type 3 (final tab)';
          this.numOfWarnings ++;
        }
        if(this.raterform.get('heat3fuel').value == ''){
          warningString += '\n Heat 3 Fuel (final tab)';
          this.numOfWarnings ++;
        }
        if(this.raterform.get('hvac_3_mfr').value == ''){
          warningString += '\n Heat Manufacturer (final tab)';
          this.numOfWarnings ++;
        }
        if(this.data.pics['c_coil_3_mn'] === null){
          warningString += '\n C coil 3 mn picture is missing (final tab)';
          this.numOfWarnings ++;
        }
        if(this.data.pics['e_coil_3_mn'] === null){
          warningString += '\n E coil 3 mn picture is missing (final tab)';
          this.numOfWarnings ++;
        }
        if(this.data.pics['ahu_furn_3_mn'] === null){
          warningString += '\n AHU furn 3 mn picture is missing (final tab)';
          this.numOfWarnings ++;
        }
        if(this.data.pics['db3_ext'] === null){
          warningString += '\n DB3 exterior leakage picture is missing (testing tab)';
          this.numOfWarnings ++;
        }


      }


      if(this.raterform.get("hvac4name").value.length > 1){

          if(this.raterform.get('tstattype4').value == ''){
            warningString += '\n Thermostat Type 4 (final tab)';
            this.numOfWarnings ++;
          }
          if(this.raterform.get('heat4fuel').value == ''){
            warningString += '\n Heat 4 Fuel (final tab)';
            this.numOfWarnings ++;
          }
          if(this.raterform.get('hvac_4_mfr').value == ''){
            warningString += '\n Heat Manufacturer (final tab)';
            this.numOfWarnings ++;
          }
          if(this.data.pics['c_coil_4_mn'] === null){
            warningString += '\n C coil 4 mn picture is missing (final tab)';
            this.numOfWarnings ++;
          }
          if(this.data.pics['e_coil_4_mn'] === null){
            warningString += '\n E coil 4 mn picture is missing (final tab)';
            this.numOfWarnings ++;
          }
          if(this.data.pics['ahu_furn_4_mn'] === null){
            warningString += '\n AHU furn 4 mn picture is missing (final tab)';
            this.numOfWarnings ++;
          }
          if(this.data.pics['db4_ext'] === null){
            warningString += '\n DB4 exterior leakage picture is missing (testing tab)';
            this.numOfWarnings ++;
          }

        }

    if(this.raterform.get('dhw_1_location').value == ''){
      warningString += '\n DHW 1 location (final tab)';
      this.numOfWarnings ++;
    }

    if(this.data.pics['dhw_1_mn'] === null){
      warningString += '\n DHW 1 mn picture is missing (final tab)';
      this.numOfWarnings ++;
    }

    if(this.customerObj && this.customerObj.customer_id == 62){
      if(this.raterform.get('loflowafx').value === null && this.data.pics['loflowafx'] === null){
        warningString += '\n Make sure there is a picture or value for Low Flow Fixtures (final tab)';
        this.numOfWarnings ++;
      }
    }
    return warningString;
  }

  openAtticTentModal(): void {

    const dialogRef = this.dialog.open(AtticTentWarningComponent, {
      width: '90%',
      height: '600px',
      data: {},
      panelClass: 'custom-dialog-container'
    });


    this.subscriptions.add(dialogRef.afterClosed().subscribe(result => {
      if(result == 1){
        this.dialog.closeAll();
        this.log.info(this.usernamee + ' chose to close the raterform anyway when attic tent warning was presented for form with id: ' + this.form_id + ' street address: ' + this.street_address + ' subdivision and lot: ' + this.subdivision_name + ' - ' + this.lot);
      }
    }));

  }

  openFinalWarningsModal(warnings): void {

    const dialogRef = this.dialog.open(WarningModalComponent, {
      width: '95vw',
      height: '95vh',
      data: warnings,
      panelClass: 'custom-dialog-container'
    });

    this.subscriptions.add(dialogRef.afterClosed().subscribe(result => {
      if(result == 1){
        this.dialog.closeAll();
        this.log.info(this.usernamee + ' chose to close the raterform when following warnings were presented for form with id: ' + this.form_id + ' street address: ' + this.street_address + ' subdivision and lot: ' + this.subdivision_name + ' - ' + this.lot + ' Warnings: ' + warnings);
      }
    }));
    
  }

  getStageDone(systemNo): string {
    return this.raterform.get(`stagedone${systemNo}`).value;
  }

  getLeakageTarget(systemNo): any {
    if(this.raterform.get(`stagedone${systemNo}`).value.length > 1){
      
      //if it includes 'rough' then return '8%', otherwise, return '4%'
      if(this.raterform.get(`stagedone${systemNo}`).value.toLowerCase().includes('rough')){
        return this.raterform.get(`noreturn${systemNo}`).value >= 3 ? 6 : 4;
      } else {
        return this.raterform.get(`noreturn${systemNo}`).value >= 3 ? 12 : 8;
      }
    } else {
      //we'll default it to 8. 
      return this.raterform.get(`noreturn${systemNo}`).value >= 3 ? 12 : 8;
    }
  }

  getGradeValue(field: string, sysNo: number): any {

    if(field.includes('hvac')) {
      return this.raterform.get(`hvac${sysNo}name`).value || this.sys1grade.name;
    } else if(field.includes('returns')){
      return this.raterform.get(`noreturn${sysNo}`).value;
    }else if(field.includes('leakage')){
      return this.raterform.get(`hvac${sysNo}totpcnt`).value;
    }else if(field.includes('lineset') || field.includes('linesetPhoto')){
      return this[`sys${sysNo}grade`].linesetPhoto;
    }else if(field === 'voltsPhoto'){
      return this[`sys${sysNo}grade`].voltsPhoto;
    }else if(field === 'ampsPhoto'){
      return this[`sys${sysNo}grade`].ampsPhoto;
    }else if(field === 'airflowReport'){
      return this[`sys${sysNo}grade`].airflowReport;
    }
  }

  openWarningModal(warnings) :void {

    //let raterform = this.dialogRef;

    const dialogRef = this.dialog.open(WarningModalComponent, {
      width: '90%',
      height: '600px',
      data: warnings,
      panelClass: 'custom-dialog-container'
    });

    this.subscriptions.add(dialogRef.afterClosed().subscribe(result => {
      if(result == 1){

        this.dialog.closeAll();

        if(this.isFinal){

          //check BD and lto

          let testingWarnings = '';

          if(this.raterform.get('blower_door').value == 0){
            testingWarnings += '\n Blower Door value is 0!';
          }

          else if (this.raterform.get('ach50').value == 0){
            testingWarnings += '\n Ach50 value is 0!';
          }



          for (let i = 1; i <= 4; i++) {
            const systemName = `hvac${i}name`;
            const extPcnt = `hvac${i}extpcnt`;

            if (this.raterform.get(systemName).value.length > 1) {
              if (this.raterform.get(extPcnt).value == 0) {
                testingWarnings += `\n HVAC System ${i} has 0% leakage to outside, confirm that this is correct!`;
              }
            }
          }

          const dialogRef2 = this.dialog.open(WarningModalComponent, {
            width: '90%',
            height: '600px',
            data: testingWarnings,
          });

          this.subscriptions.add(dialogRef2.afterClosed().subscribe(result => {
            if(result == 1){
              this.dialog.closeAll();

            }
          }))



        }else {
          this.dialog.closeAll();
        }

        //when this modal closes, check for errors and open the next Warning Modal component



      }

    }));

  }


  onEnter(auto: MatAutocomplete): void {
    //if (!auto.optionSelected) {
      this.raterform.get('tagControl').setValue('');
    //}

  }

  addTag(event: MatChipInputEvent, tag?: any): void {

    let today = new Date();
    let date = (today.getMonth() + 1) + '/' + today.getDate();
    let time = today.getHours() + ":" + (today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes());

    let dateTime = date + ' ' + time;

    const input = event.input;
    // Only add tag if it is not already selected
    if(tag){
      if (this.inputTags) {
        const tagIds = this.inputTags.map(existingTag => existingTag.id);
        if (!tagIds.includes(tag.id)) {
          this.inputTags.push(tag);
          this.log.info(this.usernamee + ' added tag: ' + tag.displayname + ' to form with id: ' + this.form_id + ' street address: ' + this.street_address + ' subdivision and lot: ' + this.subdivision_name + ' - ' + this.lot);

          //add tag name to finalnotes4builder control value
          //this.raterform.get('finalnotes4builder').setValue(this.raterform.get('finalnotes4builder').value + 'Tag: "' + tag.displayname  + '" added by ' + this.initials + ' on ' + dateTime + '\n');
        }
      }
    }
    input.value = '';

    //this.processTags();

  }

  setSysNo(systemNo: number): void {
    this.systemNo = systemNo;
    this.currentGrade = this[`sys${systemNo}grade`];
    this.curr_sys_grading_stagedone =  this.raterform.get(`stagedone${systemNo}`).value;
    this.leakageTarget = this.getLeakageTarget(systemNo);

    //set the grade form controls
    this.raterform.get('volts').setValue(this.currentGrade?.volts);
    this.raterform.get('amps').setValue(this.currentGrade?.amps);

    const watts = Number(this.currentGrade?.watts);
    this.raterform.get('watts').setValue(
      Number.isFinite(watts) ? watts.toFixed(2) : null
    );

    this.raterform.get('calculatedAirFlowGrade').setValue(this.currentGrade?.calcAirflowGrade);
    this.raterform.get('lineset').setValue(this.currentGrade?.linesetLength);
    this.raterform.get('liquiddiameter').setValue(this.currentGrade?.liquidLineDiameter);
    this.raterform.get('chargedev').setValue(this.currentGrade?.chargedev);
    this.raterform.get('prechargedistance').setValue(this.currentGrade?.prechargedDistance);
    this.raterform.get('ozrefrigerant').setValue(this.currentGrade?.refrigerantNeeded);
    this.raterform.get('airflowtestmode').setValue(this.currentGrade?.airflowtestmode);
    this.raterform.get('tonnage').setValue(this.currentGrade?.tonnage);
    this.raterform.get('manualcalc').setValue(this.currentGrade?.manualcalc);
    this.raterform.get('manualdesign').setValue(this.currentGrade?.manualdesign);
    this.raterform.get('cfm_per_ton').setValue(this.currentGrade?.cfmPerTon || 400);



    this.calculateGrade();
    this.updateManualBounds();


  }

  toggleManualCalc(event: any, sys): void {
    if (event.checked) {
      this.changeCurrentGradeValue(null,'tonnage', sys);
      this.raterform.get('tonnage')?.setValue(null); // Clear tonnage if manual calc is selected
      this.updateManualBounds();
    } else {
      this.changeCurrentGradeValue(null,'manualdesign', sys);
      this.raterform.get('manualdesign')?.setValue(null); // Clear manual design if tonnage is selected
      this.manualUpperBound = null;
      this.manualLowerBound = null;
    }
  }

  updateBDFactors(name): void {
    this[`${name}`] = this.initialValue;

    this[`${name}_changed`] = true;
    this.show_bd_factor_warning = true;
  }
    
  

  updateManualBounds(): void {
    
    const manualDesign = this.raterform.get('manualdesign')?.value;

    if (!isNaN(manualDesign) && manualDesign !== null) {

      

      //this.manualUpperBound = Math.floor(manualDesign * 1.15); // +15%

      //this.manualLowerBound = Math.floor(manualDesign * 0.85); // -15%
    } else {
      //this.manualUpperBound = null;
      //this.manualLowerBound = null;
    }
  }

  isAirflowWithinRange(): boolean {
    const airflow = this.getGradingTotalAirflow(this.systemNo);
    return airflow >= this.getLowerBound(this.raterform.get('tonnage').value) && airflow <= this.getUpperBound(this.raterform.get('tonnage').value);
  }

  isAirflowWithinRangeManual(): boolean {
    const airflow = this.getGradingTotalAirflow(this.systemNo);
    return airflow >= this.manualLowerBound && airflow < this.manualUpperBound;
  }


  calculateGrade(): void {

      const watts = this.raterform.get('watts')?.value;
      const airflow = this.getGradingTotalAirflow(this.systemNo);
    
      if (!watts || !airflow) {
        this.raterform.get('calculatedAirFlowGrade').setValue(null);
        this.wattscfm = null;
        return;
      }
    
      const wacfm = watts / airflow;
    
      if (wacfm <= 0.45) {
        this.raterform.get('calculatedAirFlowGrade').setValue('I');
        this.changeCurrentGradeValue('I', 'calcAirflowGrade', this.systemNo);
       // this.currentGradeText = ''
      } else if (wacfm > 0.45 && wacfm <= 0.58) {
        this.raterform.get('calculatedAirFlowGrade').setValue('II');
        this.changeCurrentGradeValue('II', 'calcAirflowGrade', this.systemNo);
      } else {
        this.raterform.get('calculatedAirFlowGrade').setValue('III');
        this.changeCurrentGradeValue('III', 'calcAirflowGrade', this.systemNo);
      }

      this.wattscfm = Number(wacfm.toFixed(2));
      this.saveHvacGrading();
    

  }
  

  changeCurrentGradeValue(value, field: string, systemNo: number): void {
    if(isNumber(value)){
      value = Number(value);
    }
    this[`sys${systemNo}grade`][field] = value;
    this.subscriptions.add(this.raterFormService.updateRFLog(`System_${systemNo}_${field}`, this.form_id, value, (this.usernamee || 'Inspector')).subscribe(
      res => {
        if (res.Error) {
        }
      }
    ));
      this.saveHvacGrading(false,[`${field}`]);
  }

  updateWatts(): void {
    const volts = this.raterform.get('volts').value;
    const amps = this.raterform.get('amps').value;

    if (volts && amps) {
      this.raterform.get('watts').setValue(volts * amps);
      this[`sys${this.systemNo}grade`].watts = volts * amps;
    }
      this.saveHvacGrading(false, ['watts']);
  }

  calculateOzNeeded(): void {

    //Extra Line Length=Line Set Length−Pre-Charged Distance


    const lineSetLength = this.raterform.get('lineset').value;
    const preChargedDistance = this.raterform.get('prechargedistance').value;
    const liquidDiameter = Number(this.raterform.get('liquiddiameter').value);

    if (lineSetLength && preChargedDistance && liquidDiameter) {
      const extraLineLength = lineSetLength - preChargedDistance;

      // Calculate the volume in cubic inches
      const radius = liquidDiameter / 2;
      const volumeCubicInches = Math.PI * Math.pow(radius, 2) * (extraLineLength * 12); // 12 inches per foot
  
      // Convert volume to ounces (assuming 0.5 oz per cubic inch for refrigerant density)
      const refrigerantOunces = volumeCubicInches * 0.5;
      this.raterform.get('ozrefrigerant').setValue(Number(refrigerantOunces).toFixed(2));
    }
      this.saveHvacGrading();
    // Calculate the extra line length
  }


  removeTag(tag: any): void {
    const index = this.inputTags.indexOf(tag);

    if (index >= 0) {
      this.log.info(this.usernamee + ' removed tag: ' + tag.displayname + ' to form with id: ' + this.form_id + ' street address: ' + this.street_address + ' subdivision and lot: ' + this.subdivision_name + ' - ' + this.lot);

      this.inputTags.splice(index, 1);
    }
  }




  setElevNA(direction) {

    let url;

    switch(direction){

      case 1:
        url = '/rhAPI/elev/left/' + this.location_id
        this.subscriptions.add(this.raterFormService.updateElevPhotoRecord(url, 'N/A').subscribe(
          (response) => {
          }, (error) => {
          }));
        this.messager.openSnackBar('Left picture set to N/A', '', 'successAlert');
        this.elev_left =  'N/A';
        break;
      case 2:
        url = '/rhAPI/elev/right/' + this.location_id
        this.subscriptions.add(this.raterFormService.updateElevPhotoRecord(url, 'N/A').subscribe(
          (response) => {
          }, (error) => {
          }));
        this.messager.openSnackBar('Right picture set to N/A', '', 'successAlert');
        this.elev_right =  'N/A';
        break;
      case 3:
        url = '/rhAPI/elev/front/' + this.location_id
        this.subscriptions.add(this.raterFormService.updateElevPhotoRecord(url, 'N/A').subscribe(
          (response) => {
          }, (error) => {
          }));
        this.messager.openSnackBar('Front picture set to N/A', '', 'successAlert');
        this.elev_front =  'N/A';
        break;
      case 4:
        url = '/rhAPI/elev/back/' + this.location_id
        this.subscriptions.add(this.raterFormService.updateElevPhotoRecord(url, 'N/A').subscribe(
          (response) => {
          }, (error) => {
          }));
        this.messager.openSnackBar('Back picture set to N/A', '', 'successAlert');
        this.elev_back = 'N/A';
        break;
    }

  }


  openImage(index: number) {
    this.openPhotoViewer(this.checklistItems[index].photos[0]);
  }

  openPhotoInNewTab(url: string) {
    if (!url) return;
    const win = window.open('', '_blank');
    if (!win) return;
    win.document.body.style.cssText = 'margin:0;background:#111;';
    const img = win.document.createElement('img');
    img.src = url;
    img.style.cssText = 'display:block;max-width:100%;margin:0 auto;';
    win.document.body.appendChild(img);
  }

  openPhotoViewer(url: string) {
    if (!url) return;
    this.dialog.open(PhotoViewerDialogComponent, {
      data: { url },
      width: '100vw',
      maxWidth: '100vw',
      height: '100dvh',
      maxHeight: '100dvh',
      panelClass: 'photo-viewer-panel',
      backdropClass: 'photo-viewer-backdrop',
    });
  }

  viewPic(fieldname) {
    this.openPhotoViewer(this.data.pics[fieldname]);
  }

  openBedroomInfo() {
    this.dialog.open(BedroomDefinitionDialogComponent, {
      width: '90vw',
      maxWidth: '700px',
      panelClass: 'custom-dialog-container'
    });
  }


  longRipple(theRipple: MatRipple) {
    const ripRef = theRipple.launch({
      persistent: true,
      centered: true,
      color: 'lightgreen',
      animation: {
        enterDuration: 1000,
        exitDuration: 2000
      }
    });
    ripRef.fadeOut();
  }

  longRippleError(theRipple: MatRipple) {
    const ripRef = theRipple.launch({
      persistent: true,
      centered: true,
      color: 'red',
      animation: {
        enterDuration: 1000,
        exitDuration: 2500
      }
    });
    ripRef.fadeOut();
  }

  changeView(): void {

    this.isHorizontal = !(this.isHorizontal);
    this.toggleLabel = this.isHorizontal ? 'Vertical' : 'Horizontal';

  }


  onFilePicked(event: Event, index, field, mf: boolean = false, options: any = {}): void {

    this.messager.openSnackBar('Uploading picture in background...', '', 'basicAlert');
    const _self = this;
    //let fileObj =  File;
    try{

      const file: File = (event.target as HTMLInputElement).files[0];
      //this will be our 'key'

      const fileExt = file.name.split('.').pop()?.toLowerCase();
      const uploadImageLabel = this.job_id + '_' + field +  '-' + Date.now();
      this.activeUploadingField = uploadImageLabel;

      const BUCKET = 'inspexn';

      if (fileExt !== 'jpg' && fileExt !== 'jpeg') {
        this.messager.openSnackBar('Only JPG and JPEG images are allowed!', '', 'errorAlert');
        return; // Exit the function if the file type is not JPG or JPEG
      }

      this.currentUpload = {
        active: true,
        field: field,
        percent: 0
      };

      const MAX_WIDTH = 1024;

      this.resizeWithExif(file, MAX_WIDTH)
      .then(function({exif, resizedFile }){


        _self.subscriptions.add(_self.raterFormService.addExifData({imagename:uploadImageLabel,exifdata:exif}).subscribe());

        _self.raterFormService.getPresignedURL(uploadImageLabel, file.type)
        .subscribe(res => {
          const url = res.url;
          const imageLabel = uploadImageLabel;

          let slowNetworkNotified = false;
          const starttime = performance.now();
          _self.uploadProgress[uploadImageLabel] = 0;

          _self.subscriptions.add(
            _self.raterFormService.uploadDirectToS3(url, resizedFile)
            .subscribe({
              next: (evt) => {
                //we'll update progress here

                if(evt.type === HttpEventType.UploadProgress && evt.total){
                  const elapsedsec = (performance.now() - starttime)/1000;
                  const percent = Math.round(100 * evt.loaded/ evt.total); 
                  _self.uploadProgress[uploadImageLabel] = percent;

                if(_self.activeUploadingField !== uploadImageLabel){
                  return;
                }

                _self.currentUpload = {
                    active: true,
                    field,
                    percent
                  };

                  // we wait until an arbitrary minimum of 50 kb is uploaded and 
                  // 1 second has passed before we determine if a connection is slow. 
                  // This is so that low file sizes don't set off a false notification. 
                  const BYTES_TO_WAIT_FOR = 50 * 1024;

                  if(!slowNetworkNotified && evt.loaded > BYTES_TO_WAIT_FOR && elapsedsec >= 1){
                    const kbps = (evt.loaded/ 1024) / elapsedsec; 
                    console.log('Upload speed kbps: ' + kbps);
                    console.log('Upload threshold: ', _self.configs.SLOW_UPLOAD_THRESHOLD);

                    if(kbps < _self.configs.SLOW_UPLOAD_THRESHOLD ){
                      slowNetworkNotified = true;
                      _self.messager.openSnackBar('Slow network detected, may take longer than usual to upload...', '', 'warningAlert');
                    }
                
                  }

                }else if (evt.type === HttpEventType.Response){

                  _self.proceedUpload(
                    resizedFile,
                    exif,
                    uploadImageLabel,
                    field,
                    index,
                    mf,
                    options?.gradingSystemNo ?? options?.sysNo ?? -1,
                    fileExt
                  );


                  _self.messager.openSnackBar(`${field} photo upload finished.`, '', 'successAlert');
                  if(_self.activeUploadingField !== uploadImageLabel){
                    return;
                  }

                  _self.currentUpload = {
                    active: true,
                    field,
                    percent: 100
                  };

                  setTimeout(() => {
                    _self.currentUpload = {
                      active: false,
                      field: '',
                      percent: 0
                    };
                  }, 1000);
                }
              }, 
              error: (err) => {

                if(_self.activeUploadingField === uploadImageLabel){
                  _self.currentUpload = {
                    active: false,
                    field: '',
                    percent: 0 
                  };
                }

                let userMessage = '';
                //some human readable messages for common errors
                if (err.status === 0) {
                  // Network issue, CORS issue or offline
                  if (!navigator.onLine) {
                    userMessage = `Upload failed: no network connection. Please reconnect and try again.`;
                  } else {
                    userMessage = `Upload failed due to a network error (connection lost or blocked). Please try again.`;
                  }
                } else if (err.status === 403) {
                  // Very common with expired presigned URLs
                  userMessage = `Upload failed: upload link expired or was rejected. Please try again.`;
                } else if (err.status >= 500) {
                  userMessage = `Upload failed: server error (${err.status}). Please try again later.`;
                } else {
                  userMessage = `Upload failed (${err.status}): ${err.statusText || 'Unexpected error.'}`;
                }

                _self.uploadProgress[uploadImageLabel] = -1;
                _self.uploadErrors[uploadImageLabel] = userMessage + '\n Details:  ' + err.message;
                _self.messager.openSnackBar('Upload failed: (see support tab for details)', '', 'errorAlert')
              }
            })
          )
        })
      }).catch((err) => {
        console.error(err);
        this.currentUpload = {
          active: false,
          field: '',
          percent: 0
        };
        this.messager.openSnackBar(
          'Error processing the image: ' + err.message,
          '',
          'errorAlert'
        );
      });
    }catch(err){
      this.messager.openSnackBar('Error processing the image: ' + err.message, '', 'errorAlert');
    }

  }

    proceedUpload(thefile: File, exifObj: any, uploadImageLabel: string, field: string, index: number, mf: boolean = false, sysNo: number = -1, fileExt: string = '.jpg'): void {

        if(mf){
          this.subscriptions.add(this.raterFormService.uploadImageChecklist(thefile, uploadImageLabel).subscribe(
            response => {
               var urlpic = 'https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.' + fileExt;

              const itemToUpdate = this.mfChecklistItems.find(item => item.field === field);
              if (itemToUpdate) {
                if (!itemToUpdate.photos) itemToUpdate.photos = [];
                itemToUpdate.photos.push(urlpic);
                itemToUpdate.photo = urlpic;
                this.currentMFphotoobjects.push(urlpic);
                this.selectionChangedMF(itemToUpdate.value,field, true);

                this.subscriptions.add(this.raterFormService.updateRFLog('ESMFNC pic for ' + itemToUpdate.field, this.form_id, itemToUpdate.photo, (this.usernamee || 'Inspector')).subscribe(
                  res => {
                  }
                ));

                
              let uploadobj = { field_name : field, image_url : urlpic}
              this.subscriptions.add(this.raterFormService.insertpicsToFormTable(this.form_id,uploadobj).subscribe());
                this.cdr.detectChanges();
              }
            }));
        }else {
          //write to old table. For the time being, locpics will still hold last pic taken as the current 'picture.'
          this.subscriptions.add(this.raterFormService.uploadImageChecklist(thefile, uploadImageLabel).subscribe(
            (response) => {
              var urlpic = 'https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.' + fileExt;
              this.subscriptions.add(this.raterFormService.updateImageField(this.data.pics.id, field, urlpic).subscribe(
                (res) => {

                    if(index > -1){
                      this.checklistItems[index].photos.push('https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.' + fileExt);
                      this.currentphotoobjects.push('https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.' + fileExt);
                      this.bumpChecklistPhotoCount(field, 1);
                    }else {
                      this.data.pics[field] = 'https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.' + fileExt;
                      // Update selfie photos array for immediate preview
                      if(field === 'selfie_pic'){
                        this.selfiepics.push('https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.' + fileExt);
                      }
                      // Update loflowafx photos array for immediate preview and insert to formpics
                      if(field === 'loflowafx'){
                        this.loflowafxPhotos.push('https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.' + fileExt);
                        let uploadobj = { field_name: field, image_url: urlpic };
                        this.subscriptions.add(this.raterFormService.insertpicsToFormTable(this.form_id, uploadobj).subscribe());
                      }
                      // Update vent_ctrl photos array for immediate preview and insert to formpics
                      if(field === 'vent_ctrl'){
                        this.ventCtrlPhotos.push('https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.' + fileExt);
                        let uploadobj = { field_name: field, image_url: urlpic };
                        this.subscriptions.add(this.raterFormService.insertpicsToFormTable(this.form_id, uploadobj).subscribe());
                      }
                      // Update es_ceiling_fans photos array for immediate preview and insert to formpics
                      if(field === 'es_ceiling_fans'){
                        // Preserve any pre-existing legacy single photo by migrating it into formpics
                        // before the form table pic column gets overwritten with the new photo.
                        if(this.esCeilingFansLegacyPic){
                          let legacyobj = { field_name: field, image_url: this.esCeilingFansLegacyPic };
                          this.subscriptions.add(this.raterFormService.insertpicsToFormTable(this.form_id, legacyobj).subscribe());
                          this.esCeilingFansLegacyPic = '';
                        }
                        this.esCeilingFansPhotos.push('https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.' + fileExt);
                        let uploadobj = { field_name: field, image_url: urlpic };
                        this.subscriptions.add(this.raterFormService.insertpicsToFormTable(this.form_id, uploadobj).subscribe());
                      }
                      // Update all_otr_ceilings photos array for immediate preview and insert to formpics
                      if(field === 'all_otr_ceilings'){
                        // Preserve any pre-existing legacy single photo by migrating it into formpics
                        // before the form table pic column gets overwritten with the new photo.
                        if(this.allOtrCeilingsLegacyPic){
                          let legacyobj = { field_name: field, image_url: this.allOtrCeilingsLegacyPic };
                          this.subscriptions.add(this.raterFormService.insertpicsToFormTable(this.form_id, legacyobj).subscribe());
                          this.allOtrCeilingsLegacyPic = '';
                        }
                        this.allOtrCeilingsPhotos.push('https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.' + fileExt);
                        let uploadobj = { field_name: field, image_url: urlpic };
                        this.subscriptions.add(this.raterFormService.insertpicsToFormTable(this.form_id, uploadobj).subscribe());
                      }
                    }

                    if(sysNo > -1){
                      this.changeCurrentGradeValue(urlpic, field, sysNo);
                      this.cdr.detectChanges();
                      this.subscriptions.add(this.raterFormService.updateRFLog(`${field}_${sysNo}`, this.form_id,uploadImageLabel,(this.usernamee || 'Inspector')).subscribe());
                    }else{
                      this.subscriptions.add(this.raterFormService.updateRFLog(field + '_pic', this.form_id,uploadImageLabel,(this.usernamee || 'Inspector')).subscribe(
                        res => {
                          if (res.Error) {
                            this.logPictureError(field, this.usernamee, this.form_id, this.street_address, this.subdivision_name, this.lot, res.Message);
                          }
                        }, err => {
                          this.logPictureError(field, this.usernamee, this.form_id, this.street_address, this.subdivision_name, this.lot, err);
                          this.messager.openSnackBar('Error updating RF log: ' + err.message, '', 'errorAlert');
                        }
                      ));
                    }

                }, err => {
                    this.subscriptions.add(this.raterFormService.updateRFLog(field + '_pic', this.form_id,'UPLOAD FAILED',(this.usernamee || 'Inspector')).subscribe(
                      res => {
                        if (res.Error) {
                          this.messager.openSnackBar('Error updating RF log: ' + res.Message, '', 'errorAlert');
                        }
                      }, err => {
                          this.logPictureError(field, this.usernamee, this.form_id, this.street_address, this.subdivision_name, this.lot, err);
                        this.messager.openSnackBar('Error updating RF log: ' 
                          + err.message, '', 'errorAlert');
                      }
                    ));
                    this.logPictureError(field, this.usernamee, this.form_id, this.street_address, this.subdivision_name, this.lot, err);
                    this.log.error('Error updating image field in locpics table for field: ' 
                      + field 
                      + ' intended label: ' 
                      + uploadImageLabel 
                      + ' Error Messasge: ' 
                      + err.message);

                    this.messager.openSnackBar('Image uploaded, but DB field did not: ' + err.message, '', 'errorAlert');
                }));
            },
            (error) => {
                  this.subscriptions.add(this.raterFormService.updateRFLog(field + '_pic', this.form_id,'UPLOAD FAILED',(this.usernamee || 'Inspector')).subscribe(
                    res => {
                      if (res.Error) {
                        this.logPictureError(field, this.usernamee, this.form_id, this.street_address, this.subdivision_name, this.lot, error);
                      }
                    }, err => {
                      this.logPictureError(field, this.usernamee, this.form_id, this.street_address, this.subdivision_name, this.lot, error);
                    }
                  ));
                  this.logPictureError(field, this.usernamee, this.form_id, this.street_address, this.subdivision_name, this.lot, error);
                  this.messager.openSnackBar('Failed: ' + error.message, '', 'errorAlert');
            }));

          let urlpic = 'https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.' + fileExt;
          let uploadobj = { field_name : field, image_url : urlpic}

          //if it's NOT a checklist item, index will be less than 0.
          //for now we are only adding checklist items.
          if(index > -1){
            this.subscriptions.add(this.raterFormService.insertpicsToFormTable(this.form_id,uploadobj).subscribe(
              response =>{
                this.cdr.detectChanges();
              },error => {
              }
            ));
          }

          // Handle selfie photos - insert into formpics table
          if(field === 'selfie_pic'){
            this.subscriptions.add(this.raterFormService.insertpicsToFormTable(this.form_id, uploadobj).subscribe(
              response => {
              }, error => {
                this.log.error('Error inserting selfie pic to formpics for form id ' + this.form_id + ': ' + this.extractErrorMessage(error));
              }
            ));
          }

        }
      }

  extractErrorMessage = (error) => {
    if (!error) return 'Unknown error occurred';
  
    // Check various possible error message locations
    if (typeof error === 'string') return error;
    if (error.Message) return error.Message;
    if (error.message) return error.message;
    if (error.error) return error.error;
    if (error.statusText) return error.statusText;
  
    try {
      return JSON.stringify(error);
    } catch {
      return 'Error details could not be parsed';
    }
  };

  logPictureError(field: string, usernamee: string, form_id: number, street_address: string, subdivision_name: string, lot: string, err: any): void {
                  this.log.info(this.usernamee + ' received the following error when uploading a picture for field ' + field + ' for form with id: ' + this.form_id + ' street address: ' + this.street_address + ' subdivision and lot: ' + this.subdivision_name + ' - ' + this.lot + ' Error: ' + this.extractErrorMessage(err));
  }

  resizeCanvas(canvas: any, maxWidth: number, maxHeight: number): any {
    const ratio = Math.min(maxWidth / canvas.width, maxHeight / canvas.height);
    const newWidth = canvas.width * ratio;
    const newHeight = canvas.height * ratio;
    const newCanvas = document.createElement('canvas');
    newCanvas.width = newWidth;
    newCanvas.height = newHeight;
    newCanvas.getContext('2d').drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, newWidth, newHeight);
    return newCanvas;
  }

  dataURLtoBlob(dataURL: string): any {
    const byteString = atob(dataURL.split(',')[1]);
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  updateExifData(file: any, exifData: any): any {
    const newData = piexif.insert(piexif.dump(exifData), file);
    const newFile = new File([newData], file.name, { type: 'image/jpeg' });
    return newFile;
  }

  alertpic(value): void {
    alert(value);
  }

  pictureClick(value): void {
    document.getElementById(value).click();
  }

  openJobScopeModal(jobscope: any) {

  }

  photoTaken(event: Event, field): void {

    this.onFilePicked(event, -1, field);

    //this.messager.openSnackBar('Uploading picture in background...', '', 'basicAlert');
    //const _self = this;
    ////let fileObj =  File;
    //const file: File = (event.target as HTMLInputElement).files[0];
    //const uploadImageLabel = this.job_id + '_' + field + '-' + Date.now();
    //const fileExt = file.name.split('.').pop()?.toLowerCase();
    //if (fileExt !== 'jpg' && fileExt !== 'jpeg') {
       //this.messager.openSnackBar('Only JPG and JPEG images are allowed!', '', 'errorAlert');
       //return; // Exit the function if the file type is not JPG or JPEG
     //}
    ////fileObj = FILE;
    //let fileUrl;
    //let jid = this.job_id;
    ////File.name = this.job_id + '_' + field;
    //const reader = new FileReader();
    ////const readerData = new FileReader();
    //reader.readAsDataURL(file);

    //reader.onload = function(event){

      ////let imgBuffer = event.target.result as ArrayBuffer;

      //let imgurl = event.target.result as string;
      //const image = new Image();
      //const exifObj = piexif.load(imgurl);

      //const canvas = document.createElement('canvas');
      //image.src = imgurl;
      //image.onload = function(this: HTMLImageElement){

        //const WIDTH = 700;
        //let thefile: File;
        //if (!_self.highImage) {
          //let ratio = WIDTH / this.width;
          //canvas.width = WIDTH;
          //canvas.height = this.height * ratio;
          //exifObj["0th"][piexif.ImageIFD.Orientation] = 1;
  
          //const context = canvas.getContext("2d");
          //context.drawImage(image, 0, 0, canvas.width, canvas.height);
  
          //const resizedCanvas = canvas.toDataURL('image/jpeg', 0.85);
          //const exifBytes = piexif.dump(exifObj);
          //let newImage = piexif.insert(exifBytes, resizedCanvas);
  
          //// Convert the resized image to a file
          //thefile = urlToFile(newImage, uploadImageLabel);
        //} else {
          //// If highImage is true, use the original image
          //thefile = urlToFile(imgurl, uploadImageLabel);
        //}

        //_self.subscriptions.add(_self.raterFormService.uploadImageChecklist(thefile, uploadImageLabel).subscribe(
          //(response) => {

            //if(response.Error == true){
              //_self.messager.openSnackBar('Photo did not upload: ' + response.Message, '', 'errorAlert');

              //_self.subscriptions.add(_self.raterFormService.updateRFLog(field + '_pic', _self.form_id,'UPLOAD FAILED',(_self.usernamee || 'Inspector')).subscribe(
                //res => {
                  //if (res.Error) {
                    //_self.messager.openSnackBar('Error updating RF log: ' + res.Message, '', 'errorAlert');
                  //}
                //}, err => {
                  //_self.messager.openSnackBar('Error updating RF log: ' + err, '', 'errorAlert');
                //}
              //));

              //_self.log.error(_self.usernamee + ' experienced an error uploading ' + field +  ' photo for job with id: ' + _self.job_id + ':: ' + response.Message );
            //}else {
              //_self.subscriptions.add(_self.raterFormService.addExifData({imagename:uploadImageLabel,exifdata:exifObj}).subscribe())
              //_self.subscriptions.add(_self.raterFormService.updateRFLog(field + '_pic', _self.form_id,uploadImageLabel,(_self.usernamee || 'Inspector')).subscribe(
                //res => {
                  //if (res.Error) {
                    //_self.messager.openSnackBar('Error updating RF log: ' + res.Message, '', 'errorAlert');
                  //}
                //}, err => {
                  //_self.messager.openSnackBar('Error updating RF log: ' + err, '', 'errorAlert');
                //}
              //));

              //_self.messager.openSnackBar('Successfully uploaded!', '', 'successAlert');
              //var urlpic = 'https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.jpg';
            //}

            //_self.subscriptions.add(_self.raterFormService.updateImageField(_self.data.pics.id, field, urlpic).subscribe(
              //(res) => {
                //_self.data.pics[field] = 'https://inspexn.s3.amazonaws.com/' + uploadImageLabel + '.jpg';
                //_self.cdr.detectChanges();
              //}, err => {
                //_self.log.error(_self.usernamee + ' experienced an error uploading ' + field +  ' photo for job with id: ' + _self.job_id + ':: ' + response.Message );
                //_self.messager.openSnackBar('Error updating the field: ' + err, '', 'errorAlert');
              //}));


          //},
          //(error) => {
            //_self.messager.openSnackBar('Failed: ' + error, '', 'errorAlert');
            ////alert('fail');
          //}));
          //thefile=undefined
      //}

//    }

    //function urlToFile(url, name) {

      //let arr = url.split(",");
      //let mime = arr[0];
      //let data = arr[1];

      //let dataString = atob(data);
      //let l = dataString.length;
      //let dataArr = new Uint8Array(l);

      //while(l--)
      //{
        //dataArr[l] = dataString.charCodeAt(l);
      //}

      //let file = new File([dataArr], 'file.jpg', {type: 'image/jpeg'})

      //return file;

    //}

  }



  gradingPhotoTaken(event: Event, field, sysNo): void {

    this.onFilePicked(event, -1, field, false, {
      'gradingSystemNo': sysNo,
      'field': field
    });

  }

  gradingPdfUpload(event: Event, field: string, sysNo: number): void {
    const file: File = (event.target as HTMLInputElement).files[0];
    if (!file) return;

    const fileExt = file.name.split('.').pop()?.toLowerCase() || '';
    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif', 'bmp', 'tif', 'tiff'];
    const isPdf = file.type === 'application/pdf' || fileExt === 'pdf';
    const isImage = (file.type && file.type.startsWith('image/')) || imageExts.includes(fileExt);
    if (!isPdf && !isImage) {
      this.messager.openSnackBar('Only PDF or image files are allowed!', '', 'errorAlert');
      return;
    }

    this.messager.openSnackBar('Uploading report...', '', 'basicAlert');
    // Content type must match what uploadDirectToS3 sends, or the presigned signature fails
    const contentType = file.type || 'application/octet-stream';
    const uploadKey = this.job_id + '_' + field + '-' + Date.now() + '.' + (fileExt || (isPdf ? 'pdf' : 'jpg'));

    this.subscriptions.add(
      this.raterFormService.getPresignedURL(uploadKey, contentType).subscribe(res => {
        this.subscriptions.add(
          this.raterFormService.uploadDirectToS3(res.url, file).subscribe({
            next: (evt) => {
              if (evt.type === HttpEventType.Response) {
                const reportUrl = 'https://inspexn.s3.amazonaws.com/' + uploadKey;
                this.changeCurrentGradeValue(reportUrl, field, sysNo);
                this.messager.openSnackBar('Airflow report uploaded!', '', 'successAlert');
              }
            },
            error: () => {
              this.messager.openSnackBar('Error uploading report', '', 'errorAlert');
            }
          })
        );
      })
    );
  }

async elevphotoTaken(event: Event, position: number): Promise<void> {
  this.messager.openSnackBar('Uploading picture...', '', 'basicAlert');

  const positionMapping: any = {
    1: { urlSuffix: 'back', label: 'Back photo uploaded successfully' },
    2: { urlSuffix: 'front', label: 'Front photo uploaded successfully' },
    3: { urlSuffix: 'left', label: 'Left photo uploaded successfully' },
    4: { urlSuffix: 'right', label: 'Right photo uploaded successfully' },
  };

  const mapping = positionMapping[position];
  if (!mapping) return;

  const locationId = this.location_id;
  const uploadImageLabel = `${locationId}_${mapping.urlSuffix}`;
  const partialFileName = `${uploadImageLabel}-${Date.now()}`;
  const fullFileName = `https://elevphotos.s3.amazonaws.com/${partialFileName}.jpg`;
  const urlc = `/rhAPI/elev/${mapping.urlSuffix}/${locationId}`;

  const elevMapping: any = {
    1: 'elev_back',
    2: 'elev_front',
    3: 'elev_left',
    4: 'elev_right',
  };
  this[elevMapping[position]] = '';

  const input = event.target as HTMLInputElement;
  const file: File | undefined = input?.files?.[0];
  if (!file) return;

  try {
    const exifObj = await this.extractExifFromFile(file);
    const resizedFile = await this.resizeToJpegFile(file, 700, `${partialFileName}.jpg`, 0.85);

    this.subscriptions.add(
      this.raterFormService.addExifData({ imagename: fullFileName, exifdata: exifObj }).subscribe()
    );

    this.subscriptions.add(
      this.raterFormService.updateRFLog(`${uploadImageLabel}_pic`, this.form_id, fullFileName, this.usernamee || 'Inspector')
        .subscribe(
          res => this.handleResponse(res, 'RF log'),
          err => this.messager.openSnackBar('Error updating RF log: ' + err, '', 'errorAlert')
        )
    );

    this.uploadPhoto(resizedFile, partialFileName, urlc, fullFileName, position);

  } catch (err) {
    this.messager.openSnackBar('Failed to process image: ' + (err?.message ?? err), '', 'errorAlert');
  } finally {
    // Helps mobile: allow selecting same file again
    if (input) input.value = '';
  }
}

extractExifFromFile(file: File): Promise<any> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        resolve(piexif.load(reader.result as string));
      } catch {
        resolve({});
      }
    };
    reader.onerror = () => resolve({});
    reader.readAsDataURL(file);
  });
}

resizeToJpegFile(file: File, maxWidth: number, outName: string, quality = 0.85): Promise<File> {
  return new Promise(async (resolve, reject) => {
    let bitmap: ImageBitmap | null = null;
    let canvas: HTMLCanvasElement | null = null;

    const cleanup = () => {
      bitmap?.close?.();
      bitmap = null;
      if (canvas) {
        canvas.width = 0;
        canvas.height = 0;
        canvas = null;
      }
    };

    try {
      if ('createImageBitmap' in window) {
        bitmap = await createImageBitmap(file);
        const scale = bitmap.width > maxWidth ? maxWidth / bitmap.width : 1;
        const w = Math.round(bitmap.width * scale);
        const h = Math.round(bitmap.height * scale);

        if (scale === 1) {
          cleanup();
          resolve(file); 
          return;
        }

        canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;

        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('Canvas 2D context not available');

        ctx.drawImage(bitmap, 0, 0, w, h);

        canvas.toBlob((blob) => {
          if (!blob) {
            cleanup();
            reject(new Error('Canvas toBlob failed'));
            return;
          }
          const outFile = new File([blob], outName, { type: 'image/jpeg' });
          cleanup();
          resolve(outFile);
        }, 'image/jpeg', quality);

      } else {
        // Fallback: <img> path (still avoids toDataURL for output)
        const reader = new FileReader();
        reader.onload = () => {
          const img = new Image();
          img.onload = () => {
            const scale = img.naturalWidth > maxWidth ? maxWidth / img.naturalWidth : 1;
            const w = Math.round(img.naturalWidth * scale);
            const h = Math.round(img.naturalHeight * scale);

            if (scale === 1) {
              resolve(file);
              return;
            }

            canvas = document.createElement('canvas');
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
              cleanup();
              reject(new Error('Canvas 2D context not available'));
              return;
            }

            ctx.drawImage(img, 0, 0, w, h);

            canvas.toBlob((blob) => {
              if (!blob) {
                cleanup();
                reject(new Error('Canvas toBlob failed'));
                return;
              }
              const outFile = new File([blob], outName, { type: 'image/jpeg' });
              cleanup();
              resolve(outFile);
            }, 'image/jpeg', quality);
          };
          img.onerror = () => reject(new Error('Failed to decode image'));
          img.src = reader.result as string;
        };
        reader.onerror = () => reject(new Error('Failed to read image'));
        reader.readAsDataURL(file);
      }
    } catch (e) {
      cleanup();
      reject(e instanceof Error ? e : new Error(String(e)));
    }
  });
}


  
  uploadPhoto(file: File, partialFileName: string, urlc: string, fullFileName: string, position: number) {
    this.subscriptions.add(
      this.raterFormService.uploadImageElevPhoto(file, partialFileName).subscribe(
        (res) => {
          this.messager.openSnackBar('Successfully uploaded!', '', 'successAlert');
          this.updatePhotoState(position, fullFileName);
          this.subscriptions.add(
            this.raterFormService.updateElevPhotoRecord(urlc, fullFileName).subscribe( res => this.updatePhotoState(position, fullFileName))
          );
        },
        error => this.messager.openSnackBar('Failed: ' + error, '', 'errorAlert')
      )
    );
  }
  
  updatePhotoState(position: number, fullFileName: string) {
    const photoMapping = {
      1: 'elev_back',
      2: 'elev_front',
      3: 'elev_left',
      4: 'elev_right',
    };
    this[photoMapping[position]] = fullFileName;
    this.cdr.markForCheck();
  }
  
  private handleResponse(res, context: string) {
    if (res.Error) {
      this.messager.openSnackBar(`Error updating ${context}: ${res.Message}`, '', 'errorAlert');
    }
  }
  



  sendSupportEmail() {


    let notes = (document.getElementById("supportNotes") as HTMLInputElement).value;


    this.subscriptions.add(this.ges.sendSupportEmail(notes, this.locationTxt).subscribe(
      res => {
        if (res.Error) {
          this.messager.openSnackBar('Error sending support email: ' + res.Message, '', 'errorAlert');
        } else {
          this.messager.openSnackBar('Email sent to tech support, we will respond as soon as possible! ', '', 'successAlert');
        }
      }, err => {
        this.log.error('Application error sending bail email: ' + err.toString());
      }));



  }



  expand(job, index, mf: boolean = false) {


    if(mf) {
      this.selectedMFChecklistItem = job;
      this.selectedIndexMF = index;
      (<HTMLInputElement>document.getElementById("mfchklistnote")).value = job.note.length > 0 ? job.note : '';
      (<HTMLInputElement>document.getElementById("mfchklstphoto_" + index)).value = '';

      this.class = 'fulldiv';
      this.initClass = 'hydeDiv';
    }
    else {
      this.selectedChecklistItem = job;
      this.selectedIndex = index;
      (<HTMLInputElement>document.getElementById("chklistnote")).value = job.note.length > 0 ? job.note : '';
      (<HTMLInputElement>document.getElementById("chklstphoto_" + index)).value = '';

      this.class = 'fulldiv';
      this.initClass = 'hydeDiv';

    }


  }

  tradeSelection() {

  }

  saveAdminNotes() {
    this.subscriptions.add(this.raterFormService.updateAdminNotes(this.location_id, this.adminNotesText, this.usernamee).subscribe(
      res => {
        if (res.Error) {
          this.messager.openSnackBar('Error saving admin notes: ' + res.Message, '', 'errorAlert');
        } else {
          this.messager.openSnackBar('Admin notes saved successfully! ', '', 'successAlert');
          this.closeAdminNotes();
        }
      }, err => {
        this.log.error('Application error saving admin notes: ' + err.toString());
      }));
  } 


  openAdminNotes() {
    const modal = document.getElementById('admin-notes');
    if(modal){
      modal.style.display = 'block';
    }
  }

  closeAdminNotes() {
    const modal = document.getElementById('admin-notes');
    if(modal){
      modal.style.display = 'none';
    }
  }

  openDeleteModal(photoUrl: string) {
    const modal = document.getElementById('delete-pic');
    if(modal){
      modal.style.display = 'block';
    }
    this.currDeletePhotoUrl = photoUrl;
    
  }

  deletePhoto(resp: boolean = true){
   const modal = document.getElementById('delete-pic');
    if(modal){
      modal.style.display = 'none';
    }

   if(!resp){
     return;
   }

   if(resp = false){
      return;
   }

   // Check if it's a selfie photo
   var selfieIndex = this.selfiepics.indexOf(this.currDeletePhotoUrl);
   if(selfieIndex > -1) {
     this.subscriptions.add(this.raterFormService.deletepicsFromFormTable(this.currDeletePhotoUrl).subscribe(
       res => {
         if (res.Error) {
           this.messager.openSnackBar('Error deleting selfie photo: ' + res.Message, '', 'errorAlert');
         } else {
           this.selfiepics.splice(selfieIndex, 1);
           this.cdr.detectChanges();
         }
       }, err => {
         this.log.error('_Error deleting selfie photo_ : ' + err.toString());
       }));
     return;
   }

   var index = this.currentphotoobjects.indexOf(this.currDeletePhotoUrl);
          if (index > -1) {
            if(index == this.currentphotoobjects.length - 1){
              this.subscriptions.add(this.raterFormService
                .deletelastpicsFromFormTable(
                  this.currDeletePhotoUrl,
                  this.data.pics.id,
                  this.form_id,
                  this.selectedChecklistItem.field)
                .subscribe(
              res => {
                if (res.Error) {
                  this.messager.openSnackBar('Error deleting photo: ' + res.Message, '', 'errorAlert');
                }
                this.currentphotoobjects.splice(index, 1);
                this.bumpChecklistPhotoCount(this.selectedChecklistItem.field, -1);
              }, err => {
                this.log.error('_Error deleting photo_ : ' + err.toString());
              }));
            }else{
              this.subscriptions.add(this.raterFormService.deletepicsFromFormTable(this.currDeletePhotoUrl).subscribe(
              res => {
                if (res.Error) {
                  this.messager.openSnackBar('Error deleting photo: ' + res.Message, '', 'errorAlert');
                }
                this.currentphotoobjects.splice(index, 1);
                this.bumpChecklistPhotoCount(this.selectedChecklistItem.field, -1);
              }, err => {
                this.log.error('_Error deleting photo_ : ' + err.toString());
              }));

            }
          }
  }

openDeleteModalMF(photoUrl: string) {
    const modal = document.getElementById('delete-pic-mf');
    if(modal){
      modal.style.display = 'block';
    }
    this.currDeletePhotoUrlMF = photoUrl;
  }

  deletePhotoMF(resp: boolean = true){
    const modal = document.getElementById('delete-pic-mf');
    if(modal){
      modal.style.display = 'none';
    }

    if(!resp){
      return;
    }

    var index = this.currentMFphotoobjects.indexOf(this.currDeletePhotoUrlMF);
    if (index > -1) {
      this.currentMFphotoobjects.splice(index, 1);

      if (this.selectedMFChecklistItem && this.selectedMFChecklistItem.photos) {
        const photoIdx = this.selectedMFChecklistItem.photos.indexOf(this.currDeletePhotoUrlMF);
        if (photoIdx > -1) {
          this.selectedMFChecklistItem.photos.splice(photoIdx, 1);
        }
        this.selectedMFChecklistItem.photo = this.selectedMFChecklistItem.photos.length > 0
          ? this.selectedMFChecklistItem.photos[this.selectedMFChecklistItem.photos.length - 1]
          : '';
        this.selectionChangedMF(this.selectedMFChecklistItem.value, this.selectedMFChecklistItem.field, true);
      }
    }

  }

loadSelfiePics(form_id) {

      this.raterFormService.getFormPics(form_id, 'selfie_pic').subscribe(
        (res) => {
          if (!res.Error){
            if(res.Rows > 0){
              res.Photos.forEach(photo => {
                  this.selfiepics.push(photo.image_url);
              })
            }
          }
        });

}

loadLoflowafxPhotos(form_id) {
  this.loflowafxPhotos = [];
  this.raterFormService.getFormPics(form_id, 'loflowafx').subscribe(
    (res) => {
      if (!res.Error && res.Rows > 0) {
        res.Photos.forEach(photo => {
          this.loflowafxPhotos.push(photo.image_url);
        });
      }
      // Also include the legacy single photo if it exists and isn't already in the array
      if (this.data.pics.loflowafx && this.loflowafxPhotos.indexOf(this.data.pics.loflowafx) === -1) {
        this.loflowafxPhotos.push(this.data.pics.loflowafx);
      }
    },
    (err) => {
      // On error, still show the legacy photo if it exists
      if (this.data.pics.loflowafx && this.loflowafxPhotos.indexOf(this.data.pics.loflowafx) === -1) {
        this.loflowafxPhotos.push(this.data.pics.loflowafx);
      }
    }
  );
}

openDeleteModalLoflow(photoUrl: string) {
  const modal = document.getElementById('delete-pic-loflow');
  if (modal) {
    modal.style.display = 'block';
  }
  this.currDeletePhotoUrlLoflow = photoUrl;
}

deletePhotoLoflow(resp: boolean = true) {
  const modal = document.getElementById('delete-pic-loflow');
  if (modal) {
    modal.style.display = 'none';
  }

  if (!resp) {
    return;
  }

  const index = this.loflowafxPhotos.indexOf(this.currDeletePhotoUrlLoflow);
  if (index > -1) {
    this.subscriptions.add(
      this.raterFormService.deletelastpicsFromFormTable(
        this.currDeletePhotoUrlLoflow,
        this.data.pics.id,
        this.form_id,
        'loflowafx'
      ).subscribe(
        (res) => {
          this.loflowafxPhotos.splice(index, 1);
          // Update data.pics.loflowafx to the last remaining photo or null
          if (this.loflowafxPhotos.length > 0) {
            this.data.pics.loflowafx = this.loflowafxPhotos[this.loflowafxPhotos.length - 1];
          } else {
            this.data.pics.loflowafx = null;
          }
          this.messager.openSnackBar('Photo deleted successfully', '', 'successAlert');
        },
        (err) => {
          this.messager.openSnackBar('Error deleting photo: ' + err.message, '', 'errorAlert');
        }
      )
    );
  }
}

loadVentCtrlPhotos(form_id) {
  this.ventCtrlPhotos = [];
  this.raterFormService.getFormPics(form_id, 'vent_ctrl').subscribe(
    (res) => {
      if (!res.Error && res.Rows > 0) {
        res.Photos.forEach(photo => {
          this.ventCtrlPhotos.push(photo.image_url);
        });
      }
      if (this.data.pics.vent_ctrl && this.ventCtrlPhotos.indexOf(this.data.pics.vent_ctrl) === -1) {
        this.ventCtrlPhotos.push(this.data.pics.vent_ctrl);
      }
    },
    (err) => {
      if (this.data.pics.vent_ctrl && this.ventCtrlPhotos.indexOf(this.data.pics.vent_ctrl) === -1) {
        this.ventCtrlPhotos.push(this.data.pics.vent_ctrl);
      }
    }
  );
}

openDeleteModalVentCtrl(photoUrl: string) {
  const modal = document.getElementById('delete-pic-ventctrl');
  if (modal) {
    modal.style.display = 'block';
  }
  this.currDeletePhotoUrlVentCtrl = photoUrl;
}

deletePhotoVentCtrl(resp: boolean = true) {
  const modal = document.getElementById('delete-pic-ventctrl');
  if (modal) {
    modal.style.display = 'none';
  }

  if (!resp) {
    return;
  }

  const index = this.ventCtrlPhotos.indexOf(this.currDeletePhotoUrlVentCtrl);
  if (index > -1) {
    this.subscriptions.add(
      this.raterFormService.deletelastpicsFromFormTable(
        this.currDeletePhotoUrlVentCtrl,
        this.data.pics.id,
        this.form_id,
        'vent_ctrl'
      ).subscribe(
        (res) => {
          this.ventCtrlPhotos.splice(index, 1);
          if (this.ventCtrlPhotos.length > 0) {
            this.data.pics.vent_ctrl = this.ventCtrlPhotos[this.ventCtrlPhotos.length - 1];
          } else {
            this.data.pics.vent_ctrl = null;
          }
          this.messager.openSnackBar('Photo deleted successfully', '', 'successAlert');
        },
        (err) => {
          this.messager.openSnackBar('Error deleting photo: ' + err.message, '', 'errorAlert');
        }
      )
    );
  }
}

loadEsCeilingFansPhotos(form_id) {
  this.esCeilingFansPhotos = [];
  this.esCeilingFansLegacyPic = '';
  this.raterFormService.getFormPics(form_id, 'es_ceiling_fans').subscribe(
    (res) => {
      if (!res.Error && res.Rows > 0) {
        res.Photos.forEach(photo => {
          this.esCeilingFansPhotos.push(photo.image_url);
        });
      }
      // Also include the legacy single photo if it exists and isn't already in the array.
      // It only lives in the form table pic column (not formpics), so flag it for migration
      // on the next upload to prevent it being lost when that column is overwritten.
      if (this.data.pics.es_ceiling_fans && this.esCeilingFansPhotos.indexOf(this.data.pics.es_ceiling_fans) === -1) {
        this.esCeilingFansPhotos.push(this.data.pics.es_ceiling_fans);
        this.esCeilingFansLegacyPic = this.data.pics.es_ceiling_fans;
      }
    },
    (err) => {
      // On error, still show the legacy photo if it exists
      if (this.data.pics.es_ceiling_fans && this.esCeilingFansPhotos.indexOf(this.data.pics.es_ceiling_fans) === -1) {
        this.esCeilingFansPhotos.push(this.data.pics.es_ceiling_fans);
        this.esCeilingFansLegacyPic = this.data.pics.es_ceiling_fans;
      }
    }
  );
}

openDeleteModalEsCeilingFans(photoUrl: string) {
  const modal = document.getElementById('delete-pic-esceilingfans');
  if (modal) {
    modal.style.display = 'block';
  }
  this.currDeletePhotoUrlEsCeilingFans = photoUrl;
}

deletePhotoEsCeilingFans(resp: boolean = true) {
  const modal = document.getElementById('delete-pic-esceilingfans');
  if (modal) {
    modal.style.display = 'none';
  }

  if (!resp) {
    return;
  }

  const index = this.esCeilingFansPhotos.indexOf(this.currDeletePhotoUrlEsCeilingFans);
  if (index > -1) {
    // If the legacy single photo is being deleted, clear the migration flag so it
    // isn't re-inserted into formpics on the next upload.
    if (this.esCeilingFansLegacyPic === this.currDeletePhotoUrlEsCeilingFans) {
      this.esCeilingFansLegacyPic = '';
    }
    this.subscriptions.add(
      this.raterFormService.deletelastpicsFromFormTable(
        this.currDeletePhotoUrlEsCeilingFans,
        this.data.pics.id,
        this.form_id,
        'es_ceiling_fans'
      ).subscribe(
        (res) => {
          this.esCeilingFansPhotos.splice(index, 1);
          // Update data.pics.es_ceiling_fans to the last remaining photo or null
          if (this.esCeilingFansPhotos.length > 0) {
            this.data.pics.es_ceiling_fans = this.esCeilingFansPhotos[this.esCeilingFansPhotos.length - 1];
          } else {
            this.data.pics.es_ceiling_fans = null;
          }
          this.messager.openSnackBar('Photo deleted successfully', '', 'successAlert');
        },
        (err) => {
          this.messager.openSnackBar('Error deleting photo: ' + err.message, '', 'errorAlert');
        }
      )
    );
  }
}

loadAllOtrCeilingsPhotos(form_id) {
  this.allOtrCeilingsPhotos = [];
  this.allOtrCeilingsLegacyPic = '';
  this.raterFormService.getFormPics(form_id, 'all_otr_ceilings').subscribe(
    (res) => {
      if (!res.Error && res.Rows > 0) {
        res.Photos.forEach(photo => {
          this.allOtrCeilingsPhotos.push(photo.image_url);
        });
      }
      // Also include the legacy single photo if it exists and isn't already in the array.
      // It only lives in the form table pic column (not formpics), so flag it for migration
      // on the next upload to prevent it being lost when that column is overwritten.
      if (this.data.pics.all_otr_ceilings && this.allOtrCeilingsPhotos.indexOf(this.data.pics.all_otr_ceilings) === -1) {
        this.allOtrCeilingsPhotos.push(this.data.pics.all_otr_ceilings);
        this.allOtrCeilingsLegacyPic = this.data.pics.all_otr_ceilings;
      }
    },
    (err) => {
      // On error, still show the legacy photo if it exists
      if (this.data.pics.all_otr_ceilings && this.allOtrCeilingsPhotos.indexOf(this.data.pics.all_otr_ceilings) === -1) {
        this.allOtrCeilingsPhotos.push(this.data.pics.all_otr_ceilings);
        this.allOtrCeilingsLegacyPic = this.data.pics.all_otr_ceilings;
      }
    }
  );
}

openDeleteModalAllOtrCeilings(photoUrl: string) {
  const modal = document.getElementById('delete-pic-allotrceilings');
  if (modal) {
    modal.style.display = 'block';
  }
  this.currDeletePhotoUrlAllOtrCeilings = photoUrl;
}

deletePhotoAllOtrCeilings(resp: boolean = true) {
  const modal = document.getElementById('delete-pic-allotrceilings');
  if (modal) {
    modal.style.display = 'none';
  }

  if (!resp) {
    return;
  }

  const index = this.allOtrCeilingsPhotos.indexOf(this.currDeletePhotoUrlAllOtrCeilings);
  if (index > -1) {
    // If the legacy single photo is being deleted, clear the migration flag so it
    // isn't re-inserted into formpics on the next upload.
    if (this.allOtrCeilingsLegacyPic === this.currDeletePhotoUrlAllOtrCeilings) {
      this.allOtrCeilingsLegacyPic = '';
    }
    this.subscriptions.add(
      this.raterFormService.deletelastpicsFromFormTable(
        this.currDeletePhotoUrlAllOtrCeilings,
        this.data.pics.id,
        this.form_id,
        'all_otr_ceilings'
      ).subscribe(
        (res) => {
          this.allOtrCeilingsPhotos.splice(index, 1);
          // Update data.pics.all_otr_ceilings to the last remaining photo or null
          if (this.allOtrCeilingsPhotos.length > 0) {
            this.data.pics.all_otr_ceilings = this.allOtrCeilingsPhotos[this.allOtrCeilingsPhotos.length - 1];
          } else {
            this.data.pics.all_otr_ceilings = null;
          }
          this.messager.openSnackBar('Photo deleted successfully', '', 'successAlert');
        },
        (err) => {
          this.messager.openSnackBar('Error deleting photo: ' + err.message, '', 'errorAlert');
        }
      )
    );
  }
}

loadData(job, index, mf:boolean = false) {

    this.currentphotoobjects = [];
    this.currentMFphotoobjects = [];
    if(mf){

      this.selectedMFChecklistItem = job;
      this.presetArray = this.displayPresets(this.selectedMFChecklistItem.description.split(' ')[0]);

      this.selectedIndexMF = index;
      (<HTMLInputElement>document.getElementById("mfchklistnote")).value = job.note.length > 0 ? job.note : '';

      if (this.selectedMFChecklistItem.photos && this.selectedMFChecklistItem.photos.length > 0) {
        this.currentMFphotoobjects = [...this.selectedMFChecklistItem.photos];
      } else if (this.selectedMFChecklistItem.photo && this.selectedMFChecklistItem.photo.length > 0) {
        this.currentMFphotoobjects = [this.selectedMFChecklistItem.photo];
      } else {
        this.currentMFphotoobjects = [];
      }

    }else {
      this.selectedChecklistItem = job;
      this.presetArray = this.displayPresets(this.selectedChecklistItem.description.split(' ')[0]);

      this.raterFormService.getFormPics(this.form_id, this.selectedChecklistItem.field).subscribe(
        (res) => {
          if (!res.Error){
            if(res.Rows > 0){
              res.Photos.forEach(photo => {
                  this.currentphotoobjects.push(photo.image_url);
              }) 
            } 
            
            if(this.currentphotoobjects.indexOf(this.data.pics[this.selectedChecklistItem.field]) === -1 &&
                this.data.pics[this.selectedChecklistItem.field] != null){
                this.currentphotoobjects.push(this.data.pics[this.selectedChecklistItem.field]);
            }
          }else {
            if( this.currentphotoobjects.indexOf(this.data.pics[this.selectedChecklistItem.field]) === -1 &&
                this.data.pics[this.selectedChecklistItem.field] != null){
              this.currentphotoobjects.push(this.data.pics[this.selectedChecklistItem.field]);
            }
          }
      }, err => {
           if( this.currentphotoobjects.indexOf(this.data.pics[this.selectedChecklistItem.field]) === -1 &&
                this.data.pics[this.selectedChecklistItem.field] != null){
              this.currentphotoobjects.push(this.data.pics[this.selectedChecklistItem.field]);
            }
      })
      this.selectedIndex = index;
      (<HTMLInputElement>document.getElementById("chklistnote")).value = job.note.length > 0 ? job.note : '';

      if (document.getElementById("chklstphoto_" + index) !== null) {
        (<HTMLInputElement>document.getElementById("chklstphoto_" + index)).value = '';
      }

      //get last changed
        this.subscriptions.add(this.raterFormService.getLastChanged(this.selectedChecklistItem.field, this.form_id).subscribe(
          res => {
            this.lastChanged = res.Message;
          }, err => {
            this.lastChanged = 'Could not retrieve log entry.';
          }
        ))
    }

  }

  ventRateClass(){

    if( this.raterform.get('vent_rate_total').value >= this.ashrae )
    {
      //green
      return 'green-vent-rate';

    }else {
      //red
      return 'red-vent-rate';
    }


  }

  openImageNewTab(link) {
    window.open(link, "_blank");
  }

  loadSysNames() {
    if (this.raterform.get('hvac1name').value) {
      this.systemnamed(1);
    }
    if (this.raterform.get('hvac2name').value) {
      this.systemnamed(2);
    }
    if (this.raterform.get('hvac3name').value) {
      this.systemnamed(3);
    }
    if (this.raterform.get('hvac4name').value) {
      this.systemnamed(4);
    }
  }

  systemnamed(sysno: number){

    switch(sysno) {
      case 1:
        this.labeledSystems.push(this.raterform.get('hvac1name').value);
        break;
      case 2:
        this.labeledSystems.push(this.raterform.get('hvac2name').value);
        break;
      case 3:
        this.labeledSystems.push(this.raterform.get('hvac3name').value);
        break;
      case 4:
        this.labeledSystems.push(this.raterform.get('hvac4name').value);
        break;
      default:
        return 
    }


  }

  recalcACH50(locid) {
    this.subscriptions.add(this.raterFormService.getPlanData(locid).subscribe(
      res => {

        if (!Error) {
          this.hvac_1_area = res.Plan.hvac_1_area || 0;
          this.hvac_2_area = res.Plan.hvac_2_area || 0;
          this.hvac_3_area = res.Plan.hvac_3_area || 0;
          this.hvac_4_area = res.Plan.hvac_4_area || 0;
          this.hvac1_ceil_ht = res.Plan.hvac1_ceil_ht || 0;
          this.hvac2_ceil_ht = res.Plan.hvac2_ceil_ht || 0;
          this.hvac3_ceil_ht = res.Plan.hvac3_ceil_ht || 0;
          this.hvac4_ceil_ht = res.Plan.hvac4_ceil_ht || 0;
          this.bedrooms = res.Plan.bedrooms || 0;
          this.bathrooms = res.Plan.bathrooms || 0;
          this.addvol = res.Plan.addvol || 0;
        }


        let valuee = (parseFloat(this.raterform.get('blower_door').value) * 60) / (parseFloat(this.addvol.toString()) + (parseFloat(this.hvac_1_area.toString()) * parseFloat(this.hvac1_ceil_ht.toString())) + (parseFloat(this.hvac_2_area.toString()) * parseFloat(this.hvac2_ceil_ht.toString())) + (parseFloat(this.hvac_3_area.toString()) * parseFloat(this.hvac3_ceil_ht.toString())) + (parseFloat(this.hvac_4_area.toString()) * parseFloat(this.hvac4_ceil_ht.toString())) + ((parseFloat(this.raterform.get('hvac1_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac1_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac1_optceilheight').value.toString())) + ((parseFloat(this.raterform.get('hvac2_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac2_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac2_optceilheight').value.toString())) + (parseFloat(this.raterform.get('hvac3_option_sf').value.toString()) * parseFloat(this.raterform.get('hvac3_optceilheight').value.toString())));


       // let valuee = (parseFloat(this.raterform.get('blower_door').value) * 60) / (parseFloat(this.addvol.toString()) + (parseFloat(this.hvac_1_area.toString()) * parseFloat(this.hvac1_ceil_ht.toString())) + (parseFloat(this.hvac_2_area.toString()) * parseFloat(this.hvac2_ceil_ht.toString())) + (parseFloat(this.hvac_3_area.toString()) * parseFloat(this.hvac3_ceil_ht.toString())) + (parseFloat(this.hvac_4_area.toString()) * parseFloat(this.hvac4_ceil_ht.toString())) + ((parseFloat(this.raterform.get('hvac1_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac1_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac1_optceilheight').value.toString())) + ((parseFloat(this.raterform.get('hvac2_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac2_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac2_optceilheight').value.toString())) );

        this.raterform.get('ach50').setValue(Number.isNaN(valuee) || !Number.isFinite(valuee) ? "0" : valuee.toFixed(3));
        this.updateSingleField('ach50');
      }, err => {
        this.messager.openSnackBar('Calculation failed: ' + err, '', 'errorAlert');
      }
    ));
  }

  // ---- Bedroom count override -----------------------------------------------------------
  //
  // `bedrooms` is read live from plans3.bedrooms and feeds ONLY the ASHRAE 62.2 target,
  // which in turn drives the ventilation controller runtime the rater programs on site.
  // When a rater marks the plan count Incorrect/Unsure they may supply a corrected count,
  // and that corrected count takes over the calc so the runtime is right in the field.

  // True when the rater has flagged the plan's count, which is what exposes the override
  // input. Values are the stored ones, not the (longer) dropdown labels.
  bedroomOverrideActive(): boolean {
    const v = this.raterform.get('bedroom_verify').value;
    return v === 'Incorrect' || v === 'Unsure';
  }

  // The override as a usable number, or null when it is absent/blank/not a sane count.
  // Deliberately NOT gated on bedroomOverrideActive() so the "original count" box can keep
  // rendering a recorded override; use effectiveBedrooms() for anything that feeds a calc.
  bedroomOverrideValue(): number {
    const raw = this.raterform.get('bedroom_override').value;
    if (raw === null || typeof raw === 'undefined' || String(raw).trim() === '') {
      return null;
    }
    const n = parseFloat(String(raw));
    return (isFinite(n) && n >= 0) ? n : null;
  }

  // The recorded original (plan) count, or null when none has been snapshotted. Separate
  // from a truthiness check so a plan with 0 bedrooms still renders.
  bedroomOriginalValue(): number {
    const raw = this.raterform.get('bedroom_original').value;
    if (raw === null || typeof raw === 'undefined' || String(raw).trim() === '') {
      return null;
    }
    const n = parseFloat(String(raw));
    return isFinite(n) ? n : null;
  }

  // The bedroom count every calculation should use: the rater's override when one is in
  // force, otherwise the plan's. Switching back to Verified reverts the math to the plan
  // count without discarding the stored override.
  effectiveBedrooms(): number {
    if (this.bedroomOverrideActive()) {
      const o = this.bedroomOverrideValue();
      if (o !== null) {
        return o;
      }
    }
    const planned = parseFloat(this.bedrooms as any);
    return isFinite(planned) ? planned : 0;
  }

  // ASHRAE 62.2 target. Single source of truth - both load-time sites and every recalc go
  // through this, so the formula cannot drift between them.
  computeAshrae(): number {
    return (7.5 * (1 + this.effectiveBedrooms()))
      + ((parseFloat(this.hvac_1_area.toString())
        + parseFloat(this.hvac_2_area.toString())
        + parseFloat(this.hvac_3_area.toString())
        + parseFloat(this.hvac_4_area.toString())) / 100);
  }

  // Recompute the target mid-session. ASHRAE is otherwise only computed inside the ngOnInit
  // getPlanData subscribe, so without this an override would not move the runtime until the
  // form was reopened.
  //
  // IMPORTANT: `ashrae` is NOT a locraterf column (it appears nowhere in raterform.js and is
  // absent from the table). It is in-memory/display only - never persist it.
  recalcAshrae(): void {
    this.ashrae = this.computeAshrae();
    this.raterform.get('ashrae').setValue(this.ashrae, { onlySelf: true, emitEvent: false });
  }

  // Dropdown blur. Persists exactly as before, then re-derives the target because moving
  // to/from Incorrect/Unsure can switch which bedroom count is in force.
  onBedroomVerifyChange(): void {
    this.updateSingleField('bedroom_verify');
    this.recalcAshrae();
  }

  // Override blur. Normalises the entry, records the plan's original count the first time an
  // override is saved, persists, then re-derives the target.
  onBedroomOverrideBlur(): void {
    const ctrl = this.raterform.get('bedroom_override');
    const raw = ctrl.value;
    const isBlank = raw === null || typeof raw === 'undefined' || String(raw).trim() === '';

    if (isBlank) {
      // A numeric column rejects '' ("invalid input syntax for type numeric"), so a cleared
      // field has to be sent as null.
      ctrl.setValue(null, { onlySelf: true, emitEvent: false });
    } else {
      const n = parseFloat(String(raw));
      if (!isFinite(n) || n < 0) {
        this.messager.openSnackBar('Bedroom override must be a positive whole number.', '', 'errorAlert');
        ctrl.setValue(this.initialValue, { onlySelf: true, emitEvent: false });
        return;
      }
      const whole = Math.round(n);
      ctrl.setValue(whole, { onlySelf: true, emitEvent: false });

      // Snapshot the plan's count the FIRST time an override is stored, and never again -
      // if the office later corrects the plan, a live read would rewrite what the count was
      // originally set to.
      const existingOriginal = this.raterform.get('bedroom_original').value;
      const originalUnset = existingOriginal === null
        || typeof existingOriginal === 'undefined'
        || String(existingOriginal).trim() === '';
      if (originalUnset) {
        const planned = parseFloat(this.bedrooms as any);
        const snapshot = isFinite(planned) ? planned : 0;
        this.raterform.get('bedroom_original').setValue(snapshot, { onlySelf: true, emitEvent: false });
        this.persistFieldNoDom('bedroom_original', snapshot);
      }
    }

    this.updateSingleField('bedroom_override');
    this.recalcAshrae();
  }


  // ---- Bathroom count override: mirrors the bedroom one minus the calc hooks. Nothing
  // computes off the count, so this only records the verification + corrected count. ----

  bathroomOverrideActive(): boolean {
    const v = this.raterform.get('bathroom_verify').value;
    return v === 'Incorrect' || v === 'Unsure';
  }

  bathroomOverrideValue(): number {
    const raw = this.raterform.get('bathroom_override').value;
    if (raw === null || typeof raw === 'undefined' || String(raw).trim() === '') {
      return null;
    }
    const n = parseFloat(String(raw));
    return (isFinite(n) && n >= 0) ? n : null;
  }

  bathroomOriginalValue(): number {
    const raw = this.raterform.get('bathroom_original').value;
    if (raw === null || typeof raw === 'undefined' || String(raw).trim() === '') {
      return null;
    }
    const n = parseFloat(String(raw));
    return isFinite(n) ? n : null;
  }

  // Override blur. Rounds to the nearest half-bath, snapshots the plan's count the first
  // time an override is stored (never again), then persists.
  onBathroomOverrideBlur(): void {
    const ctrl = this.raterform.get('bathroom_override');
    const raw = ctrl.value;
    const isBlank = raw === null || typeof raw === 'undefined' || String(raw).trim() === '';

    if (isBlank) {
      // A numeric column rejects '', so a cleared field has to be sent as null.
      ctrl.setValue(null, { onlySelf: true, emitEvent: false });
    } else {
      const n = parseFloat(String(raw));
      if (!isFinite(n) || n < 0) {
        this.messager.openSnackBar('Bathroom override must be a positive number (use .5 for a half bath).', '', 'errorAlert');
        ctrl.setValue(this.initialValue, { onlySelf: true, emitEvent: false });
        return;
      }
      ctrl.setValue(Math.round(n * 2) / 2, { onlySelf: true, emitEvent: false });

      const existingOriginal = this.raterform.get('bathroom_original').value;
      const originalUnset = existingOriginal === null
        || typeof existingOriginal === 'undefined'
        || String(existingOriginal).trim() === '';
      if (originalUnset) {
        const planned = parseFloat(this.bathrooms as any);
        const snapshot = isFinite(planned) ? planned : 0;
        this.raterform.get('bathroom_original').setValue(snapshot, { onlySelf: true, emitEvent: false });
        this.persistFieldNoDom('bathroom_original', snapshot);
      }
    }

    this.updateSingleField('bathroom_override');
  }

  // ---- Checklist photo-count warnings (ES finals only) -----------------------------------

  // Checklist fields whose photo count must cover the plan's room count.
  photoCountFields: { [field: string]: { item: string, kind: string } } = {
    pressure_balanced: { item: '6.2', kind: 'bedroom' },
    bathroom_cfm: { item: '8.2', kind: 'bathroom' }
  };
  // SF ENERGY STAR checklist items that need at least one photo, by inspection stage.
  requiredPhotoFields: { [field: string]: { item: string, stage: 'pdwi' | 'final' } } = {
    dropped_ceiling_soffit: { item: '2.1', stage: 'pdwi' },
    wall_b_shower_tub: { item: '2.2', stage: 'pdwi' },
    attic_knee_walls: { item: '2.3', stage: 'pdwi' },
    wall_a_porch_roof: { item: '2.4', stage: 'pdwi' },
    sealedmarriagejointsmodhomes: { item: '4.1.6', stage: 'pdwi' },
    attic_dropdown: { item: '4.1.2', stage: 'final' },
    kitchen_cfm: { item: '8.1', stage: 'final' }
  };
  // Per-field photo counts. A panel only fetches its own list when opened, so these are
  // loaded once up front and kept in step by the upload/delete handlers.
  checklistPhotoCounts: { [field: string]: number } = {};

  loadChecklistPhotoCounts(form_id: number): void {
    const fields = [...Object.keys(this.photoCountFields), ...Object.keys(this.requiredPhotoFields)];
    fields.forEach(field => {
      const legacy = this.data.pics ? this.data.pics[field] : null;
      this.subscriptions.add(this.raterFormService.getFormPics(form_id, field).subscribe(
        res => {
          const urls: string[] = (!res.Error && res.Rows > 0) ? res.Photos.map(p => p.image_url) : [];
          if (legacy && urls.indexOf(legacy) === -1) {
            urls.push(legacy);
          }
          this.checklistPhotoCounts[field] = urls.length;
        },
        () => { this.checklistPhotoCounts[field] = legacy ? 1 : 0; }
      ));
    });
  }

  bumpChecklistPhotoCount(field: string, delta: number): void {
    if (!this.photoCountFields[field] && !this.requiredPhotoFields[field]) {
      return;
    }
    this.checklistPhotoCounts[field] = Math.max(0, (this.checklistPhotoCounts[field] || 0) + delta);
  }

  // Bathroom twin of effectiveBedrooms(): the rater's override when one is in force, else the plan's.
  effectiveBathrooms(): number {
    if (this.bathroomOverrideActive()) {
      const o = this.bathroomOverrideValue();
      if (o !== null) {
        return o;
      }
    }
    const planned = parseFloat(this.bathrooms as any);
    return isFinite(planned) ? planned : 0;
  }

  // Warning text when the field's photos fall short of the room count, else ''. Silent unless
  // the job is an ENERGY STAR final, the count is known and > 0, and the photo count has loaded.
  checklistPhotoCountWarning(field: string): string {
    const cfg = this.photoCountFields[field];
    if (!cfg || !(this.isFinal && this.isEnergyStar)) {
      return '';
    }
    const required = cfg.kind === 'bedroom' ? this.effectiveBedrooms() : this.effectiveBathrooms();
    if (!(required > 0)) {
      return '';
    }
    const needed = Math.ceil(required);
    const have = this.checklistPhotoCounts[field];
    if (typeof have === 'undefined' || have >= needed) {
      return '';
    }
    let text = have + ' of ' + needed + ' ' + cfg.kind + ' photos uploaded';
    if (needed !== required) {
      text += ' (' + required + ' ' + cfg.kind + 's)';
    }
    return text;
  }

  // Warning lines for SF ENERGY STAR checklist items with no photo at this stage; bumps numOfWarnings.
  requiredChecklistPhotoWarnings(stage: 'pdwi' | 'final'): string {
    if (!this.isEnergyStar || this.multifamilyDoc) {
      return '';
    }
    let text = '';
    Object.keys(this.requiredPhotoFields).forEach(field => {
      const cfg = this.requiredPhotoFields[field];
      if (cfg.stage !== stage) {
        return;
      }
      if (field === 'attic_dropdown' && this.raterform.get('foamceilings').value == true) {
        return;
      }
      // A fresh selection holds 'N/A'; saved values are normalised to 'NA' on load.
      const item = this.checklistItems.find(i => i.field === field);
      if (item && (item.value || '').replace('/', '').trim().toUpperCase() === 'NA') {
        return;
      }
      const have = this.checklistPhotoCounts[field];
      if (typeof have === 'undefined' || have > 0) {
        return;
      }
      text += '\n ' + cfg.item + ' picture is missing (checklist tab)';
      this.numOfWarnings ++;
    });
    return text;
  }

  // Persist a field that has no rendered input. updateSingleField() dereferences
  // document.getElementById(name) on both its success and error branches, so it throws for a
  // field with no element - hence this DOM-free variant, modelled on
  // updateSingleFieldChecklist() but with the noSave guard that one is missing.
  private persistFieldNoDom(name: string, value: any): void {
    if (this.data.noSave) {
      return;
    }
    this.subscriptions.add(this.raterFormService.updateSingleField(name, this.form_id, value).subscribe(
      res => {
        if (res.Error) {
          this.messager.openSnackBar('Field: ' + name + ' ' + res.Message, '', 'errorAlert');
          return;
        }
        this.subscriptions.add(this.raterFormService.updateRFLog(name, this.form_id, value, (this.usernamee || 'Inspector')).subscribe(
          () => { }, () => { }
        ));
      }, () => { }
    ));
  }

  // Controller minute = raw minutes rounded UP (any fraction rounds up, 12.01 -> 13).
  // The percentage/hours-per-day calcs derive from this rounded-up value.
  ventRuntime(): { controllerMins: number, actual: string } {
    const required = parseFloat(this.ashrae as any);
    const measured = parseFloat(this.raterform.get('vent_rate_total').value);
    if (!isFinite(required) || required <= 0 || !isFinite(measured) || measured <= 0) {
      return null;
    }
    const total = (required / measured) * 60; // minutes, float
    if (!isFinite(total) || total <= 0) {
      return null;
    }
    // Round to 6 decimals first so float noise doesn't push a true whole minute up.
    const cleaned = Math.round(total * 1e6) / 1e6;
    const controllerMins = Math.ceil(cleaned);
    // Exact runtime as MM:SS for reference.
    let mins = Math.floor(total);
    let secs = Math.round((total - mins) * 60);
    if (secs === 60) { // rollover, e.g. 11.999 -> 12:00
      mins += 1;
      secs = 0;
    }
    const ss = secs < 10 ? '0' + secs : '' + secs;
    return { controllerMins, actual: `${mins}:${ss}` };
  }

  ventRuntimeDisplay(): string {
    const r = this.ventRuntime();
    if (!r) {
      return '';
    }
    return `${r.controllerMins} minutes (actual ${r.actual})`;
  }

  // Percentage of an hour, rounded UP to a whole number, derived from the
  // rounded-up controller minutes (not the raw float). 12 min/hr -> 20%.
  // Accepts an already-computed runtime so the model-change popup can format
  // a before/after pair; defaults to the current runtime.
  ventRuntimePercentDisplay(r = this.ventRuntime()): string {
    if (!r) {
      return '';
    }
    return `${Math.ceil((r.controllerMins / 60) * 100)}%`;
  }

  ventRuntimePasses(r = this.ventRuntime()): boolean {
    if (!r) {
      return false;
    }
    const mins = r.controllerMins;
    return mins != null && isFinite(mins) && mins > 0 && mins <= 60;
  }

  // Hours per day, rounded UP to the tenth, derived from the rounded-up
  // controller minutes. 12 min/hr -> 4.8 hours/day.
  ventRuntimeHoursPerDayDisplay(r = this.ventRuntime()): string {
    if (!r) {
      return '';
    }
    const hrs = Math.ceil((r.controllerMins * 24 / 60) * 10) / 10;
    return `${hrs.toFixed(1)} hours`;
  }

  // Compact one-line runtime format. Currently unreferenced - kept for reuse.
  ventRuntimeControllerSummary(r = this.ventRuntime()): string {
    if (!r) {
      return '';
    }
    return `${r.controllerMins} minutes / ${this.ventRuntimePercentDisplay(r)} of an hour`;
  }

  // One-line summary used by the model-change popup.
  ventRuntimeFullSummary(r): string {
    if (!r) {
      return 'not calculated';
    }
    return `${r.controllerMins} minutes / ${this.ventRuntimePercentDisplay(r)} of an hour / ${this.ventRuntimeHoursPerDayDisplay(r)} per day`;
  }

  showHomePresets(event: MatCheckboxChange): void {
    if (event.checked) {
      this.viewHomePresets = true;
    } else {
      this.viewHomePresets = false;
    }
  }

  blurNotesTimestamp(): void {

    let today = new Date();
    let date = (today.getMonth() + 1) + '/' + today.getDate();
    let time = today.getHours() + ":" + (today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes());

    let dateTime = date + ' ' + time;



  }

  addToNotes(checked,note, index): void {

    let today = new Date();
    let date = (today.getMonth() + 1) + '/' + today.getDate();
    let time = today.getHours() + ":" + (today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes());

    let dateTime = date + ' ' + time;

    if (index == 917) {
      if (checked) {
        let newNote = this.raterform.get('finalnotes4builder').value;
        newNote += newNote.length > 1 ? '\n -' + note : ' -' + note;
        //newNote += ' -' + this.initials + ' ' + dateTime;
        this.raterform.get('finalnotes4builder').setValue(newNote);
      }
    } else {
      if (checked) {
        this.checklistItems[index].note += this.checklistItems[index].note.length > 1 ? '\n -' + note : '-' + note;
      } else {
        this.checklistItems[index].note.replace(note, '');
      }
    }

    let name = '';
    let value = '';
    if(index == 917) {
      name = 'finalnotes4builder';
      value = this.raterform.get('finalnotes4builder').value;
    }else {
      name = this.checklistItems[index].field;
      value = this.checklistItems[index].note.slice(-255);
    }


    this.subscriptions.add(this.raterFormService.updateRFLog(name, this.form_id, value, (this.usernamee || 'Inspector')).subscribe(
      res => {
        if (res.Error) {

        }else {
          //save the note
          this.subscriptions.add(this.raterFormService.updateSingleNote(this.location_id, name, this.checklistItems[index].note).subscribe(
            res => {
            }, err => {
            }
          ));
        }
      }, err => {

      }));

  }

  onScrollDown(){
  }

  calculateFlowAt() {


    this.show_bd_factor_warning = false;

    var pa = new Array(6);

    pa[0] = this.raterform.get('multipa1').value;
    pa[1] = this.raterform.get('multipa2').value;
    pa[2] = this.raterform.get('multipa3').value;
    pa[3] = this.raterform.get('multipa4').value;
    pa[4] = this.raterform.get('multipa5').value;
    pa[5] = this.raterform.get('multipa6').value;

    var flo = new Array(6);

    flo[0] = this.raterform.get('multiflo1').value;
    flo[1] = this.raterform.get('multiflo2').value;
    flo[2] = this.raterform.get('multiflo3').value;
    flo[3] = this.raterform.get('multiflo4').value;
    flo[4] = this.raterform.get('multiflo5').value;
    flo[5] = this.raterform.get('multiflo6').value;

    //check multipa
    var i;
    for (i = 0; i < 6; i++) {
      if (flo[i] == null) {
        return;
      }
    }




    var elevation = parseFloat(this.raterform.get('elevation').value.toString()) || 0;
    var tempOut = parseFloat(this.raterform.get('outdoortemp').value.toString()) || 0;
    var tempIn = parseFloat(this.raterform.get('indoortemp').value.toString()) || 0;
    var baseline_p = parseFloat(this.raterform.get('envblnpres').value.toString() || null);

    if (elevation == null || elevation == 0) {
      this.messager.openSnackBar('Elevation cannot be zero!', '[close]', 'errorAlert');
      this.longRippleError(this.elevationRipple);
      return;
    }

    if (tempOut == null || tempOut == 0) {
      this.messager.openSnackBar('Outdoor temp cannot be zero!', '[close]', 'errorAlert');
      this.longRippleError(this.tempoutRipple);
      return;
    }

    if (tempIn == null || tempIn == 0) {
      this.messager.openSnackBar('Indoor temp cannot be zero!', '[close]', 'errorAlert');
      this.longRippleError(this.tempinRipple);
      return;
    }

    if (baseline_p == null) {
      this.messager.openSnackBar('Baseline pressure cannot be zero!', '[close]', 'errorAlert');
      this.longRippleError(this.baselineRipple);
      return;
    }





    var elev = elevation * 0.3048; //convert to meters
    var tin = (tempIn - 32) * (5 / 9);
    var tout = (tempOut - 32) * (5 / 9);
    var baseline = baseline_p;



    var poutairden = 1.2041 * Math.pow((1 - ((0.0065 * elev) / 293)), 5.2553) * (293 / (tout + 273))
    var pinairden = 1.2041 * Math.pow((1 - ((0.0065 * elev) / 293)), 5.2553) * (293 / (tin + 273))




    //si FLOWS

    var siFlo = new Array(6);

    var i;
    for (i = 0; i < 6; i++) {
      siFlo[i] = flo[i] * 0.000471947
    }

    //density Corrected FLOWS
    var denCorFlo = new Array(6);
    var i;
    for (i = 0; i < 6; i++) {
      denCorFlo[i] = pinairden / poutairden * siFlo[i];
    }

    //baseline Corrected
    var blineCorrected = new Array(6);
    var i;
    for (i = 0; i < 6; i++) {
      blineCorrected[i] = pa[i] - baseline;
    }

    //in of corrected FLOW
    var inCorFlo = new Array(6);
    var i;
    for (i = 0; i < 6; i++) {
      inCorFlo[i] = Math.log(denCorFlo[i]);
    }

    //in of corrected pressure
    var inCorPress = new Array(6);
    var i;
    for (i = 0; i < 6; i++) {
      inCorPress[i] = Math.log(Math.abs(blineCorrected[i]));
    }


    var avgInFlo = 0
    var i;
    for (i = 0; i < 6; i++) {
      avgInFlo += inCorFlo[i];
    }
    avgInFlo = avgInFlo / 6;

    //sum
    var i;
    var sum = 0;
    for (i = 0; i < 6; i++) {
      sum += Math.pow(inCorFlo[i] - avgInFlo, 2);
    }

    var varianceLF = 1 / (6 - 1) * sum;

    ///
    var avgInPress = 0
    var i;
    for (i = 0; i < 6; i++) {
      avgInPress += inCorPress[i];
    }
    avgInPress = avgInPress / 6;

    ///
    var i;
    var sumpress = 0;
    for (i = 0; i < 6; i++) {
      sumpress += Math.pow(inCorPress[i] - avgInPress, 2);
    }

    var varianceLP = 1 / (6 - 1) * sumpress;


    var i;
    var sumCV = 0;
    for (i = 0; i < 6; i++) {
      sumCV += (inCorFlo[i] - avgInFlo) * (inCorPress[i] - avgInPress);
    }

    var covariance = 1 / (6 - 1) * sumCV

    var n = covariance / varianceLP

    var bigC = Math.exp(avgInFlo - n * avgInPress)

    var dynvisOut = (0.000001458 * Math.pow((tout + 273), 0.5)) / (1 + (110.4 / (tout + 273)))

    var reference = 0.0000181268800379262;
    var standardDen = 1.204;

    var Co = bigC * Math.pow((dynvisOut / reference), 2 * n - 1) * Math.pow((poutairden / standardDen), 1 - n);

    var ALmeters = Co * (Math.pow(standardDen / 2, 0.5)) * Math.pow(4, n - 0.5)

    var ALinches = ALmeters * 1550

    var flow = (bigC * Math.pow(50, n)) / 0.000471947;

    this.raterform.get('flowat50').setValue(flow.toFixed(2),{onlySelf: true, emitEvent: false});
    this.updateSingleField('flowat50');

    return flow.toFixed(2);

  }


  // Fired only from the Ventilation Model dropdown's (selectionChange). cfmCalculation
  // recomputes Total House CFM, which moves the ASHRAE runtime — tell the rater so they
  // re-set the controller instead of leaving the old runtime programmed. Do not move the
  // snackbar into cfmCalculation itself: that also runs on form init and on every Pascal
  // Reading change.
  ventBrandChanged(brand): void {
    const before = this.ventRuntime();
    this.cfmCalculation(brand);
    const after = this.ventRuntime();

    if (!before && !after) {
      return;
    }
    if (before && after && before.controllerMins === after.controllerMins) {
      return;
    }

    const message = after
      ? `Ventilation runtime changed. Minimum controller runtime setting: ${this.ventRuntimeFullSummary(after)}`
      : 'Ventilation runtime changed and is no longer calculable.';
    this.messager.openSnackBar(message, 'OK', 'successAlert', 8000);
  }

  cfmCalculation = function (brand) {

    var value = this.raterform.get('numpa').value;
    var formula = "";
    var y = 0.0;
    var modelNo = "";
    var ventType = "";

    if(value == 0){
      document.getElementById('manualentry').classList.remove('manualEntryRemove');
    }else {
      document.getElementById('manualentry').classList.add('manualEntryRemove');
    }

    this.raterform.get('vent_brand').setValue(brand,{onlySelf: true, emitEvent: false});


    switch (brand) {
      case "1": //Panasonic
        y = (-0.0044 * Math.pow(value, 2)) - (0.14 * (value)) + 258;
        formula = "-0.0044*(value^2) - 0.14*(value)+258";
        this.raterform.get('ven_mn').setValue("FVR250",{onlySelf: true, emitEvent: false});
        break;
      case "2": //Aprilaire
        y = -0.00001 * Math.pow(value, 3) - 0.0003 * Math.pow(value, 2) - 0.7095 * (value) + 285.57;
        formula = "y = -1E-05x3 - 0.0003x2 - 0.7095x + 285.57";
        this.raterform.get('ven_mn').setValue("8140",{onlySelf: true, emitEvent: false});
        break;
      case "3": //Lennox
        y = -0.000005 * Math.pow(value, 3) + 0.0006 * Math.pow(value, 2) - 0.4744 * (value) + 191.57;
        this.raterform.get('ven_mn').setValue("ERV3-200",{onlySelf: true, emitEvent: false});
        break;
      case "4": //Broan
        y = -0.0019 * Math.pow(value, 3) + 0.3867 * Math.pow(value, 2) - 32.66 * (value) + 1140.1;
        this.raterform.get('ven_mn').setValue("ERV70",{onlySelf: true, emitEvent: false});
        break;
      case "5":
        y = -0.000008 * Math.pow(value, 3) + 0.0012 * Math.pow(value, 2) - 0.4397 * (value) + 161.29;
        this.raterform.get('ven_mn').setValue("ERV3-150",{onlySelf: true, emitEvent: false});
        break;
      case "6":
        if (value < 25) {
          y = 220;
        }
        if (value > 25 && value < 50) {
          y = 200;
        }
        if (value > 50) {
          y = 180;
        }
        this.raterform.get('ven_mn').setValue("VNT2200",{onlySelf: true, emitEvent: false});
        break;
      case "8":
        y = -0.000001 * Math.pow(value, 3) + 0.00006 * Math.pow(value, 2) - 0.1322 * (value) + 135.97;
        this.raterform.get('ven_mn').setValue("ERV5-130",{onlySelf: true, emitEvent: false});
        break;
      case "9":
        y = -0.0003 * Math.pow(value, 2) - 0.3117 * (value) + 170.68;
        this.raterform.get('ven_mn').setValue("ERV5-150",{onlySelf: true, emitEvent: false});
        break;
      case "10":
        y = 0.0002 * Math.pow(value, 2) - 1.1394 * (value) + 283.0221;
        this.raterform.get('ven_mn').setValue("Aprilaire 8145",{onlySelf: true, emitEvent: false});
        break;
      case "11":
        y = (0.0003 * Math.pow(value, 3)) - (0.099 * Math.pow(value, 2)) + (7.8053 * (value)) - 64.029;
        this.raterform.get('ven_mn').setValue("QFAM QFRESH",{onlySelf: true, emitEvent: false});
        break;
      case "12":
        y = (-0.6028 * value) + 200;
        this.raterform.get('ven_mn').setValue("Aprilaire E070",{onlySelf: true, emitEvent: false});
        break;
      case "13":
        y = (-1.005 * value) + 185;
        this.raterform.get('ven_mn').setValue("Aprilaire E080",{onlySelf: true, emitEvent: false});
        break;
      case "14":
        y = (-0.7033 * value) + 280;
        this.raterform.get('ven_mn').setValue("Aprilaire E100",{onlySelf: true, emitEvent: false});
        break;
      case "15":
        y = (-0.119 * value) + (0.0000583 * Math.pow(value, 2)) + 126;
        break;
      default: //Other
        y = value;
        this.raterform.get('ven_mn').setValue(this.raterform.get('ven_mn').value,{onlySelf: true, emitEvent: false});
        break;
    }

    if(value == 0 ){
      if(this.raterform.get('manualentry').value == true){
        //do nothing
      }else {
        //set vent_rate total = 0
        this.raterform.get('vent_rate_total').setValue(0,{onlySelf: true, emitEvent: false});
      }

    } else {
      // Calculated CFM rounds DOWN to a whole number; every calc that reads
      // vent_rate_total (runtime, warnings, coloring) gets the floored value.
      this.raterform.get('vent_rate_total').setValue(Math.floor(y),{onlySelf: true, emitEvent: false});
    }
    //this.raterform.get('runtime').value = (this.raterform.get('ashrae').value/this.raterform.get('vent_rate_total').value)*60;

  }

  notesClick() {

    //let notes = this.raterform.get('predrywallnotes4builder').replace("(No Notes Left By Rater)", "");
    this.raterform.get('predrywallnotes4builder').setValue(this.raterform.get('predrywallnotes4builder').value.replace("(No Notes Left By Rater)", ""))


  }

  recalculateLightPct() {
    // Helper function to parse integers safely
    const safeParseInt = (value) => parseInt(value) || 0;

    // Helper function to calculate percentages
    const calculatePercentage = (numerator, denominator) => {
        if (denominator === 0) return 0; 
        let num = parseFloat(numerator);
        if (isNaN(num)) num = 0; 
        return (num / denominator) * 100;
    };

    const values = {
        insidet1: safeParseInt(this.raterform.get('insidet1').value),
        insidet2: safeParseInt(this.raterform.get('insidet2').value),
        insidenq: safeParseInt(this.raterform.get('insidenq').value),
        outsidet1: safeParseInt(this.raterform.get('outsidet1').value),
        outsidet2: safeParseInt(this.raterform.get('outsidet2').value),
        outsidenq: safeParseInt(this.raterform.get('outsidenq').value),
        garaget1: safeParseInt(this.raterform.get('garaget1').value),
        garaget2: safeParseInt(this.raterform.get('garaget2').value),
        garagenq: safeParseInt(this.raterform.get('garagenq').value)
    };

    const insidetotal = values.insidet1 + values.insidet2 + values.insidenq;
    const outsidetotal = values.outsidet1 + values.outsidet2 + values.outsidenq;
    const garagetotal = values.garaget1 + values.garaget2 + values.garagenq;
    const sumtotal = insidetotal + outsidetotal + garagetotal;


    const tier1 = values.insidet1 + values.garaget1 + values.outsidet1;
    const tier2 = values.insidet2 + values.garaget2 + values.outsidet2;

    // Set percentage values
    ['insidet1', 'insidet2'].forEach(field => {
        this.raterform.get(`${field}pct`).setValue(calculatePercentage(values[field], insidetotal), {onlySelf: true, emitEvent: false});
    });

    ['outsidet1', 'outsidet2'].forEach(field => {
        this.raterform.get(`${field}pct`).setValue(calculatePercentage(values[field], outsidetotal), {onlySelf: true, emitEvent: false});
    });

    ['garaget1', 'garaget2'].forEach(field => {
        this.raterform.get(`${field}pct`).setValue(calculatePercentage(values[field], garagetotal), {onlySelf: true, emitEvent: false});
    });

    // Calculate and set whole house percentage efficiency
    let whtpc = calculatePercentage(tier1 + tier2, sumtotal);
    this.raterform.get('whpcteff').setValue(whtpc.toString(), {onlySelf: true, emitEvent: false});
}




  checkMustCorrectWarning(value) {
    this.checklistItems.map((item) => {
      if (item.value === 'Must Correct') this.totalMustCorrect++
    })

    if(value.includes('Must')){

      if (this.totalMustCorrect > 8 && !this.data.formData.jobinfo.customer_jobtype.toLowerCase().includes('hers')) {
        this.dialog.open(WarningPopupComponent, {
          data: {
            warning_title: "WARNING",
            warning_description: "A builder can only sign off on up to 8 items. You have " + this.totalMustCorrect + " marked as 'must correct.'"
          }
        })
      }

    }
    this.totalMustCorrect = 0
  }


  selectionChanged(valueString, index, mf: boolean = false) {

      this.checklistItems[index].value = valueString;
      this.updateSingleFieldChecklist(index);
      this.checkMustCorrectWarning(valueString);

      let engineerLetterIndexes = [15, 16, 17, 18, 19];
      if(engineerLetterIndexes.includes(index)){
        this.checkEngineerLetterNeeded();
      }
    
      let threepointfourArray = this.checklistItems.slice(15,20); 
      if(threepointfourArray.some(item => !item.value.toLowerCase().includes('verified')) ){
        this.showAff = false;
        this.raterform.get('aff').setValue(false);
      }else{
        this.showAff = true;
        this.raterform.get('aff').setValue(true);
      }

  }

  selectionChangedMF(valueString, field, mf: boolean = false){

    let fieldT;
    if(mf){
      const foundField = this.mfChecklistItems.find(item => item.field === field);
      fieldT = foundField.field;
    }else {
      fieldT = this.mfChecklistItems[field].field;
    }
    const itemToUpdate = this.mfChecklistItems.find(item => item.field === fieldT);
    if (itemToUpdate) {

      itemToUpdate.value = valueString;

      let data = {
        value : itemToUpdate.value,
        photos : itemToUpdate.photos || [],
        note : itemToUpdate.note
      }

      this.subscriptions.add(this.raterFormService.updateRFLog('ESMFNC ' + itemToUpdate.field, this.form_id, itemToUpdate.value, (this.usernamee || 'Inspector')).subscribe(
        res => {
          if (res.Error) {
          }
        }, err => {

        }
      ));

      this.raterFormService.updateESMFNCdataSF(this.mfChecklistID,fieldT, data).subscribe(
        res => {
          if (res.Error) {
          }else {
          }
        }, err => {

        });
    }

    let engineerLetterIndexes = [25, 26, 27, 28];
    if(engineerLetterIndexes.includes(field)){
      this.checkEngineerLetterNeeded();
    }

  }
  
  

  updateSingleMFChecklist(field,index, value) {

    //1 = photos, 2 = note, 3 = value
    let data = {
      value : this.mfChecklistItems[field].value,
      photos : this.mfChecklistItems[field].photos || [],
      note : this.mfChecklistItems[field].note
    }

    if(field == 1) this.mfChecklistItems[index].photos = value;
    if(field == 2) this.mfChecklistItems[index].note = value;
    if(field == 3) this.mfChecklistItems[index].value = value;

    //call api function here

    this.raterFormService.updateESMFNCdataSF(this.mfChecklistID,field, data).subscribe(
      res => {
        if (res.Error) {
        }else {
          //this.messager.openSnackBar('')
        }
      }, err => {

      });

  }


  //save single note

  notesBlur(notes, index, mf: boolean = false) {

    if(mf){
      let today = new Date();
      let date = (today.getMonth() + 1) + '/' + today.getDate();
      let time = today.getHours() + ":" + (today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes());

      let dateTime = date + ' ' + time;
      this.mfChecklistItems[index].note = notes + ' -' + this.initials + ' ' + dateTime;

      this.selectionChangedMF(this.mfChecklistItems[index].value, index);

      /*
      let data = {
        value : this.mfChecklistItems[index].value,
        photo : this.mfChecklistItems[index].photo,
        note : this.mfChecklistItems[index].note
      }

      this.raterFormService.updateESMFNCdataSF(this.mfChecklistID,name, data).subscribe(
        res => {
          if (res.Error) {
          }else {
          }
        }, err => {

        });
        */
    }else {

        let today = new Date();
        let date = (today.getMonth() + 1) + '/' + today.getDate();
        let time = today.getHours() + ":" + (today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes());

        let dateTime = date + ' ' + time;
        this.checklistItems[index].note = notes;

        let name = this.checklistItems[index].field;
        let value = this.checklistItems[index].note.slice(-255);
        this.subscriptions.add(this.raterFormService.updateRFLog(name, this.form_id, value, (this.usernamee || 'Inspector')).subscribe(
          res => {
            if (res.Error) {
            }else {
              //save the note
              this.subscriptions.add(this.raterFormService.updateSingleNote(this.location_id, name, this.checklistItems[index].note).subscribe(
                res => {
                }, err => {
                }
              ));
            }
          }, err => {
          }
        ));

    }
    //save to logs.

    //this.raterFormService.updateNotes()

  }

  trimNotes(notes, index, mf: boolean = false) {


    if(mf){
      this.mfChecklistItems[index].note.trim();
      notes.trim();
    }else {
      this.checklistItems[index].note.trim();
      notes.trim();
    }


  }



  searchFunction(value) {


    this.setSelectedItem(7);

    const searchables = document.getElementsByClassName('searchable');
    const containingFields = [];


    //uncomment below
    /*
    for(let item of searchables){
      if(item.innerText.toLowerCase().includes(value.toLowerCase())){

        containingFields.push(item);

      }
    }

    for(let obj of containingFields){

        const cln = obj.cloneNode(true);
        document.getElementById("searchResults").appendChild(cln);

    }


*/

  }



  close(index) {
    this.class = 'hidden';

    //this.checklistItems[index].note = this.raterform.get('checklistNotes').value;
    this.checklistNotes = '';
    this.selectedChecklistItem = '';
    //

  }

  //
  scrollToPos(position: number) {
    let el = document.getElementById('chklistitems');

    switch (position) {

      case 1:
        el.scrollLeft = 0;
        break;
      case 2:
        el.scrollLeft = 319;
        break;
      case 3:
        el.scrollLeft = 1061;
        break;
      case 4:
        el.scrollLeft = 2118;
        break;
      case 5:
        el.scrollLeft = 3180;
        break;
      case 6:
        el.scrollLeft = 3603;
        break;
      case 7:
        el.scrollLeft = 4243;
        break;
      case 8:
        el.scrollLeft = 5510;
        break;
      case 9:
        el.scrollLeft = 5724;
        break;
      case 10:
        el.scrollLeft = 6042;
        break;

    }

  }

  getStatusColor(status: string) {

    switch (status.trim()) {
      case 'Pass':
        return 'limegreen';
      case 'Fail':
        return 'red';
      case 'Complete':
        return 'limegreen';
      default:
        return '';
    }

  }


  toggleClass(value: string, index: number): void {
    switch (value.toString()) {

      case 'Must Correct':
        this.checklistClasses[index] = 'checklist-must-correct';
        break;
      case 'Rater Verified':
        this.checklistClasses[index] = 'checklist-verified';
        break;
      case 'N/A':
        this.checklistClasses[index] = 'checklist-na';
        break;
      case 'Builder Verified':
        this.checklistClasses[index] = 'checklist-bv';
        break;
      case 'Recommended':
        this.checklistClasses[index] = 'checklist-recommended';
        break;
      default:
        this.checklistClasses[index] = 'checklist-default';

    }



  }


  setClass(value): string {
    if (value == 'Must Correct') {
      return 'checklist-must-correct';
    }
    else if (value == 'Rater Verified') {
      return 'checklist-verified';
    }
    else if (value == 'N/A') {
      return 'checklist-na';
    }
    else if (value == 'Builder Verified') {
      return 'checklist-bv';
    }
    else if (value == 'Recommended') {
      return 'checklist-recommended';
    }
    else {
      return 'checklist-default';
    }
  }



  recalcFlow(location_id): void {

    this.messager.openSnackBar('Recalculating...', '', 'successAlert');

    this.subscriptions.add(this.raterFormService.getPlanData(location_id).subscribe(

      res => {
        this.hvac_1_area = res.Plan.hvac_1_area;
        this.hvac_2_area = res.Plan.hvac_2_area || 0;
        this.hvac_3_area = res.Plan.hvac_3_area || 0;
        this.hvac_4_area = res.Plan.hvac_4_area || 0;
        this.hvac1_ceil_ht = res.Plan.hvac1_ceil_ht || 0;
        this.hvac2_ceil_ht = res.Plan.hvac2_ceil_ht || 0;
        this.hvac3_ceil_ht = res.Plan.hvac3_ceil_ht || 0;
        this.hvac4_ceil_ht = res.Plan.hvac4_ceil_ht || 0;
        this.bedrooms = res.Plan.bedrooms || 0;
        this.bathrooms = res.Plan.bathrooms || 0;
        this.plan_name = res.Plan.plan_name || "No plan assigned";
        this.plan_notes = res.Plan.plan_notes || "No notes";
        this.addvol = res.Plan.addvol || 0;


        let val = (parseFloat(this.raterform.get('blower_door').value) * 60) / (parseFloat(this.addvol.toString()) + (parseFloat(this.hvac_1_area.toString()) * parseFloat(this.hvac1_ceil_ht.toString())) + (parseFloat(this.hvac_2_area.toString()) * parseFloat(this.hvac2_ceil_ht.toString())) + (parseFloat(this.hvac_3_area.toString()) * parseFloat(this.hvac3_ceil_ht.toString())) + (parseFloat(this.hvac_4_area.toString()) * parseFloat(this.hvac4_ceil_ht.toString())) + ((parseFloat(this.raterform.get('hvac1_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac1_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac1_optceilheight').value.toString())) + ((parseFloat(this.raterform.get('hvac2_option1_sf').value.toString()) + parseFloat(this.raterform.get('hvac2_option2_sf').value.toString())) * parseFloat(this.raterform.get('hvac2_optceilheight').value.toString())) + (parseFloat(this.raterform.get('hvac3_option_sf').value.toString()) * parseFloat(this.raterform.get('hvac3_optceilheight').value.toString())));
        //let val = ((this.raterform.get('blower_door').value) * 60) / ((this.addvol) + ((this.hvac_1_area) * (this.hvac1_ceil_ht)) + ((this.hvac_2_area) * (this.hvac2_ceil_ht)) + ((this.hvac_3_area) * (this.hvac3_ceil_ht)) + ((this.hvac_4_area) * (this.hvac4_ceil_ht)) + (((this.hvac1_option1_sf) + (this.hvac1_option2_sf)) * (this.hvac1_optceilheight)) + (((this.hvac2_option1_sf) + (this.hvac2_option2_sf)) * (this.hvac2_optceilheight)) + ((this.hvac3_option_sf) * (this.hvac3_optceilheight)));
        this.ach50 = (Number.isNaN(val) || !Number.isFinite(val) ? "0" : val.toFixed(3));

        this.updateSingleField('ach50');
        //this.ashrae = (7.5 * (1 + parseFloat(this.bedrooms.toString()) ) + ( (parseFloat(this.hvac_1_area.toString()) + parseFloat(this.hvac_2_area.toString()) + parseFloat(this.hvac_3_area.toString()) + parseFloat(this.hvac_4_area.toString()) ) / 100));
        //this.raterform.get('ashrae').setValue(this.ashrae,{onlySelf: true, emitEvent: false});

      }
    ));
  }

  clickListenerFunc(this){
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  }


  showMandatoryWarning() {

    if(this.isPDWI){

        //elevations
        if(this.elev_left == null || this.elev_back == null || this.elev_right == null || this.elev_front == null){
          return 'Please ensure all elevation photos have a picture, or N/A selected.';
        }

        //foundation type (slab)
        if( ( this.raterform.get('fdn_r').value != 'TBD' && this.raterform.get('fdn_r').value != 'N.A.'  && !this.data.pics.fdn_r) ){
          return 'You must select a foundation R-value, and ensure you\'ve taken a picture. (Envelope)';
        }

      }


  }


  ngOnDestroy(){
    this.image.remove();
    //remove event listeners
    let coll = document.getElementsByClassName("collapseButton");
    let i;

    for (i = 0; i < coll.length; i++) {
      coll[i].removeEventListener('click',this.clickListenerFunc,false)
    }

    this.subscriptions.unsubscribe();
  }


}
@Component({
  template: `
    <h1 mat-dialog-title style="text-align:center;">Final Inspection Checklist Warnings</h1>
    <div>
      <p>This is a final, please make sure all of the checklist items are at least filled in with 'N/A.'</p>
      <div *ngFor="let item of data;" style="border-style: solid;border-width: 0.5px; padding-left: 6px;">
        <pre style="white-space: break-spaces;">{{item}}</pre>
      </div>
    </div>
    <div style="position: relative;margin-top: 10px;top: 20px;left: 42px;width: 70%;">
      <button mat-button (click)="dref.close()"  style="position: relative;left: 50%;background: #ffffffaf;">Close</button>
    </div>
  `
})
export class RFWarningDialogComponent {

  constructor(public dref: MatDialogRef<RFWarningDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

}

@Component({
  template: `
    <div style="padding: 2em">
    <h1 mat-dialog-title style="text-align: center;
    font-size: 2em;
    color: #4f4f4f;">HVAC Grading Data Required</h1>
    <div>
      <p style="font-size: 1.5em;
      color: #424242;">This is a job in which HVAC Grading data is needed. Please ensure the Lineset Length, and Liquid Diameter is filled in for each system (Hvac Grading Tab).  </p>
    </div>
    <div style="margin: auto;
    padding-left: 25%;
    padding-right: 25%;
    padding-top: 2em;">
      <button mat-button [mat-dialog-close]="1"  style="margin-right: 2em; height: 4em;
      background: #ffffffaf;
      width: 10em;
      font-size: 1em;">Close Anyway</button>
      <button mat-button [mat-dialog-close]="2"  style="    height: 4em;
      background: #ffffffaf;
      width: 10em;
      font-size: 1em;">Back To Form</button>
    </div>
    </div>
  `
})
export class HvacGradingWarningComponent {

  constructor(public dref: MatDialogRef<HvacGradingWarningComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

}


@Component({
  template: `
    <div style="padding: 2em">
    <h1 mat-dialog-title style="text-align: center;
    font-size: 2em;
    color: #4f4f4f;">Total Duct Leakage Missing</h1>
    <div>
      <p style="font-size: 1.5em;
      color: #424242;">This HVAC Grading (HVG) job is missing Total Duct Leakage (DB Total) for one or more systems. Please enter the total duct leakage on the Testing tab, or re-test if the house was not tested at rough-in.</p>
      <p style="font-size: 1.15em;
      color: #b71c1c;
      white-space: pre-line;">{{ data }}</p>
    </div>
    <div style="margin: auto;
    padding-left: 25%;
    padding-right: 25%;
    padding-top: 2em;">
      <button mat-button [mat-dialog-close]="1"  style="margin-right: 2em; height: 4em;
      background: #ffffffaf;
      width: 10em;
      font-size: 1em;">Close Anyway</button>
      <button mat-button [mat-dialog-close]="2"  style="    height: 4em;
      background: #ffffffaf;
      width: 10em;
      font-size: 1em;">Back To Form</button>
    </div>
    </div>
  `
})
export class DuctLeakageWarningComponent {

  constructor(public dref: MatDialogRef<DuctLeakageWarningComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

}



@Component({
  template: `
    <h1 mat-dialog-title class="text-center mb-4 text-danger">Warning: Percentage is too high</h1>
    <div class="d-flex flex-column align-items-center">
      <p class="text-center mb-4">
        ES Requires less than 4% LTO. ES Requires less than 8% Total (12% with 3 or more returns)
      </p>
      <button mat-button color="primary" (click)="dialogRef.close()">OK</button>
    </div>
  `
})
export class ESPercentDialogComponent {
  constructor(public dialogRef: MatDialogRef<RFWarningDialogComponent>) { }
}

@Component({
  template: `
    <h1 mat-dialog-title class="text-center mb-4 text-danger">Warning: Percentage is too high</h1>
    <div class="d-flex flex-column align-items-center">
      <p class="text-center mb-4">
      Notice: This job may have exterior/ total leakage numbers that are failing. Please check the testing tab to ensure the leakage numbers are in range, and re-test if not.
      </p>
      <button mat-button color="primary" (click)="dialogRef.close()">OK</button>
    </div>
  `
})
export class RFWarningLeakageDialogComponent {
  constructor(public dialogRef: MatDialogRef<RFWarningLeakageDialogComponent>) { }
}
@Component({
  template: `
    <h1 mat-dialog-title class="text-center mb-4 text-danger">Warning: Percentage is too high</h1>
    <div class="d-flex flex-column align-items-center">
      <p class="text-center mb-4">
      Notice: This job may have exterior/ total leakage numbers that are failing. Please check the testing tab to ensure the leakage numbers are in range, and re-test if not.
      </p>
      <button mat-button color="primary" (click)="dialogRef.close()">OK</button>
    </div>
  `
})
export class ESLeakageDialogComponent {
  constructor(public dialogRef: MatDialogRef<RFWarningDialogComponent>) { }
}

@Component({
  template: `
    <h1 mat-dialog-title class="text-center mb-4 text-danger">Attic Tent Required</h1>
    <div class="d-flex flex-column align-items-center">
      <p class="text-center mb-4" style="font-size: 24px;">
        This job requires an attic tent. Please ensure one is installed, and then take a picture of it.
        If you are unable to install one, or one is not required, go to the home page, scroll to the bottom, and enter the appropriate
        tag (either 'Attic Tent Not Required', or 'Unable to Install Attic Tent').
      </p>
      <button [mat-dialog-close]="2" mat-button color="primary" style="height: 75px;
    width: 200px;
    border: 0;
    font-size: 24px;
    font-weight: 700;
    background: #8bc34a;
    color: white;
    border-radius: 10px">Go Back</button>

<button [mat-dialog-close]="1" style="height:75px;
    width: 200px;
    border: 0;
    font-size: 24px;
    font-weight: 700;
    color: #8bc34a8a;
    background: #ffffff;
    border-radius: 10px">Close Anyway</button>


    </div>
  `
})
export class AtticTentWarningComponent {
  constructor(public dialogRef: MatDialogRef<AtticTentWarningComponent>) { }
}

@Component({
  template: `
    <h1 mat-dialog-title class="text-center mb-3">What Counts as a Bedroom?</h1>
    <div mat-dialog-content style="font-size: 1.05em; color: #424242;">
      <p><strong>1. Solid door with lock</strong> (if the plans say the door is "non-locking" or
        &ldquo;non-latching&rdquo; then it does not meet this criteria. If the plans do not specify,
        we assume it has a lock. No glass door meets this criteria, the door must be solid.)</p>

      <p><strong>2. At least one operable/egress window</strong> (if the only window(s) present in
        this room are fixed, the criteria is not met. If all the windows are fixed, but there is a
        door opening to the exterior present, the criteria is met since it provides egress in an
        emergency).</p>

      <p><strong>3. Minimum area of 70 sq.ft.</strong></p>

      <p><strong>4. Closet</strong> (any size).</p>

      <p style="margin-top: 1.25em;"><strong>Instructions:</strong> If the bedroom count is correct,
        please verify. If you are sure that the bedroom count is incorrect, please select incorrect
        and override the count. If you are unsure of the count because of a certain confusing
        feature, please mark unsure and override the value if necessary, or contact the office or
        reviewer for confirmation. Please do not subtract a bedroom if you are unsure, only ADD by
        no more than 1. You may also want to leave a rater note. Note that the ventilation
        calculation is based on bedroom/occupant counts. If you under estimate, you will be setting
        the controller to a runtime LESS than is allowed by ASHRAE. If you over estimate, you will
        only be adding a little more ventilation (7.5cfm per BR), but too little could result in a
        model failure.</p>
    </div>
    <div class="d-flex justify-content-center mt-3">
      <button mat-button color="primary" (click)="dialogRef.close()">Close</button>
    </div>
  `
})
export class BedroomDefinitionDialogComponent {
  constructor(public dialogRef: MatDialogRef<BedroomDefinitionDialogComponent>) { }
}

function ngAfterContentInit() {
  throw new Error('Function not implemented.');
}
